"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/* eslint-disable */

/* prebid.js v7.25.0
Updated: 2023-07-29
Modules: consentManagement, consentManagementUsp, gridBidAdapter, medianetBidAdapter, openxBidAdapter, rubiconBidAdapter, unrulyBidAdapter, pulsepointBidAdapter, sonobiBidAdapter, sovrnBidAdapter, tripleliftBidAdapter, ixBidAdapter */


if (window.pbjs && window.pbjs.libLoaded) try {
  window.pbjs.getConfig("debug") && console.warn("Attempted to load a copy of Prebid.js that clashes with the existing 'pbjs' instance. Load aborted.");
} catch (e) {} else (function () {
  !function () {
    var e,
        n = {
      5706: function _(e, n, t) {
        t.d(n, {
          Pd: function Pd() {
            return d;
          },
          Th: function Th() {
            return c;
          },
          _U: function _U() {
            return s;
          }
        });
        var r = t(5730),
            i = t(4358),
            o = t(265),
            a = t(4614),
            u = "outstream";

        function c(e) {
          var n = this,
              t = e.url,
              c = e.config,
              d = e.id,
              s = e.callback,
              f = e.loaded,
              l = e.adUnitCode,
              g = e.renderNow;
          this.url = t, this.config = c, this.handlers = {}, this.id = d, this.loaded = f, this.cmd = [], this.push = function (e) {
            "function" == typeof e ? n.loaded ? e.call() : n.cmd.push(e) : (0, i.H)("Commands given to Renderer.push must be wrapped in a function");
          }, this.callback = s || function () {
            n.loaded = !0, n.process();
          }, this.render = function () {
            var e = this,
                n = arguments,
                c = function c() {
              e._render ? e._render.apply(e, n) : (0, i.yN)("No render function was provided, please use .setRender on the renderer");
            };

            !function (e) {
              var n = pbjs.adUnits,
                  t = (0, a.sE)(n, function (n) {
                return n.code === e;
              });
              if (!t) return !1;
              var r = (0, o.Z)(t, "renderer"),
                  i = !!(r && r.url && r.render),
                  u = (0, o.Z)(t, "mediaTypes.video.renderer"),
                  c = !!(u && u.url && u.render);
              return !!(i && !0 !== r.backupOnly || c && !0 !== u.backupOnly);
            }(l) ? g ? c() : (this.cmd.unshift(c), (0, r.B)(t, u, this.callback, this.documentContext)) : ((0, i.yN)("External Js not loaded by Renderer since renderer url and callback is already defined on adUnit ".concat(l)), c());
          }.bind(this);
        }

        function d(e) {
          return !(!e || !e.url);
        }

        function s(e, n, t) {
          var r = null;
          e.config && e.config.documentResolver && (r = e.config.documentResolver(n, document, t)), r || (r = document), e.documentContext = r, e.render(n, e.documentContext);
        }

        c.install = function (e) {
          return new c({
            url: e.url,
            config: e.config,
            id: e.id,
            callback: e.callback,
            loaded: e.loaded,
            adUnitCode: e.adUnitCode,
            renderNow: e.renderNow
          });
        }, c.prototype.getConfig = function () {
          return this.config;
        }, c.prototype.setRender = function (e) {
          this._render = e;
        }, c.prototype.setEventHandlers = function (e) {
          this.handlers = e;
        }, c.prototype.handleVideoEvent = function (e) {
          var n = e.id,
              t = e.eventName;
          "function" == typeof this.handlers[t] && this.handlers[t](), (0, i.ji)("Prebid Renderer event for id ".concat(n, " type ").concat(t));
        }, c.prototype.process = function () {
          for (; this.cmd.length > 0;) {
            try {
              this.cmd.shift().call();
            } catch (e) {
              (0, i.H)("Error processing Renderer command: ", e);
            }
          }
        };
      },
      875: function _(e, n, t) {
        t.d(n, {
          f: function f() {
            return a;
          }
        });
        var r = t(265),
            i = {};

        function o(e, n, t) {
          var r = function (e, n) {
            var t = i[e] = i[e] || {
              bidders: {}
            };
            return n ? t.bidders[n] = t.bidders[n] || {} : t;
          }(e, t);

          return r[n] = (r[n] || 0) + 1, r[n];
        }

        var a = {
          incrementRequestsCounter: function incrementRequestsCounter(e) {
            return o(e, "requestsCounter");
          },
          incrementBidderRequestsCounter: function incrementBidderRequestsCounter(e, n) {
            return o(e, "requestsCounter", n);
          },
          incrementBidderWinsCounter: function incrementBidderWinsCounter(e, n) {
            return o(e, "winsCounter", n);
          },
          getRequestsCounter: function getRequestsCounter(e) {
            return (0, r.Z)(i, "".concat(e, ".requestsCounter")) || 0;
          },
          getBidderRequestsCounter: function getBidderRequestsCounter(e, n) {
            return (0, r.Z)(i, "".concat(e, ".bidders.").concat(n, ".requestsCounter")) || 0;
          },
          getBidderWinsCounter: function getBidderWinsCounter(e, n) {
            return (0, r.Z)(i, "".concat(e, ".bidders.").concat(n, ".winsCounter")) || 0;
          }
        };
      },
      3092: function _(e, n, t) {
        t.d(n, {
          ZP: function ZP() {
            return le;
          },
          rp: function rp() {
            return ie;
          },
          uV: function uV() {
            return ue;
          },
          nX: function nX() {
            return oe;
          }
        });
        var r = t(9062),
            i = t(3324),
            o = t(4942),
            a = t(4358),
            u = t(265),
            c = t(1002),
            d = t(3193),
            s = t(4614),
            f = t(4679),
            l = [];

        function g(e, n) {
          return e.labelAll ? {
            labelAll: !0,
            labels: e.labelAll,
            activeLabels: n
          } : {
            labelAll: !1,
            labels: e.labelAny,
            activeLabels: n
          };
        }

        function p() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = e.labels,
              t = void 0 === n ? [] : n,
              r = e.labelAll,
              i = void 0 !== r && r,
              o = e.activeLabels,
              c = void 0 === o ? [] : o,
              d = arguments.length > 1 ? arguments[1] : void 0,
              g = arguments.length > 2 ? arguments[2] : void 0,
              p = v(arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : l);
          (0, a.PO)(d) || (d = g ? {
            banner: {
              sizes: g
            }
          } : {});
          var h = (0, u.Z)(d, "banner.sizes");
          p.shouldFilter && h && ((d = (0, a.I8)(d)).banner.sizes = h.filter(function (e) {
            return p.sizesSupported[e];
          }));
          var m = {
            active: !d.hasOwnProperty(f.Mk) || (0, u.Z)(d, "banner.sizes.length") > 0 && (0 === t.length || !i && (t.some(function (e) {
              return p.labels[e];
            }) || t.some(function (e) {
              return (0, s.q9)(c, e);
            })) || i && t.reduce(function (e, n) {
              return e ? p.labels[n] || (0, s.q9)(c, n) : e;
            }, !0)),
            mediaTypes: d
          };
          return h && h.length !== d.banner.sizes.length && (m.filterResults = {
            before: h,
            after: d.banner.sizes
          }), m;
        }

        function v(e) {
          return e.reduce(function (e, n) {
            if ("object" === (0, c.Z)(n) && "string" == typeof n.mediaQuery && n.mediaQuery.length > 0) {
              var t = !1;

              try {
                t = (0, a.Zy)().matchMedia(n.mediaQuery).matches;
              } catch (e) {
                (0, a.yN)("Unfriendly iFrame blocks sizeConfig from being correctly evaluated"), t = matchMedia(n.mediaQuery).matches;
              }

              t && (Array.isArray(n.sizesSupported) && (e.shouldFilter = !0), ["labels", "sizesSupported"].forEach(function (t) {
                return (n[t] || []).forEach(function (n) {
                  return e[t][n] = !0;
                });
              }));
            } else (0, a.yN)('sizeConfig rule missing required property "mediaQuery"');

            return e;
          }, {
            labels: {},
            sizesSupported: {},
            shouldFilter: !1
          });
        }

        d.vc.getConfig("sizeConfig", function (e) {
          return function (e) {
            l = e;
          }(e.sizeConfig);
        });
        var h = t(59),
            m = t(5339),
            b = t(8928),
            y = t(2797),
            w = t(875),
            C = t(5102),
            A = t(136),
            T = t(2963),
            E = t(1120),
            O = t(5671),
            k = t(3144),
            B = t(8916),
            I = t(2793),
            j = t(8792);

        function S(e) {
          var n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var t,
                r = (0, E.Z)(e);

            if (n) {
              var i = (0, E.Z)(this).constructor;
              t = Reflect.construct(r, arguments, i);
            } else t = r.apply(this, arguments);

            return (0, T.Z)(this, t);
          };
        }

        function U(e, n, t) {
          P(e, n), n.set(e, t);
        }

        function P(e, n) {
          if (n.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
        }

        function _(e, n, t) {
          if (!n.has(e)) throw new TypeError("attempted to get private field on non-instance");
          return t;
        }

        var R = new WeakMap(),
            N = new WeakMap(),
            q = new WeakMap(),
            Z = new WeakMap(),
            x = new WeakSet(),
            D = function () {
          function e() {
            var n, t;
            (0, O.Z)(this, e), P(n = this, t = x), t.add(n), U(this, R, {
              writable: !0,
              value: void 0
            }), U(this, N, {
              writable: !0,
              value: void 0
            }), U(this, q, {
              writable: !0,
              value: void 0
            }), U(this, Z, {
              writable: !0,
              value: void 0
            }), (0, o.Z)(this, "generatedTime", void 0), this.reset();
          }

          return (0, k.Z)(e, [{
            key: "reset",
            value: function value() {
              (0, I.Z)(this, q, (0, j.P)()), (0, I.Z)(this, R, !1), (0, I.Z)(this, N, null), (0, I.Z)(this, Z, !1), this.generatedTime = null;
            }
          }, {
            key: "enable",
            value: function value() {
              (0, I.Z)(this, R, !0);
            }
          }, {
            key: "enabled",
            get: function get() {
              return (0, B.Z)(this, R);
            }
          }, {
            key: "ready",
            get: function get() {
              return (0, B.Z)(this, Z);
            }
          }, {
            key: "promise",
            get: function get() {
              return (0, B.Z)(this, Z) ? j.Z.resolve((0, B.Z)(this, N)) : ((0, B.Z)(this, R) || _(this, x, H).call(this, null), (0, B.Z)(this, q).promise);
            }
          }, {
            key: "setConsentData",
            value: function value(e) {
              var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (0, a.AB)();
              this.generatedTime = n, _(this, x, H).call(this, e);
            }
          }, {
            key: "getConsentData",
            value: function value() {
              return (0, B.Z)(this, N);
            }
          }]), e;
        }();

        function H(e) {
          (0, I.Z)(this, Z, !0), (0, I.Z)(this, N, e), (0, B.Z)(this, q).resolve(e);
        }

        var F = function (e) {
          (0, A.Z)(t, e);
          var n = S(t);

          function t() {
            return (0, O.Z)(this, t), n.apply(this, arguments);
          }

          return (0, k.Z)(t, [{
            key: "getConsentMeta",
            value: function value() {
              var e = this.getConsentData();
              if (e && this.generatedTime) return {
                usp: e,
                generatedAt: this.generatedTime
              };
            }
          }]), t;
        }(D),
            M = function (e) {
          (0, A.Z)(t, e);
          var n = S(t);

          function t() {
            return (0, O.Z)(this, t), n.apply(this, arguments);
          }

          return (0, k.Z)(t, [{
            key: "getConsentMeta",
            value: function value() {
              var e = this.getConsentData();
              if (e && e.vendorData && this.generatedTime) return {
                gdprApplies: e.gdprApplies,
                consentStringSize: (0, a.d8)(e.vendorData.tcString) ? e.vendorData.tcString.length : 0,
                generatedAt: this.generatedTime,
                apiVersion: e.apiVersion
              };
            }
          }]), t;
        }(D),
            z = t(2021),
            W = t(5644),
            K = t(9128),
            L = t(5383);

        function G(e, n) {
          var t = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            n && (r = r.filter(function (n) {
              return Object.getOwnPropertyDescriptor(e, n).enumerable;
            })), t.push.apply(t, r);
          }

          return t;
        }

        function J(e) {
          for (var n = 1; n < arguments.length; n++) {
            var t = null != arguments[n] ? arguments[n] : {};
            n % 2 ? G(Object(t), !0).forEach(function (n) {
              (0, o.Z)(e, n, t[n]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : G(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
            });
          }

          return e;
        }

        var V = "client",
            Q = "server",
            Y = {},
            X = Y.bidderRegistry = {},
            $ = Y.aliasRegistry = {},
            ee = [];
        d.vc.getConfig("s2sConfig", function (e) {
          e && e.s2sConfig && (ee = (0, a.kJ)(e.s2sConfig) ? e.s2sConfig : [e.s2sConfig]);
        });
        var ne = {};
        var te = (0, y.z3)("sync", function (e) {
          var n = e.bidderCode,
              t = e.auctionId,
              r = e.bidderRequestId,
              i = e.adUnits,
              o = e.src,
              c = e.metrics;
          return i.reduce(function (e, i) {
            return e.push(i.bids.filter(function (e) {
              return e.bidder === n;
            }).reduce(function (e, n) {
              var d = null == (n = Object.assign({}, n, (0, a.iG)(i, ["nativeParams", "nativeOrtbRequest", "ortb2Imp", "mediaType", "renderer"]))).mediaTypes ? i.mediaTypes : n.mediaTypes;
              return (0, a.FS)(d) ? n = Object.assign({}, n, {
                mediaTypes: d
              }) : (0, a.H)("mediaTypes is not correctly configured for adunit ".concat(i.code)), e.push(Object.assign({}, n, {
                adUnitCode: i.code,
                transactionId: i.transactionId,
                sizes: (0, u.Z)(d, "banner.sizes") || (0, u.Z)(d, "video.playerSize") || [],
                bidId: n.bid_id || (0, a._d)(),
                bidderRequestId: r,
                auctionId: t,
                src: o,
                metrics: c,
                bidRequestsCount: w.f.getRequestsCounter(i.code),
                bidderRequestsCount: w.f.getBidderRequestsCounter(i.code, n.bidder),
                bidderWinsCount: w.f.getBidderWinsCounter(i.code, n.bidder)
              })), e;
            }, [])), e;
          }, []).reduce(a.xH, []).filter(function (e) {
            return "" !== e;
          });
        }, "getBids");
        var re = (0, y.z3)("sync", function (e, n) {
          var t = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).getS2SBidders;
          if (null == n) return e;
          var r = (void 0 === t ? ue : t)(n);
          return e.filter(function (e) {
            return r.has(e.bidder);
          });
        }, "filterBidsForAdUnit");
        var ie = new M(),
            oe = new F(),
            ae = (0, y.z3)("sync", function (e, n) {
          return function (e, n) {
            return e.reduce(function (e, t) {
              var r = p(g(t, n), t.mediaTypes, t.sizes),
                  i = r.active,
                  o = r.mediaTypes,
                  u = r.filterResults;
              return i ? (u && (0, a.PN)('Size mapping filtered adUnit "'.concat(t.code, '" banner sizes from '), u.before, "to ", u.after), t.mediaTypes = o, t.bids = t.bids.reduce(function (e, r) {
                var i = p(g(r, n), t.mediaTypes),
                    o = i.active,
                    u = i.mediaTypes,
                    c = i.filterResults;
                return o ? (c && ((0, a.PN)('Size mapping filtered adUnit "'.concat(t.code, '" bidder "').concat(r.bidder, '" banner sizes from '), c.before, "to ", c.after), r.mediaTypes = u), e.push(r)) : (0, a.PN)('Size mapping deactivated adUnit "'.concat(t.code, '" bidder "').concat(r.bidder, '"')), e;
              }, []), e.push(t)) : (0, a.PN)('Size mapping disabled adUnit "'.concat(t.code, '"')), e;
            }, []);
          }(e, n);
        }, "setupAdUnitMediaTypes");

        function ue(e) {
          (0, a.kJ)(e) || (e = [e]);
          var n = new Set([null]);
          return e.filter(function (e) {
            return e && e.enabled;
          }).flatMap(function (e) {
            return e.bidders;
          }).forEach(function (e) {
            return n.add(e);
          }), n;
        }

        var ce = (0, y.z3)("sync", function (e, n) {
          var t,
              r = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).getS2SBidders,
              i = (void 0 === r ? ue : r)(n);
          return (0, a.pP)(e).reduce(function (e, n) {
            return e[i.has(n) ? Q : V].push(n), e;
          }, (t = {}, (0, o.Z)(t, V, []), (0, o.Z)(t, Q, []), t));
        }, "partitionBidders");

        function de(e, n) {
          var t = X[e],
              r = (null == t ? void 0 : t.getSpec) && t.getSpec();
          if (r && r[n] && "function" == typeof r[n]) return [r, r[n]];
        }

        function se(e, n, t, r) {
          try {
            (0, a.PN)("Invoking ".concat(e, ".").concat(n));

            for (var i = arguments.length, o = new Array(i > 4 ? i - 4 : 0), u = 4; u < i; u++) {
              o[u - 4] = arguments[u];
            }

            d.vc.runWithBidder(e, r.bind.apply(r, [t].concat(o)));
          } catch (t) {
            (0, a.yN)("Error calling ".concat(n, " of ").concat(e));
          }
        }

        function fe(e, n, t) {
          var i = de(e, n);
          null != i && se.apply(void 0, [e, n].concat((0, r.Z)(i), [t]));
        }

        Y.makeBidRequests = (0, y.z3)("sync", function (e, n, t, r, i) {
          var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {},
              u = arguments.length > 6 ? arguments[6] : void 0;
          u = (0, K.Bf)(u), z.j8(W.FP.BEFORE_REQUEST_BIDS, e), (0, h.Fb)(e), e = ae(e, i);
          var c = ce(e, ee),
              f = c[V],
              l = c[Q];
          d.vc.getConfig("bidderSequence") === d.FD && (f = (0, a.TV)(f));
          var g = (0, C.nH)(),
              p = [],
              v = o.global || {},
              m = o.bidder || {};

          function b(e) {
            var n = Object.freeze((0, a.Ee)({}, v, m[e.bidderCode]));
            return e.ortb2 = n, e.bids.forEach(function (e) {
              return e.ortb2 = n;
            }), e;
          }

          ee.forEach(function (r) {
            if (r && r.enabled) {
              var i = function (e, n) {
                var t = (0, a.I8)(e);
                return t.forEach(function (e) {
                  e.bids = re(e.bids, n).map(function (e) {
                    return e.bid_id = (0, a._d)(), e;
                  });
                }), t.filter(function (e) {
                  return 0 !== e.bids.length;
                });
              }(e, r),
                  o = (0, a.DO)();

              l.forEach(function (e) {
                var c = (0, a._d)(),
                    d = u.fork(),
                    s = b({
                  bidderCode: e,
                  auctionId: t,
                  bidderRequestId: c,
                  uniquePbsTid: o,
                  bids: te({
                    bidderCode: e,
                    auctionId: t,
                    bidderRequestId: c,
                    adUnits: (0, a.I8)(i),
                    src: W.os.YZ,
                    metrics: d
                  }),
                  auctionStart: n,
                  timeout: r.timeout,
                  src: W.os.YZ,
                  refererInfo: g,
                  metrics: d
                });
                0 !== s.bids.length && p.push(s);
              }), i.forEach(function (e) {
                var n = e.bids.filter(function (e) {
                  return (0, s.sE)(p, function (n) {
                    return (0, s.sE)(n.bids, function (n) {
                      return n.bidId === e.bid_id;
                    });
                  });
                });
                e.bids = n;
              }), p.forEach(function (e) {
                void 0 === e.adUnitsS2SCopy && (e.adUnitsS2SCopy = i.filter(function (e) {
                  return e.bids.length > 0;
                }));
              });
            }
          });

          var y = function (e) {
            var n = (0, a.I8)(e);
            return n.forEach(function (e) {
              e.bids = re(e.bids, null);
            }), n.filter(function (e) {
              return 0 !== e.bids.length;
            });
          }(e);

          return f.forEach(function (e) {
            var o = (0, a._d)(),
                c = u.fork(),
                d = b({
              bidderCode: e,
              auctionId: t,
              bidderRequestId: o,
              bids: te({
                bidderCode: e,
                auctionId: t,
                bidderRequestId: o,
                adUnits: (0, a.I8)(y),
                labels: i,
                src: "client",
                metrics: c
              }),
              auctionStart: n,
              timeout: r,
              refererInfo: g,
              metrics: c
            }),
                s = X[e];
            s || (0, a.H)("Trying to make a request for bidder that does not exist: ".concat(e)), s && d.bids && 0 !== d.bids.length && p.push(d);
          }), ie.getConsentData() && p.forEach(function (e) {
            e.gdprConsent = ie.getConsentData();
          }), oe.getConsentData() && p.forEach(function (e) {
            e.uspConsent = oe.getConsentData();
          }), p.forEach(function (e) {
            d.vc.runWithBidder(e.bidderCode, function () {
              var n = d.vc.getConfig("fledgeEnabled");
              e.fledgeEnabled = navigator.runAdAuction && n;
            });
          }), p;
        }, "makeBidRequests"), Y.callBids = function (e, n, t, r, o, u, c) {
          var s = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : {};

          if (n.length) {
            var f = n.reduce(function (e, n) {
              return e[Number(void 0 !== n.src && n.src === W.os.YZ)].push(n), e;
            }, [[], []]),
                l = (0, i.Z)(f, 2),
                g = l[0],
                p = l[1],
                v = [];
            p.forEach(function (e) {
              for (var n = -1, t = 0; t < v.length; ++t) {
                if (e.uniquePbsTid === v[t].uniquePbsTid) {
                  n = t;
                  break;
                }
              }

              n <= -1 && v.push(e);
            });
            var h = 0;
            ee.forEach(function (e) {
              if (e && v[h] && ue(e).has(v[h].bidderCode)) {
                var n = (0, b.O)(u, o ? {
                  request: o.request.bind(null, "s2s"),
                  done: o.done
                } : void 0),
                    i = e.bidders,
                    c = X[e.adapter],
                    d = v[h].uniquePbsTid,
                    f = v[h].adUnitsS2SCopy,
                    l = p.filter(function (e) {
                  return e.uniquePbsTid === d;
                });

                if (c) {
                  var g = {
                    ad_units: f,
                    s2sConfig: e,
                    ortb2Fragments: s
                  };

                  if (g.ad_units.length) {
                    var m = l.map(function (e) {
                      return e.start = (0, a.AB)(), r.bind(e);
                    }),
                        y = (0, a.pP)(g.ad_units).filter(function (e) {
                      return i.includes(e);
                    });
                    (0, a.ji)("CALLING S2S HEADER BIDDERS ==== ".concat(y.length > 0 ? y.join(", ") : 'No bidder specified, using "ortb2Imp" definition(s) only')), l.forEach(function (e) {
                      z.j8(W.FP.BID_REQUESTED, J(J({}, e), {}, {
                        tid: e.auctionId
                      }));
                    }), c.callBids(g, p, t, function () {
                      return m.forEach(function (e) {
                        return e();
                      });
                    }, n);
                  }
                } else (0, a.H)("missing " + e.adapter);

                h++;
              }
            }), g.forEach(function (e) {
              e.start = (0, a.AB)();
              var n = X[e.bidderCode];
              d.vc.runWithBidder(e.bidderCode, function () {
                (0, a.ji)("CALLING BIDDER"), z.j8(W.FP.BID_REQUESTED, e);
              });
              var i = (0, b.O)(u, o ? {
                request: o.request.bind(null, e.bidderCode),
                done: o.done
              } : void 0),
                  s = r.bind(e);

              try {
                d.vc.runWithBidder(e.bidderCode, a.ak.call(n.callBids, n, e, t, s, i, c, d.vc.callbackWithBidder(e.bidderCode)));
              } catch (n) {
                (0, a.H)("".concat(e.bidderCode, " Bid Adapter emitted an uncaught error when parsing their bidRequest"), {
                  e: n,
                  bidRequest: e
                }), s();
              }
            });
          } else (0, a.yN)("callBids executed with no bidRequests.  Were they filtered by labels or sizing?");
        }, Y.videoAdapters = [], Y.registerBidAdapter = function (e, n) {
          var t = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).supportedMediaTypes,
              r = void 0 === t ? [] : t;
          e && n ? "function" == typeof e.callBids ? (X[n] = e, (0, s.q9)(r, "video") && Y.videoAdapters.push(n), (0, s.q9)(r, "native") && h.Sg.push(n)) : (0, a.H)("Bidder adaptor error for bidder code: " + n + "bidder must implement a callBids() function") : (0, a.H)("bidAdapter or bidderCode not specified");
        }, Y.aliasBidAdapter = function (e, n, t) {
          if (void 0 === X[n]) {
            var r = X[e];

            if (void 0 === r) {
              var i = [];
              ee.forEach(function (t) {
                if (t.bidders && t.bidders.length) {
                  var r = t && t.bidders;
                  t && (0, s.q9)(r, n) ? $[n] = e : i.push(e);
                }
              }), i.forEach(function (e) {
                (0, a.H)('bidderCode "' + e + '" is not an existing bidder.', "adapterManager.aliasBidAdapter");
              });
            } else try {
              var o,
                  u = function (e) {
                var n = [];
                return (0, s.q9)(Y.videoAdapters, e) && n.push("video"), (0, s.q9)(h.Sg, e) && n.push("native"), n;
              }(e);

              if (r.constructor.prototype != Object.prototype) (o = new r.constructor()).setBidderCode(n);else {
                var c = r.getSpec(),
                    d = t && t.gvlid,
                    f = t && t.skipPbsAliasing;
                o = (0, m.PZ)(Object.assign({}, c, {
                  code: n,
                  gvlid: d,
                  skipPbsAliasing: f
                })), $[n] = e;
              }
              Y.registerBidAdapter(o, n, {
                supportedMediaTypes: u
              });
            } catch (n) {
              (0, a.H)(e + " bidder does not currently support aliasing.", "adapterManager.aliasBidAdapter");
            }
          } else (0, a.ji)('alias name "' + n + '" has been already specified.');
        }, Y.registerAnalyticsAdapter = function (e) {
          var n = e.adapter,
              t = e.code,
              r = e.gvlid;
          n && t ? "function" == typeof n.enableAnalytics ? (n.code = t, ne[t] = {
            adapter: n,
            gvlid: r
          }) : (0, a.H)('Prebid Error: Analytics adaptor error for analytics "'.concat(t, '"\n        analytics adapter must implement an enableAnalytics() function')) : (0, a.H)("Prebid Error: analyticsAdapter or analyticsCode not specified");
        }, Y.enableAnalytics = function (e) {
          (0, a.kJ)(e) || (e = [e]), (0, a.yi)(e, function (e) {
            var n = ne[e.provider];
            n && n.adapter ? n.adapter.enableAnalytics(e) : (0, a.H)("Prebid Error: no analytics adapter found in registry for '".concat(e.provider, "'."));
          });
        }, Y.getBidAdapter = function (e) {
          return X[e];
        }, Y.getAnalyticsAdapter = function (e) {
          return ne[e];
        }, Y.callTimedOutBidders = function (e, n, t) {
          n = n.map(function (n) {
            return n.params = (0, a.S0)(e, n.adUnitCode, n.bidder), n.timeout = t, n;
          }), n = (0, a.vM)(n, "bidder"), Object.keys(n).forEach(function (e) {
            fe(e, "onTimeout", n[e]);
          });
        }, Y.callBidWonBidder = function (e, n, t) {
          n.params = (0, a.S0)(t, n.adUnitCode, n.bidder), w.f.incrementBidderWinsCounter(n.adUnitCode, n.bidder), fe(e, "onBidWon", n);
        }, Y.callSetTargetingBidder = function (e, n) {
          fe(e, "onSetTargeting", n);
        }, Y.callBidViewableBidder = function (e, n) {
          fe(e, "onBidViewable", n);
        }, Y.callBidderError = function (e, n, t) {
          fe(e, "onBidderError", {
            error: n,
            bidderRequest: t
          });
        }, Y.callDataDeletionRequest = (0, y.z3)("sync", function () {
          for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
            n[t] = arguments[t];
          }

          var o = "onDataDeletionRequest";
          Object.keys(X).filter(function (e) {
            return !$.hasOwnProperty(e);
          }).forEach(function (e) {
            var t = de(e, o);

            if (null != t) {
              var i = L.K.getBidsRequested().filter(function (n) {
                return function (e) {
                  for (var n = new Set(); $.hasOwnProperty(e) && !n.has(e);) {
                    n.add(e), e = $[e];
                  }

                  return e;
                }(n.bidderCode) === e;
              });
              se.apply(void 0, [e, o].concat((0, r.Z)(t), [i], n));
            }
          }), Object.entries(ne).forEach(function (e) {
            var t,
                r = (0, i.Z)(e, 2),
                u = r[0],
                c = r[1],
                d = null == c || null === (t = c.adapter) || void 0 === t ? void 0 : t[o];
            if ("function" == typeof d) try {
              d.apply(c.adapter, n);
            } catch (e) {
              (0, a.H)("error calling ".concat(o, " of ").concat(u), e);
            }
          });
        });
        var le = Y;
      },
      5339: function _(e, n, t) {
        t.d(n, {
          PZ: function PZ() {
            return B;
          },
          dX: function dX() {
            return k;
          }
        });
        var r = t(3324),
            i = t(1002);

        function o(e) {
          var n = e;
          return {
            callBids: function callBids() {},
            setBidderCode: function setBidderCode(e) {
              n = e;
            },
            getBidderCode: function getBidderCode() {
              return n;
            }
          };
        }

        var a = t(3092),
            u = t(3193),
            c = t(9626),
            d = t(1974),
            s = t(59),
            f = t(154),
            l = t(5644),
            g = t(2021),
            p = t(4614),
            v = t(8928),
            h = t(4358),
            m = t(265),
            b = t(4679),
            y = t(2797),
            w = t(5164),
            C = t(5383),
            A = t(5975),
            T = t(9128),
            E = (0, w.eA)("bidderFactory"),
            O = ["cpm", "ttl", "creativeId", "netRevenue", "currency"];

        function k(e) {
          var n = Array.isArray(e.supportedMediaTypes) ? {
            supportedMediaTypes: e.supportedMediaTypes
          } : void 0;

          function t(e) {
            var t = B(e);
            a.ZP.registerBidAdapter(t, e.code, n);
          }

          t(e), Array.isArray(e.aliases) && e.aliases.forEach(function (n) {
            var r,
                i,
                o = n;
            (0, h.PO)(n) && (o = n.code, r = n.gvlid, i = n.skipPbsAliasing), a.ZP.aliasRegistry[o] = e.code, t(Object.assign({}, e, {
              code: o,
              gvlid: r,
              skipPbsAliasing: i
            }));
          });
        }

        function B(e) {
          return Object.assign(new o(e.code), {
            getSpec: function getSpec() {
              return Object.freeze(e);
            },
            registerSyncs: n,
            callBids: function callBids(i, o, d, v, m, b) {
              if (Array.isArray(i.bids)) {
                var y = {},
                    w = [],
                    E = U(i).measureTime("validate", function () {
                  return i.bids.filter(t);
                });

                if (0 !== E.length) {
                  var k = {};
                  E.forEach(function (e) {
                    k[e.bidId] = e, e.adUnitCode || (e.adUnitCode = e.placementCode);
                  }), I(e, E, i, v, b, {
                    onRequest: function onRequest(e) {
                      return g.j8(l.FP.BEFORE_BIDDER_HTTP, i, e);
                    },
                    onResponse: function onResponse(n) {
                      m(e.code), w.push(n);
                    },
                    onFledgeAuctionConfigs: function onFledgeAuctionConfigs(e) {
                      e.forEach(function (e) {
                        var n = k[e.bidId];
                        n && S(n, e);
                      });
                    },
                    onError: function onError(n, t) {
                      m(e.code), a.ZP.callBidderError(e.code, t, i), g.j8(l.FP.BIDDER_ERROR, {
                        error: t,
                        bidderRequest: i
                      }), (0, h.H)("Server call for ".concat(e.code, " failed: ").concat(n, " ").concat(t.status, ". Continuing without bids."));
                    },
                    onBid: function onBid(n) {
                      var t = k[n.requestId];

                      if (t) {
                        if (n.adapterCode = t.bidder, function (e, n) {
                          var t = A.S.get(n, "allowAlternateBidderCodes") || !1,
                              r = A.S.get(n, "allowedAlternateBidderCodes");
                          if (e && n && n !== e && (r = (0, h.kJ)(r) ? r.map(function (e) {
                            return e.trim().toLowerCase();
                          }).filter(function (e) {
                            return !!e;
                          }).filter(h.tT) : r, !t || (0, h.kJ)(r) && "*" !== r[0] && !r.includes(e))) return !0;
                          return !1;
                        }(n.bidderCode, t.bidder)) return (0, h.yN)("".concat(n.bidderCode, " is not a registered partner or known bidder of ").concat(t.bidder, ", hence continuing without bid. If you wish to support this bidder, please mark allowAlternateBidderCodes as true in bidderSettings.")), void o.reject(t.adUnitCode, n, l.Gw.Dg);
                        n.originalCpm = n.cpm, n.originalCurrency = n.currency, n.meta = n.meta || Object.assign({}, n[t.bidder]);
                        var r = Object.assign((0, c.m)(l.Q_.Q, t), n);
                        B(t.adUnitCode, r);
                      } else (0, h.yN)("Bidder ".concat(e.code, " made bid for unknown request ID: ").concat(n.requestId, ". Ignoring.")), o.reject(null, n, l.Gw.Gp);
                    },
                    onCompletion: j
                  });
                } else j();
              }

              function B(e, n) {
                var t = (0, T.Bf)(n.metrics);
                t.checkpoint("addBidResponse"), y[e] = !0, t.measureTime("addBidResponse.validate", function () {
                  return function (e, n) {
                    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                        i = t.index,
                        o = void 0 === i ? C.K.index : i;

                    function a() {
                      var e = Object.keys(n);
                      return O.every(function (t) {
                        return (0, p.q9)(e, t) && !(0, p.q9)([void 0, null], n[t]);
                      });
                    }

                    function u(e) {
                      return "Invalid bid from ".concat(n.bidderCode, ". Ignoring bid: ").concat(e);
                    }

                    if (!e) return (0, h.yN)("No adUnitCode was supplied to addBidResponse."), !1;
                    if (!n) return (0, h.yN)("Some adapter tried to add an undefined bid for ".concat(e, ".")), !1;
                    if (!a()) return (0, h.H)(u("Bidder ".concat(n.bidderCode, " is missing required params. Check http://prebid.org/dev-docs/bidder-adapter-1.html for list of params."))), !1;
                    if ("native" === n.mediaType && !(0, s.r4)(n, {
                      index: o
                    })) return (0, h.H)(u("Native bid missing some required properties.")), !1;
                    if ("video" === n.mediaType && !(0, f.Dn)(n, {
                      index: o
                    })) return (0, h.H)(u("Video bid does not have required vastUrl or renderer property")), !1;
                    if ("banner" === n.mediaType && !function (e, n) {
                      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                          i = t.index,
                          o = void 0 === i ? C.K.index : i;
                      if ((n.width || 0 === parseInt(n.width, 10)) && (n.height || 0 === parseInt(n.height, 10))) return n.width = parseInt(n.width, 10), n.height = parseInt(n.height, 10), !0;
                      var a = o.getBidRequest(n),
                          u = o.getMediaTypes(n),
                          c = a && a.sizes || u && u.banner && u.banner.sizes,
                          d = (0, h.sF)(c);

                      if (1 === d.length) {
                        var s = d[0].split("x"),
                            f = (0, r.Z)(s, 2),
                            l = f[0],
                            g = f[1];
                        return n.width = parseInt(l, 10), n.height = parseInt(g, 10), !0;
                      }

                      return !1;
                    }(e, n, {
                      index: o
                    })) return (0, h.H)(u("Banner bids require a width and height")), !1;
                    return !0;
                  }(e, n);
                }) ? o(e, n) : o.reject(e, n, l.Gw.UI);
              }

              function j() {
                d(), u.vc.runWithBidder(e.code, function () {
                  g.j8(l.FP.BIDDER_DONE, i), n(w, i.gdprConsent, i.uspConsent);
                });
              }
            }
          });

          function n(n, t, r) {
            j(e, n, t, r);
          }

          function t(n) {
            return !!e.isBidRequestValid(n) || ((0, h.yN)("Invalid bid sent to bidder ".concat(e.code, ": ").concat(JSON.stringify(n))), !1);
          }
        }

        var I = (0, y.z3)("sync", function (e, n, t, r, o, a) {
          var u = a.onRequest,
              c = a.onResponse,
              d = a.onFledgeAuctionConfigs,
              s = a.onError,
              f = a.onBid,
              l = a.onCompletion,
              g = U(t);
          l = g.startTiming("total").stopBefore(l);
          var p = g.measureTime("buildRequests", function () {
            return e.buildRequests(n, t);
          });

          if (p && 0 !== p.length) {
            Array.isArray(p) || (p = [p]);
            var v = (0, h.yx)(l, p.length);
            p.forEach(function (n) {
              var t = g.fork();

              function a(e) {
                null != e && (e.metrics = t.fork().renameWith()), f(e);
              }

              var l = o(function (r, i) {
                m();

                try {
                  r = JSON.parse(r);
                } catch (e) {}

                r = {
                  body: r,
                  headers: {
                    get: i.getResponseHeader.bind(i)
                  }
                }, c(r);

                try {
                  r = t.measureTime("interpretResponse", function () {
                    return e.interpretResponse(r, n);
                  });
                } catch (n) {
                  return (0, h.H)("Bidder ".concat(e.code, " failed to interpret the server's response. Continuing without bids"), null, n), void v();
                }

                var o;
                r && (0, h.kJ)(r.fledgeAuctionConfigs) ? (d(r.fledgeAuctionConfigs), o = r.bids) : o = r, o && ((0, h.kJ)(o) ? o.forEach(a) : a(o)), v();
              }),
                  p = o(function (e, n) {
                m(), s(e, n), v();
              });
              u(n);
              var m = t.startTiming("net");

              switch (n.method) {
                case "GET":
                  r("".concat(n.url).concat(function (e) {
                    if (e) return "?".concat("object" === (0, i.Z)(e) ? (0, h.Re)(e) : e);
                    return "";
                  }(n.data)), {
                    success: l,
                    error: p
                  }, void 0, Object.assign({
                    method: "GET",
                    withCredentials: !0
                  }, n.options));
                  break;

                case "POST":
                  r(n.url, {
                    success: l,
                    error: p
                  }, "string" == typeof n.data ? n.data : JSON.stringify(n.data), Object.assign({
                    method: "POST",
                    contentType: "text/plain",
                    withCredentials: !0
                  }, n.options));
                  break;

                default:
                  (0, h.yN)("Skipping invalid request from ".concat(e.code, ". Request type ").concat(n.type, " must be GET or POST")), v();
              }
            });
          } else l();
        }, "processBidderRequests"),
            j = (0, y.z3)("async", function (e, n, t, r) {
          var i = u.vc.getConfig("userSync.aliasSyncEnabled");

          if (e.getUserSyncs && (i || !a.ZP.aliasRegistry[e.code])) {
            var o = u.vc.getConfig("userSync.filterSettings"),
                c = e.getUserSyncs({
              iframeEnabled: !(!o || !o.iframe && !o.all),
              pixelEnabled: !(!o || !o.image && !o.all)
            }, n, t, r);
            c && (Array.isArray(c) || (c = [c]), c.forEach(function (n) {
              d.k_.registerSync(n.type, e.code, n.url);
            }));
          }
        }, "registerSyncs"),
            S = (0, y.z3)("sync", function (e, n) {
          (0, h.PN)("bidderFactory.addComponentAuction", n);
        }, "addComponentAuction");

        function U(e) {
          return (0, T.Bf)(e.metrics).renameWith(function (n) {
            return ["adapter.client.".concat(n), "adapters.client.".concat(e.bidderCode, ".").concat(n)];
          });
        }

        (0, y.v5)("checkAdUnitSetup").before(function (e, n) {
          if (!u.vc.getConfig("adpod.brandCategoryExclusion")) return e.call(this, n);
          n.filter(function (e) {
            return (0, m.Z)(e, "mediaTypes.video.context") === b.Oh;
          }).map(function (e) {
            return e.bids.map(function (e) {
              return e.bidder;
            });
          }).reduce(h.xH, []).filter(h.tT).forEach(function (e) {
            var n = a.ZP.getBidAdapter(e);

            if (n.getSpec().getMappingFileInfo) {
              var t = n.getSpec().getMappingFileInfo(),
                  r = t.refreshInDays ? t.refreshInDays : 1,
                  i = t.localStorageKey ? t.localStorageKey : n.getSpec().code,
                  o = E.getDataFromLocalStorage(i);

              try {
                (!(o = o ? JSON.parse(o) : void 0) || (0, h.AB)() > o.lastUpdated + 24 * r * 60 * 60 * 1e3) && (0, v.h)(t.url, {
                  success: function success(n) {
                    try {
                      n = JSON.parse(n);
                      var t = {
                        lastUpdated: (0, h.AB)(),
                        mapping: n.mapping
                      };
                      E.setDataInLocalStorage(i, JSON.stringify(t));
                    } catch (n) {
                      (0, h.H)("Failed to parse ".concat(e, " bidder translation mapping file"));
                    }
                  },
                  error: function error() {
                    (0, h.H)("Failed to load ".concat(e, " bidder translation file"));
                  }
                });
              } catch (n) {
                (0, h.H)("Failed to parse ".concat(e, " bidder translation mapping file"));
              }
            }
          }), e.call(this, n);
        });
      },
      5730: function _(e, n, t) {
        t.d(n, {
          B: function B() {
            return u;
          }
        });
        var r = t(4614),
            i = t(4358),
            o = new WeakMap(),
            a = ["debugging", "adloox", "admatic", "criteo", "outstream", "adagio", "spotx", "browsi", "brandmetrics", "justtag", "tncId", "akamaidap", "ftrackId", "inskin", "hadron", "medianet", "improvedigital", "aaxBlockmeter"];

        function u(e, n, t, u, c) {
          if (n && e) {
            if ((0, r.q9)(a, n)) {
              u || (u = document);
              var d = l(u, e);
              if (d) return t && "function" == typeof t && (d.loaded ? t() : d.callbacks.push(t)), d.tag;
              var s = o.get(u) || {},
                  f = {
                loaded: !1,
                tag: null,
                callbacks: []
              };
              return s[e] = f, o.set(u, s), t && "function" == typeof t && f.callbacks.push(t), (0, i.yN)("module ".concat(n, " is loading external JavaScript")), function (n, t, r, o) {
                r || (r = document);
                var a = r.createElement("script");
                a.type = "text/javascript", a.async = !0;
                var u = l(r, e);
                u && (u.tag = a);
                a.readyState ? a.onreadystatechange = function () {
                  "loaded" !== a.readyState && "complete" !== a.readyState || (a.onreadystatechange = null, t());
                } : a.onload = function () {
                  t();
                };
                a.src = n, o && (0, i.D9)(a, o);
                return (0, i.jC)(a, r), a;
              }(e, function () {
                f.loaded = !0;

                try {
                  for (var e = 0; e < f.callbacks.length; e++) {
                    f.callbacks[e]();
                  }
                } catch (e) {
                  (0, i.H)("Error executing callback", "adloader.js:loadExternalScript", e);
                }
              }, u, c);
            }

            (0, i.H)("".concat(n, " not whitelisted for loading external JavaScript"));
          } else (0, i.H)("cannot load external script without url and moduleCode");

          function l(e, n) {
            var t = o.get(e);
            return t && t[n] ? t[n] : null;
          }
        }
      },
      8928: function _(e, n, t) {
        t.d(n, {
          O: function O() {
            return c;
          },
          h: function h() {
            return u;
          }
        });
        var r = t(1002),
            i = t(3193),
            o = t(4358),
            a = 4,
            u = c();

        function c() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 3e3,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              t = n.request,
              u = n.done;
          return function (n, c, d) {
            var s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};

            try {
              var f,
                  l = s.method || (d ? "POST" : "GET"),
                  g = document.createElement("a");
              g.href = n;
              var p = "object" === (0, r.Z)(c) && null !== c ? c : {
                success: function success() {
                  (0, o.ji)("xhr success");
                },
                error: function error(e) {
                  (0, o.H)("xhr error", null, e);
                }
              };

              if ("function" == typeof c && (p.success = c), (f = new window.XMLHttpRequest()).onreadystatechange = function () {
                if (f.readyState === a) {
                  "function" == typeof u && u(g.origin);
                  var e = f.status;
                  e >= 200 && e < 300 || 304 === e ? p.success(f.responseText, f) : p.error(f.statusText, f);
                }
              }, i.vc.getConfig("disableAjaxTimeout") || (f.ontimeout = function () {
                (0, o.H)("  xhr timeout after ", f.timeout, "ms");
              }), "GET" === l && d) {
                var v = (0, o.en)(n, s);
                Object.assign(v.search, d), n = (0, o.Q2)(v);
              }

              f.open(l, n, !0), i.vc.getConfig("disableAjaxTimeout") || (f.timeout = e), s.withCredentials && (f.withCredentials = !0), (0, o.yi)(s.customHeaders, function (e, n) {
                f.setRequestHeader(n, e);
              }), s.preflight && f.setRequestHeader("X-Requested-With", "XMLHttpRequest"), f.setRequestHeader("Content-Type", s.contentType || "text/plain"), "function" == typeof t && t(g.origin), "POST" === l && d ? f.send(d) : f.send();
            } catch (e) {
              (0, o.H)("xhr construction", e), "object" === (0, r.Z)(c) && null !== c && c.error(e);
            }
          };
        }
      },
      5383: function _(e, n, t) {
        t.d(n, {
          K: function K() {
            return ee;
          }
        });
        var r = t(4358),
            i = t(1002),
            o = t(3324),
            a = t(265),
            u = t(6463),
            c = t(59),
            d = t(8928),
            s = t(3193),
            f = 15;

        function l(e) {
          var n,
              t,
              r,
              i = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).index,
              o = void 0 === i ? ee.index : i,
              a = e.vastXml ? e.vastXml : (n = e.vastUrl, t = e.vastImpUrl, r = t ? "<![CDATA[".concat(t, "]]>") : "", '<VAST version="3.0">\n    <Ad>\n      <Wrapper>\n        <AdSystem>prebid.org wrapper</AdSystem>\n        <VASTAdTagURI><![CDATA['.concat(n, "]]></VASTAdTagURI>\n        <Impression>").concat(r, "</Impression>\n        <Creatives></Creatives>\n      </Wrapper>\n    </Ad>\n  </VAST>")),
              u = o.getAuction(e),
              c = {
            type: "xml",
            value: a,
            ttlseconds: Number(e.ttl) + f
          };
          return s.vc.getConfig("cache.vasttrack") && (c.bidder = e.bidder, c.bidid = e.requestId, c.aid = e.auctionId), null != u && (c.timestamp = u.getAuctionStart()), "string" == typeof e.customCacheKey && "" !== e.customCacheKey && (c.key = e.customCacheKey), c;
        }

        function g(e, n) {
          var t = {
            puts: e.map(l)
          };
          (0, d.h)(s.vc.getConfig("cache.url"), function (e) {
            return {
              success: function success(n) {
                var t;

                try {
                  t = JSON.parse(n).responses;
                } catch (n) {
                  return void e(n, []);
                }

                t ? e(null, t) : e(new Error("The cache server didn't respond with a responses property."), []);
              },
              error: function error(n, t) {
                e(new Error("Error storing video ad in the cache: ".concat(n, ": ").concat(JSON.stringify(t))), []);
              }
            };
          }(n), JSON.stringify(t), {
            contentType: "text/plain",
            withCredentials: !0
          });
        }

        var p = t(5706),
            v = t(1974),
            h = t(2797),
            m = t(4614),
            b = t(154),
            y = t(4679),
            w = t(5975),
            C = t(2021),
            A = t(3092),
            T = t(5644),
            E = t(8792),
            O = t(9128),
            k = t(9626),
            B = v.k_.syncUsers,
            I = "started",
            j = "inProgress",
            S = "completed";
        C.on(T.FP.BID_ADJUSTMENT, function (e) {
          !function (e) {
            var n = e.bidderCode,
                t = e.cpm,
                i = w.S.get(n || null, "bidCpmAdjustment");
            if (i && "function" == typeof i) try {
              t = i(e.cpm, Object.assign({}, e));
            } catch (e) {
              (0, r.H)("Error during bid adjustment", "bidmanager.js", e);
            }
            t >= 0 && (e.cpm = t);
          }(e);
        });
        var U = 4,
            P = {},
            _ = {},
            R = [];

        function N(e) {
          var n = e.adUnits,
              t = e.adUnitCodes,
              c = e.callback,
              d = e.cbTimeout,
              f = e.labels,
              l = e.auctionId,
              g = e.ortb2Fragments,
              v = e.metrics;
          v = (0, O.Bf)(v);
          var h,
              y,
              w,
              N,
              D = n,
              F = f,
              M = t,
              z = l || (0, r.DO)(),
              W = d,
              G = new Set(),
              J = [],
              V = c,
              Q = [],
              Y = [],
              $ = [],
              ne = [];

          function te() {
            return {
              auctionId: z,
              timestamp: h,
              auctionEnd: y,
              auctionStatus: N,
              adUnits: D,
              adUnitCodes: M,
              labels: F,
              bidderRequests: Q,
              noBids: $,
              bidsReceived: Y,
              bidsRejected: J,
              winningBids: ne,
              timeout: W,
              metrics: v
            };
          }

          function re(e, t) {
            if (t && clearTimeout(w), void 0 === y) {
              var i = [];
              e && ((0, r.ji)("Auction ".concat(z, " timedOut")), o = G, (i = Q.map(function (e) {
                return (e.bids || []).filter(function (e) {
                  return !o.has(e.bidder);
                });
              }).reduce(r.xH, [])).length && C.j8(T.FP.BID_TIMEOUT, i)), N = S, y = Date.now(), v.checkpoint("auctionEnd"), v.timeBetween("requestBids", "auctionEnd", "requestBids.total"), v.timeBetween("callBids", "auctionEnd", "requestBids.callBids"), C.j8(T.FP.AUCTION_END, te()), x(D, function () {
                try {
                  if (null != V) {
                    var t = M,
                        o = Y.filter(r.ak.call(r.IK, this, t)).reduce(X, {});
                    V.apply(pbjs, [o, e, z]), V = null;
                  }
                } catch (e) {
                  (0, r.H)("Error executing bidsBackHandler", null, e);
                } finally {
                  i.length && A.ZP.callTimedOutBidders(n, i, W);
                  var a = s.vc.getConfig("userSync") || {};
                  a.enableOverride || B(a.syncDelay);
                }
              });
            }

            var o;
          }

          function ie() {
            s.vc.resetBidder(), (0, r.PN)("Bids Received for Auction with id: ".concat(z), Y), N = S, re(!1, !0);
          }

          function oe(e) {
            G.add(e);
          }

          function ae(e) {
            var n = this;
            e.forEach(function (e) {
              var n;
              n = e, Q = Q.concat(n);
            });
            var t = {},
                c = {
              bidRequests: e,
              run: function run() {
                var c, l;
                c = re.bind(null, !0), l = setTimeout(c, W), w = l, N = j, C.j8(T.FP.AUCTION_INIT, te());

                var v = function (e, n) {
                  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                      c = t.index,
                      d = void 0 === c ? ee.index : c,
                      f = 0,
                      l = !1,
                      g = new Set(),
                      v = {},
                      h = {};

                  function y(e, n) {
                    null == h[e] && (h[e] = E.Z.resolve()), h[e] = h[e].then(function () {
                      return E.Z.resolve(n).catch(function () {});
                    });
                  }

                  function w(e, t) {
                    var r = e.timeout;
                    (null == r || r > n.getTimeout()) && (r = n.getTimeout());
                    var i = n.getAuctionStart() + r - Date.now(),
                        o = h[e.bidderRequestId],
                        a = h[""];
                    (null != o || null != a) && i > 0 ? E.Z.race([E.Z.timeout(i), E.Z.resolve(a).then(function () {
                      return o;
                    })]).then(t) : t();
                  }

                  function A() {
                    f--, l && 0 === f && e();
                  }

                  function O(e, n, t) {
                    return v[n.requestId] = !0, function (e, n) {
                      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                          i = t.index,
                          o = void 0 === i ? ee.index : i,
                          a = o.getBidderRequest(e),
                          u = o.getAdUnit(e),
                          c = a && a.start || e.requestTimestamp;
                      Object.assign(e, {
                        responseTimestamp: e.responseTimestamp || (0, r.AB)(),
                        requestTimestamp: e.requestTimestamp || c,
                        cpm: e.cpm || parseFloat(e.cpm) || 0,
                        bidder: e.bidder || e.bidderCode,
                        adUnitCode: n
                      }), null != (null == u ? void 0 : u.ttlBuffer) && (e.ttlBuffer = u.ttlBuffer);
                      e.timeToRespond = e.responseTimestamp - e.requestTimestamp;
                    }(n, e), f++, t(A);
                  }

                  function B(e, t) {
                    O(e, t, function (e) {
                      var o = function (e) {
                        var n,
                            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                            r = t.index,
                            o = void 0 === r ? ee.index : r;
                        C.j8(T.FP.BID_ADJUSTMENT, e);
                        var a = (null === (n = o.getBidRequest(e)) || void 0 === n ? void 0 : n.renderer) || o.getAdUnit(e).renderer,
                            c = e.mediaType,
                            d = o.getMediaTypes(e),
                            f = d && d[c],
                            l = f && f.renderer,
                            g = null;
                        l && l.url && l.render && (!0 !== l.backupOnly || !e.renderer) ? g = l : a && a.url && a.render && (!0 !== a.backupOnly || !e.renderer) && (g = a);
                        g && (e.renderer = p.Th.install({
                          url: g.url,
                          config: g.options
                        }), e.renderer.setRender(g.render));
                        var v = L(e.mediaType, d, s.vc.getConfig("mediaTypePriceGranularity")),
                            h = (0, u.D)(e.cpm, "object" === (0, i.Z)(v) ? v : s.vc.getConfig("customPriceBucket"), s.vc.getConfig("currency.granularityMultiplier"));
                        return e.pbLg = h.low, e.pbMg = h.med, e.pbHg = h.high, e.pbAg = h.auto, e.pbDg = h.dense, e.pbCg = h.custom, e;
                      }(t);

                      "video" === o.mediaType ? function (e, n, t) {
                        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                            o = i.index,
                            u = void 0 === o ? ee.index : o,
                            c = !0,
                            d = (0, a.Z)(u.getMediaTypes({
                          requestId: n.originalRequestId || n.requestId,
                          transactionId: n.transactionId
                        }), "video"),
                            f = d && (0, a.Z)(d, "context"),
                            l = d && (0, a.Z)(d, "useCacheKey");
                        s.vc.getConfig("cache.url") && (l || f !== b.gZ) && (!n.videoCacheKey || s.vc.getConfig("cache.ignoreBidderCacheKey") ? (c = !1, K(e, n, t, d)) : n.vastUrl || ((0, r.H)("videoCacheKey specified but not required vastUrl for video bid"), c = !1));
                        c && (H(e, n), t());
                      }(n, o, e) : (H(n, o), e());
                    });
                  }

                  function I(e, t, i) {
                    return O(e, t, function (e) {
                      var a,
                          u = (0, k.m)(T.Q_.H, null === (a = t.getIdentifiers) || void 0 === a ? void 0 : a.call(t));
                      return Object.assign(u, Object.fromEntries(Object.entries(t).filter(function (e) {
                        var n = (0, o.Z)(e, 1)[0];
                        return !u.hasOwnProperty(n) && !["ad", "adUrl", "vastXml", "vastUrl", "native"].includes(n);
                      }))), u.status = T.UE.G9, u.cpm = 0, t.rejectionReason = i, (0, r.yN)("Bid from ".concat(t.bidder || "unknown bidder", " was rejected: ").concat(i), t), C.j8(T.FP.BID_REJECTED, t), n.addBidRejected(t), e(), u;
                    });
                  }

                  function j() {
                    var t = this,
                        i = n.getBidRequests(),
                        o = s.vc.getConfig("auctionOptions");

                    if (g.add(t), o && !(0, r.xb)(o)) {
                      var a = o.secondaryBidders;
                      a && !i.every(function (e) {
                        return (0, m.q9)(a, e.bidderCode);
                      }) && (i = i.filter(function (e) {
                        return !(0, m.q9)(a, e.bidderCode);
                      }));
                    }

                    l = i.every(function (e) {
                      return g.has(e);
                    }), t.bids.forEach(function (e) {
                      v[e.bidId] || (n.addNoBid(e), C.j8(T.FP.NO_BID, e));
                    }), l && 0 === f && e();
                  }

                  return {
                    addBidResponse: function () {
                      function e(e, n) {
                        var t,
                            r = d.getBidderRequest(n);
                        y(r && r.bidderRequestId || "", q.call({
                          dispatch: B
                        }, e, n, function (r) {
                          return null == t && (t = I(e, n, r)), t;
                        }));
                      }

                      return e.reject = I, e;
                    }(),
                    adapterDone: function adapterDone() {
                      w(this, j.bind(this));
                    }
                  };
                }(ie, n);

                A.ZP.callBids(D, e, v.addBidResponse, v.adapterDone, {
                  request: function request(e, n) {
                    f(P, n), f(t, e), _[e] || (_[e] = {
                      SRA: !0,
                      origin: n
                    }), t[e] > 1 && (_[e].SRA = !1);
                  },
                  done: function done(e) {
                    P[e]--, R[0] && d(R[0]) && R.shift();
                  }
                }, W, oe, g);
              }
            };

            function d(e) {
              var n = !0,
                  t = s.vc.getConfig("maxRequestsPerOrigin") || U;
              return e.bidRequests.some(function (e) {
                var r = 1,
                    i = void 0 !== e.src && e.src === T.os.YZ ? "s2s" : e.bidderCode;
                return _[i] && (!1 === _[i].SRA && (r = Math.min(e.bids.length, t)), P[_[i].origin] + r > t && (n = !1)), !n;
              }), n && e.run(), n;
            }

            function f(e, n) {
              void 0 === e[n] ? e[n] = 1 : e[n]++;
            }

            d(c) || ((0, r.yN)("queueing auction due to limited endpoint capacity"), R.push(c));
          }

          return {
            addBidReceived: function addBidReceived(e) {
              Y = Y.concat(e);
            },
            addBidRejected: function addBidRejected(e) {
              J = J.concat(e);
            },
            addNoBid: function addNoBid(e) {
              $ = $.concat(e);
            },
            executeCallback: re,
            callBids: function callBids() {
              N = I, h = Date.now();
              var e = v.measureTime("requestBids.makeRequests", function () {
                return A.ZP.makeBidRequests(D, h, z, W, F, g, v);
              });
              (0, r.PN)("Bids Requested for Auction with id: ".concat(z), e), v.checkpoint("callBids"), e.length < 1 ? ((0, r.yN)("No valid bid requests returned for auction"), ie()) : Z.call({
                dispatch: ae,
                context: this
              }, e);
            },
            addWinningBid: function addWinningBid(e) {
              ne = ne.concat(e), A.ZP.callBidWonBidder(e.adapterCode || e.bidder, e, n);
            },
            setBidTargeting: function setBidTargeting(e) {
              A.ZP.callSetTargetingBidder(e.adapterCode || e.bidder, e);
            },
            getWinningBids: function getWinningBids() {
              return ne;
            },
            getAuctionStart: function getAuctionStart() {
              return h;
            },
            getTimeout: function getTimeout() {
              return W;
            },
            getAuctionId: function getAuctionId() {
              return z;
            },
            getAuctionStatus: function getAuctionStatus() {
              return N;
            },
            getAdUnits: function getAdUnits() {
              return D;
            },
            getAdUnitCodes: function getAdUnitCodes() {
              return M;
            },
            getBidRequests: function getBidRequests() {
              return Q;
            },
            getBidsReceived: function getBidsReceived() {
              return Y;
            },
            getNoBids: function getNoBids() {
              return $;
            },
            getFPD: function getFPD() {
              return g;
            },
            getMetrics: function getMetrics() {
              return v;
            }
          };
        }

        var q = (0, h.z3)("sync", function (e, n, t) {
          this.dispatch.call(null, e, n);
        }, "addBidResponse"),
            Z = (0, h.z3)("sync", function (e) {
          this.dispatch.call(this.context, e);
        }, "addBidderRequests"),
            x = (0, h.z3)("async", function (e, n) {
          n && n();
        }, "bidsBackCallback");

        function D(e, n) {
          n.timeToRespond > e.getTimeout() + s.vc.getConfig("timeoutBuffer") && e.executeCallback(!0);
        }

        function H(e, n) {
          !function (e) {
            var n,
                t = !0 === w.S.get(e.bidderCode, "allowZeroCpmBids") ? e.cpm >= 0 : e.cpm > 0;
            e.bidderCode && (t || e.dealId) && (n = function (e, n) {
              var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                  r = t.index,
                  i = void 0 === r ? ee.index : r;
              if (!n) return {};
              var o = i.getBidRequest(n),
                  a = {},
                  u = Q(n.mediaType, e);
              Y(a, u, n, o), e && w.S.getOwn(e, T.k2.xn) && (Y(a, w.S.ownSettingsFor(e), n, o), n.sendStandardTargeting = w.S.get(e, "sendStandardTargeting"));
              n.native && (a = Object.assign({}, a, (0, c.Ur)(n)));
              return a;
            }(e.bidderCode, e));
            e.adserverTargeting = Object.assign(e.adserverTargeting || {}, n);
          }(n), (0, O.Bf)(n.metrics).timeSince("addBidResponse", "addBidResponse.total"), C.j8(T.FP.BID_RESPONSE, n), e.addBidReceived(n), D(e, n);
        }

        var F,
            M,
            z = function z(e) {
          g(e.map(function (e) {
            return e.bidResponse;
          }), function (n, t) {
            t.forEach(function (t, i) {
              var o,
                  a = e[i],
                  u = a.auctionInstance,
                  c = a.bidResponse,
                  d = a.afterBidAdded;
              n ? ((0, r.yN)("Failed to save to the video cache: ".concat(n, ". Video bid must be discarded.")), D(u, c)) : "" === t.uuid ? ((0, r.yN)("Supplied video cache key was already in use by Prebid Cache; caching attempt was rejected. Video bid must be discarded."), D(u, c)) : (c.videoCacheKey = t.uuid, c.vastUrl || (c.vastUrl = (o = c.videoCacheKey, "".concat(s.vc.getConfig("cache.url"), "?uuid=").concat(o))), H(u, c), d());
            });
          });
        };

        s.vc.getConfig("cache", function (e) {
          F = "number" == typeof e.cache.batchSize && e.cache.batchSize > 0 ? e.cache.batchSize : 1, M = "number" == typeof e.cache.batchTimeout && e.cache.batchTimeout > 0 ? e.cache.batchTimeout : 0;
        });

        var W = function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : setTimeout,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : z,
              t = [[]],
              r = !1,
              i = function i(e) {
            return e();
          };

          return function (o, a, u) {
            var c = M > 0 ? e : i;
            t[t.length - 1].length >= F && t.push([]), t[t.length - 1].push({
              auctionInstance: o,
              bidResponse: a,
              afterBidAdded: u
            }), r || (r = !0, c(function () {
              t.forEach(n), t = [[]], r = !1;
            }, M));
          };
        }(),
            K = (0, h.z3)("async", function (e, n, t, r) {
          W(e, n, t);
        }, "callPrebidCache");

        function L(e, n, t) {
          if (e && t) {
            if (e === y.pX) {
              var r = (0, a.Z)(n, "".concat(y.pX, ".context"), "instream");
              if (t["".concat(y.pX, "-").concat(r)]) return t["".concat(y.pX, "-").concat(r)];
            }

            return t[e];
          }
        }

        var G = function G(e) {
          return function (n) {
            var t = e || function (e) {
              var n = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).index,
                  t = void 0 === n ? ee.index : n,
                  r = L(e.mediaType, t.getMediaTypes(e), s.vc.getConfig("mediaTypePriceGranularity"));
              return "string" == typeof e.mediaType && r ? "string" == typeof r ? r : "custom" : s.vc.getConfig("priceGranularity");
            }(n);

            return t === T.Ql.B7 ? n.pbAg : t === T.Ql.uN ? n.pbDg : t === T.Ql.yE ? n.pbLg : t === T.Ql.M2 ? n.pbMg : t === T.Ql.lj ? n.pbHg : t === T.Ql.qN ? n.pbCg : void 0;
          };
        },
            J = function J() {
          return function (e) {
            return e.meta && e.meta.advertiserDomains && e.meta.advertiserDomains.length > 0 ? e.meta.advertiserDomains[0] : "";
          };
        };

        function V(e, n) {
          return {
            key: e,
            val: "function" == typeof n ? function (e, t) {
              return n(e, t);
            } : function (e) {
              return (0, r.NA)(e, n);
            }
          };
        }

        function Q(e, n) {
          var t = T.TD,
              i = Object.assign({}, w.S.settingsFor(null));

          if (i[T.k2.xn] || (i[T.k2.xn] = function () {
            var e = T.TD;
            return [V(e.BIDDER, "bidderCode"), V(e.AD_ID, "adId"), V(e.PRICE_BUCKET, G()), V(e.SIZE, "size"), V(e.DEAL, "dealId"), V(e.SOURCE, "source"), V(e.FORMAT, "mediaType"), V(e.ADOMAIN, J())];
          }()), "video" === e) {
            var o = i[T.k2.xn].slice();

            if (i[T.k2.xn] = o, [t.UUID, t.CACHE_ID].forEach(function (e) {
              void 0 === (0, m.sE)(o, function (n) {
                return n.key === e;
              }) && o.push(V(e, "videoCacheKey"));
            }), s.vc.getConfig("cache.url") && (!n || !1 !== w.S.get(n, "sendStandardTargeting"))) {
              var u = (0, r.en)(s.vc.getConfig("cache.url"));
              void 0 === (0, m.sE)(o, function (e) {
                return e.key === t.CACHE_HOST;
              }) && o.push(V(t.CACHE_HOST, function (e) {
                return (0, a.Z)(e, "adserverTargeting.".concat(t.CACHE_HOST)) ? e.adserverTargeting[t.CACHE_HOST] : u.hostname;
              }));
            }
          }

          return i;
        }

        function Y(e, n, t, i) {
          var o = n[T.k2.xn];
          return t.size = t.getSize(), (0, r.yi)(o, function (o) {
            var a = o.key,
                u = o.val;
            if (e[a] && (0, r.yN)("The key: " + a + " is being overwritten"), (0, r.LQ)(u)) try {
              u = u(t, i);
            } catch (e) {
              (0, r.H)("bidmanager", "ERROR", e);
            }
            (void 0 === n.suppressEmptyKeys || !0 !== n.suppressEmptyKeys) && a !== T.TD.DEAL || !(0, r.jH)(u) && null != u ? e[a] = u : (0, r.PN)("suppressing empty key '" + a + "' from adserver targeting");
          }), e;
        }

        function X(e, n) {
          return e[n.adUnitCode] || (e[n.adUnitCode] = {
            bids: []
          }), e[n.adUnitCode].bids.push(n), e;
        }

        function $(e) {
          Object.assign(this, {
            getAuction: function getAuction(n) {
              var t = n.auctionId;
              if (null != t) return e().find(function (e) {
                return e.getAuctionId() === t;
              });
            },
            getAdUnit: function getAdUnit(n) {
              var t = n.transactionId;
              if (null != t) return e().flatMap(function (e) {
                return e.getAdUnits();
              }).find(function (e) {
                return e.transactionId === t;
              });
            },
            getMediaTypes: function getMediaTypes(e) {
              var n = e.transactionId,
                  t = e.requestId;

              if (null != t) {
                var r = this.getBidRequest({
                  requestId: t
                });
                if (null != r && (null == n || r.transactionId === n)) return r.mediaTypes;
              } else if (null != n) {
                var i = this.getAdUnit({
                  transactionId: n
                });
                if (null != i) return i.mediaTypes;
              }
            },
            getBidderRequest: function getBidderRequest(n) {
              var t = n.requestId,
                  r = n.bidderRequestId;

              if (null != t || null != r) {
                var i = e().flatMap(function (e) {
                  return e.getBidRequests();
                });
                return null != r && (i = i.filter(function (e) {
                  return e.bidderRequestId === r;
                })), null == t ? i[0] : i.find(function (e) {
                  return e.bids && null != e.bids.find(function (e) {
                    return e.bidId === t;
                  });
                });
              }
            },
            getBidRequest: function getBidRequest(n) {
              var t = n.requestId;
              if (null != t) return e().flatMap(function (e) {
                return e.getBidRequests();
              }).flatMap(function (e) {
                return e.bids;
              }).find(function (e) {
                return e && e.bidId === t;
              });
            }
          });
        }

        var ee = function () {
          var e = [],
              n = {};
          return n.addWinningBid = function (n) {
            var t = (0, O.Bf)(n.metrics);
            t.checkpoint("bidWon"), t.timeBetween("auctionEnd", "bidWon", "render.pending"), t.timeBetween("requestBids", "bidWon", "render.e2e");
            var i = (0, m.sE)(e, function (e) {
              return e.getAuctionId() === n.auctionId;
            });
            i ? (n.status = T.UE.fe, i.addWinningBid(n)) : (0, r.yN)("Auction not found when adding winning bid");
          }, n.getAllWinningBids = function () {
            return e.map(function (e) {
              return e.getWinningBids();
            }).reduce(r.xH, []);
          }, n.getBidsRequested = function () {
            return e.map(function (e) {
              return e.getBidRequests();
            }).reduce(r.xH, []);
          }, n.getNoBids = function () {
            return e.map(function (e) {
              return e.getNoBids();
            }).reduce(r.xH, []);
          }, n.getBidsReceived = function () {
            return e.map(function (e) {
              if (e.getAuctionStatus() === S) return e.getBidsReceived();
            }).reduce(r.xH, []).filter(function (e) {
              return e;
            });
          }, n.getAllBidsForAdUnitCode = function (n) {
            return e.map(function (e) {
              return e.getBidsReceived();
            }).reduce(r.xH, []).filter(function (e) {
              return e && e.adUnitCode === n;
            });
          }, n.getAdUnits = function () {
            return e.map(function (e) {
              return e.getAdUnits();
            }).reduce(r.xH, []);
          }, n.getAdUnitCodes = function () {
            return e.map(function (e) {
              return e.getAdUnitCodes();
            }).reduce(r.xH, []).filter(r.tT);
          }, n.createAuction = function (n) {
            var t = N(n);
            return function (n) {
              e.push(n);
            }(t), t;
          }, n.findBidByAdId = function (n) {
            return (0, m.sE)(e.map(function (e) {
              return e.getBidsReceived();
            }).reduce(r.xH, []), function (e) {
              return e.adId === n;
            });
          }, n.getStandardBidderAdServerTargeting = function () {
            return Q()[T.k2.xn];
          }, n.setStatusForBids = function (t, r) {
            var i = n.findBidByAdId(t);

            if (i && (i.status = r), i && r === T.UE.CK) {
              var o = (0, m.sE)(e, function (e) {
                return e.getAuctionId() === i.auctionId;
              });
              o && o.setBidTargeting(i);
            }
          }, n.getLastAuctionId = function () {
            return e.length && e[e.length - 1].getAuctionId();
          }, n.clearAllAuctions = function () {
            e.length = 0;
          }, n.index = new $(function () {
            return e;
          }), n;
        }();
      },
      5975: function _(e, n, t) {
        t.d(n, {
          S: function S() {
            return g;
          }
        });
        var r = t(5671),
            i = t(3144),
            o = t(265),
            a = t(4358),
            u = t(8640),
            c = t(5644);

        function d(e, n) {
          !function (e, n) {
            if (n.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }(e, n), n.add(e);
        }

        function s(e, n, t) {
          if (!n.has(e)) throw new TypeError("attempted to get private field on non-instance");
          return t;
        }

        var f = new WeakSet();

        function l(e) {
          return null == e ? this.defaultScope : e;
        }

        var g = new (function () {
          function e(n, t) {
            (0, r.Z)(this, e), d(this, f), this.getSettings = n, this.defaultScope = t;
          }

          return (0, i.Z)(e, [{
            key: "get",
            value: function value(e, n) {
              var t = this.getOwn(e, n);
              return void 0 === t && (t = this.getOwn(null, n)), t;
            }
          }, {
            key: "getOwn",
            value: function value(e, n) {
              return e = s(this, f, l).call(this, e), (0, o.Z)(this.getSettings(), "".concat(e, ".").concat(n));
            }
          }, {
            key: "getScopes",
            value: function value() {
              var e = this;
              return Object.keys(this.getSettings()).filter(function (n) {
                return n !== e.defaultScope;
              });
            }
          }, {
            key: "settingsFor",
            value: function value(e) {
              return (0, a.Ee)({}, this.ownSettingsFor(null), this.ownSettingsFor(e));
            }
          }, {
            key: "ownSettingsFor",
            value: function value(e) {
              return e = s(this, f, l).call(this, e), this.getSettings()[e] || {};
            }
          }]), e;
        }())(function () {
          return (0, u.R)().bidderSettings || {};
        }, c.k2.zF);
      },
      9626: function _(e, n, t) {
        t.d(n, {
          m: function m() {
            return o;
          }
        });
        var r = t(4358);

        function i(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              t = n.src,
              i = void 0 === t ? "client" : t,
              o = n.bidder,
              a = void 0 === o ? "" : o,
              u = n.bidId,
              c = n.transactionId,
              d = n.auctionId,
              s = i,
              f = e || 0;
          this.bidderCode = a, this.width = 0, this.height = 0, this.statusMessage = function () {
            switch (f) {
              case 0:
                return "Pending";

              case 1:
                return "Bid available";

              case 2:
                return "Bid returned empty or error response";

              case 3:
                return "Bid timed out";
            }
          }(), this.adId = (0, r._d)(), this.requestId = u, this.transactionId = c, this.auctionId = d, this.mediaType = "banner", this.source = s, this.getStatusCode = function () {
            return f;
          }, this.getSize = function () {
            return this.width + "x" + this.height;
          }, this.getIdentifiers = function () {
            return {
              src: this.source,
              bidder: this.bidderCode,
              bidId: this.requestId,
              transactionId: this.transactionId,
              auctionId: this.auctionId
            };
          };
        }

        function o(e, n) {
          return new i(e, n);
        }
      },
      3193: function _(e, n, t) {
        t.d(n, {
          FD: function FD() {
            return g;
          },
          vc: function vc() {
            return m;
          }
        });
        var r = t(4942),
            i = t(1002),
            o = t(3324),
            a = t(6463),
            u = t(4614),
            c = t(4358),
            d = t(265),
            s = t(5644);

        function f(e, n) {
          var t = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            n && (r = r.filter(function (n) {
              return Object.getOwnPropertyDescriptor(e, n).enumerable;
            })), t.push.apply(t, r);
          }

          return t;
        }

        var l = "TRUE" === (0, c.rD)(s.f).toUpperCase(),
            g = "random",
            p = {};
        p[g] = !0, p.fixed = !0;
        var v = g,
            h = {
          LOW: "low",
          MEDIUM: "medium",
          HIGH: "high",
          AUTO: "auto",
          DENSE: "dense",
          CUSTOM: "custom"
        };

        var m = function () {
          var e,
              n,
              t,
              s = [],
              g = null;

          function m() {
            e = {};
            var r = {
              _debug: l,

              get debug() {
                return this._debug;
              },

              set debug(e) {
                this._debug = e;
              },

              _bidderTimeout: 3e3,

              get bidderTimeout() {
                return this._bidderTimeout;
              },

              set bidderTimeout(e) {
                this._bidderTimeout = e;
              },

              _publisherDomain: null,

              get publisherDomain() {
                return this._publisherDomain;
              },

              set publisherDomain(e) {
                (0, c.yN)("publisherDomain is deprecated and has no effect since v7 - use pageUrl instead"), this._publisherDomain = e;
              },

              _priceGranularity: h.MEDIUM,

              set priceGranularity(e) {
                o(e) && ("string" == typeof e ? this._priceGranularity = i(e) ? e : h.MEDIUM : (0, c.PO)(e) && (this._customPriceBucket = e, this._priceGranularity = h.CUSTOM, (0, c.ji)("Using custom price granularity")));
              },

              get priceGranularity() {
                return this._priceGranularity;
              },

              _customPriceBucket: {},

              get customPriceBucket() {
                return this._customPriceBucket;
              },

              _mediaTypePriceGranularity: {},

              get mediaTypePriceGranularity() {
                return this._mediaTypePriceGranularity;
              },

              set mediaTypePriceGranularity(e) {
                var n = this;
                this._mediaTypePriceGranularity = Object.keys(e).reduce(function (t, r) {
                  return o(e[r]) ? "string" == typeof e ? t[r] = i(e[r]) ? e[r] : n._priceGranularity : (0, c.PO)(e) && (t[r] = e[r], (0, c.ji)("Using custom price granularity for ".concat(r))) : (0, c.yN)("Invalid price granularity for media type: ".concat(r)), t;
                }, {});
              },

              _sendAllBids: true,

              get enableSendAllBids() {
                return this._sendAllBids;
              },

              set enableSendAllBids(e) {
                this._sendAllBids = e;
              },

              _useBidCache: false,

              get useBidCache() {
                return this._useBidCache;
              },

              set useBidCache(e) {
                this._useBidCache = e;
              },

              _deviceAccess: true,

              get deviceAccess() {
                return this._deviceAccess;
              },

              set deviceAccess(e) {
                this._deviceAccess = e;
              },

              _bidderSequence: v,

              get bidderSequence() {
                return this._bidderSequence;
              },

              set bidderSequence(e) {
                p[e] ? this._bidderSequence = e : (0, c.yN)("Invalid order: ".concat(e, ". Bidder Sequence was not set."));
              },

              _timeoutBuffer: 400,

              get timeoutBuffer() {
                return this._timeoutBuffer;
              },

              set timeoutBuffer(e) {
                this._timeoutBuffer = e;
              },

              _disableAjaxTimeout: false,

              get disableAjaxTimeout() {
                return this._disableAjaxTimeout;
              },

              set disableAjaxTimeout(e) {
                this._disableAjaxTimeout = e;
              },

              _maxNestedIframes: 10,

              get maxNestedIframes() {
                return this._maxNestedIframes;
              },

              set maxNestedIframes(e) {
                this._maxNestedIframes = e;
              },

              _auctionOptions: {},

              get auctionOptions() {
                return this._auctionOptions;
              },

              set auctionOptions(e) {
                (function (e) {
                  if (!(0, c.PO)(e)) return (0, c.yN)("Auction Options must be an object"), !1;

                  for (var n = 0, t = Object.keys(e); n < t.length; n++) {
                    var r = t[n];
                    if ("secondaryBidders" !== r && "suppressStaleRender" !== r) return (0, c.yN)("Auction Options given an incorrect param: ".concat(r)), !1;

                    if ("secondaryBidders" === r) {
                      if (!(0, c.kJ)(e[r])) return (0, c.yN)("Auction Options ".concat(r, " must be of type Array")), !1;
                      if (!e[r].every(c.d8)) return (0, c.yN)("Auction Options ".concat(r, " must be only string")), !1;
                    } else if ("suppressStaleRender" === r && !(0, c.jn)(e[r])) return (0, c.yN)("Auction Options ".concat(r, " must be of type boolean")), !1;
                  }

                  return !0;
                })(e) && (this._auctionOptions = e);
              }

            };

            function i(e) {
              return (0, u.sE)(Object.keys(h), function (n) {
                return e === h[n];
              });
            }

            function o(e) {
              if (!e) return (0, c.H)("Prebid Error: no value passed to `setPriceGranularity()`"), !1;
              if ("string" == typeof e) i(e) || (0, c.yN)("Prebid Warning: setPriceGranularity was called with invalid setting, using `medium` as default.");else if ((0, c.PO)(e) && !(0, a.t)(e)) return (0, c.H)("Invalid custom price value passed to `setPriceGranularity()`"), !1;
              return !0;
            }

            n && j(Object.keys(n).reduce(function (e, t) {
              return n[t] !== r[t] && (e[t] = r[t] || {}), e;
            }, {})), n = r, t = {};
          }

          function b() {
            if (g && t && (0, c.PO)(t[g])) {
              var e = t[g],
                  r = new Set(Object.keys(n).concat(Object.keys(e)));
              return (0, u.Oc)(r).reduce(function (t, r) {
                return void 0 === e[r] ? t[r] = n[r] : void 0 === n[r] ? t[r] = e[r] : (0, c.PO)(e[r]) ? t[r] = (0, c.Ee)({}, n[r], e[r]) : t[r] = e[r], t;
              }, {});
            }

            return Object.assign({}, n);
          }

          var y = [b, function () {
            var e = b();
            return Object.defineProperty(e, "ortb2", {
              get: function get() {
                throw new Error("invalid access to 'orbt2' config - use request parameters instead");
              }
            }), e;
          }].map(function (e) {
            return function () {
              if (arguments.length <= 1 && "function" != typeof (arguments.length <= 0 ? void 0 : arguments[0])) {
                var n = arguments.length <= 0 ? void 0 : arguments[0];
                return n ? (0, d.Z)(e(), n) : b();
              }

              return I.apply(void 0, arguments);
            };
          }),
              w = (0, o.Z)(y, 2),
              C = w[0],
              A = w[1],
              T = [A, C].map(function (e) {
            return function () {
              var n = e.apply(void 0, arguments);
              return n && "object" === (0, i.Z)(n) && (n = (0, c.I8)(n)), n;
            };
          }),
              E = (0, o.Z)(T, 2),
              O = E[0],
              k = E[1];

          function B(t) {
            if ((0, c.PO)(t)) {
              var r = Object.keys(t),
                  i = {};
              r.forEach(function (r) {
                var o = t[r];
                (0, c.PO)(e[r]) && (0, c.PO)(o) && (o = Object.assign({}, e[r], o));

                try {
                  i[r] = n[r] = o;
                } catch (e) {
                  (0, c.yN)("Cannot set config for property ".concat(r, " : "), e);
                }
              }), j(i);
            } else (0, c.H)("setConfig options must be an object");
          }

          function I(e, n) {
            var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                i = n;

            if ("string" != typeof e && (i = e, e = "*", t = n || {}), "function" == typeof i) {
              var o = {
                topic: e,
                callback: i
              };
              return s.push(o), t.init && i("*" === e ? A() : (0, r.Z)({}, e, A(e))), function () {
                s.splice(s.indexOf(o), 1);
              };
            }

            (0, c.H)("listener must be a function");
          }

          function j(e) {
            var n = Object.keys(e);
            s.filter(function (e) {
              return (0, u.q9)(n, e.topic);
            }).forEach(function (n) {
              n.callback((0, r.Z)({}, n.topic, e[n.topic]));
            }), s.filter(function (e) {
              return "*" === e.topic;
            }).forEach(function (n) {
              return n.callback(e);
            });
          }

          function S(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

            try {
              !function (e) {
                if (!(0, c.PO)(e)) throw "setBidderConfig bidder options must be an object";
                if (!Array.isArray(e.bidders) || !e.bidders.length) throw "setBidderConfig bidder options must contain a bidders list with at least 1 bidder";
                if (!(0, c.PO)(e.config)) throw "setBidderConfig bidder options must contain a config object";
              }(e), e.bidders.forEach(function (r) {
                t[r] || (t[r] = {}), Object.keys(e.config).forEach(function (i) {
                  var o = e.config[i];

                  if ((0, c.PO)(o)) {
                    var a = n ? c.Ee : Object.assign;
                    t[r][i] = a({}, t[r][i] || {}, o);
                  } else t[r][i] = o;
                });
              });
            } catch (e) {
              (0, c.H)(e);
            }
          }

          function U(e, n) {
            g = e;

            try {
              return n();
            } finally {
              P();
            }
          }

          function P() {
            g = null;
          }

          return m(), {
            getCurrentBidder: function getCurrentBidder() {
              return g;
            },
            resetBidder: P,
            getConfig: A,
            getAnyConfig: C,
            readConfig: O,
            readAnyConfig: k,
            setConfig: B,
            mergeConfig: function mergeConfig(e) {
              if ((0, c.PO)(e)) {
                var n = (0, c.Ee)(b(), e);
                return B(function (e) {
                  for (var n = 1; n < arguments.length; n++) {
                    var t = null != arguments[n] ? arguments[n] : {};
                    n % 2 ? f(Object(t), !0).forEach(function (n) {
                      (0, r.Z)(e, n, t[n]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : f(Object(t)).forEach(function (n) {
                      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
                    });
                  }

                  return e;
                }({}, n)), n;
              }

              (0, c.H)("mergeConfig input must be an object");
            },
            setDefaults: function setDefaults(t) {
              (0, c.PO)(e) ? (Object.assign(e, t), Object.assign(n, t)) : (0, c.H)("defaults must be an object");
            },
            resetConfig: m,
            runWithBidder: U,
            callbackWithBidder: function callbackWithBidder(e) {
              return function (n) {
                return function () {
                  if ("function" == typeof n) {
                    for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++) {
                      r[i] = arguments[i];
                    }

                    return U(e, c.ak.call.apply(c.ak, [n, this].concat(r)));
                  }

                  (0, c.yN)("config.callbackWithBidder callback is not a function");
                };
              };
            },
            setBidderConfig: S,
            getBidderConfig: function getBidderConfig() {
              return t;
            },
            mergeBidderConfig: function mergeBidderConfig(e) {
              return S(e, !0);
            }
          };
        }();
      },
      6463: function _(e, n, t) {
        t.d(n, {
          D: function D() {
            return l;
          },
          t: function t() {
            return p;
          }
        });
        var r = t(4614),
            i = t(4358),
            o = t(3193),
            a = 2,
            u = {
          buckets: [{
            max: 5,
            increment: .5
          }]
        },
            c = {
          buckets: [{
            max: 20,
            increment: .1
          }]
        },
            d = {
          buckets: [{
            max: 20,
            increment: .01
          }]
        },
            s = {
          buckets: [{
            max: 3,
            increment: .01
          }, {
            max: 8,
            increment: .05
          }, {
            max: 20,
            increment: .5
          }]
        },
            f = {
          buckets: [{
            max: 5,
            increment: .05
          }, {
            max: 10,
            increment: .1
          }, {
            max: 20,
            increment: .5
          }]
        };

        function l(e, n) {
          var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
              r = parseFloat(e);
          return isNaN(r) && (r = ""), {
            low: "" === r ? "" : g(e, u, t),
            med: "" === r ? "" : g(e, c, t),
            high: "" === r ? "" : g(e, d, t),
            auto: "" === r ? "" : g(e, f, t),
            dense: "" === r ? "" : g(e, s, t),
            custom: "" === r ? "" : g(e, n, t)
          };
        }

        function g(e, n, t) {
          var u = "";
          if (!p(n)) return u;
          var c = n.buckets.reduce(function (e, n) {
            return e.max > n.max ? e : n;
          }, {
            max: 0
          }),
              d = 0,
              s = (0, r.sE)(n.buckets, function (n) {
            if (e > c.max * t) {
              var r = n.precision;
              void 0 === r && (r = a), u = (n.max * t).toFixed(r);
            } else {
              if (e <= n.max * t && e >= d * t) return n.min = d, n;
              d = n.max;
            }
          });
          return s && (u = function (e, n, t) {
            var r = void 0 !== n.precision ? n.precision : a,
                u = n.increment * t,
                c = n.min * t,
                d = Math.floor,
                s = o.vc.getConfig("cpmRoundingFunction");
            "function" == typeof s && (d = s);
            var f,
                l,
                g = Math.pow(10, r + 2),
                p = (e * g - c * g) / (u * g);

            try {
              f = d(p) * u + c;
            } catch (e) {
              l = !0;
            }

            (l || "number" != typeof f) && ((0, i.yN)("Invalid rounding function passed in config"), f = Math.floor(p) * u + c);
            return (f = Number(f.toFixed(10))).toFixed(r);
          }(e, s, t)), u;
        }

        function p(e) {
          if ((0, i.xb)(e) || !e.buckets || !Array.isArray(e.buckets)) return !1;
          var n = !0;
          return e.buckets.forEach(function (e) {
            e.max && e.increment || (n = !1);
          }), n;
        }
      },
      2021: function _(e, n, t) {
        t.d(n, {
          S1: function S1() {
            return l;
          },
          j8: function j8() {
            return p;
          },
          on: function on() {
            return f;
          },
          vw: function vw() {
            return g;
          }
        });

        var r = t(4358),
            i = t(5644),
            o = Array.prototype.slice,
            a = Array.prototype.push,
            u = r.HA(i.FP, function (e) {
          return e;
        }),
            c = i.aI,
            d = [],
            s = function () {
          var e = {},
              n = {};
          return n.on = function (n, t, i) {
            if (function (e) {
              return r.r3(u, e);
            }(n)) {
              var o = e[n] || {
                que: []
              };
              i ? (o[i] = o[i] || {
                que: []
              }, o[i].que.push(t)) : o.que.push(t), e[n] = o;
            } else r.H("Wrong event name : " + n + " Valid event names :" + u);
          }, n.emit = function (n) {
            !function (n, t) {
              r.ji("Emitting event for: " + n);
              var i = t[0] || {},
                  o = i[c[n]],
                  u = e[n] || {
                que: []
              },
                  s = r.HA(u, function (e, n) {
                return n;
              }),
                  f = [];
              d.push({
                eventType: n,
                args: i,
                id: o,
                elapsedTime: r.bd()
              }), o && r.r3(s, o) && a.apply(f, u[o].que), a.apply(f, u.que), r.yi(f, function (e) {
                if (e) try {
                  e.apply(null, t);
                } catch (e) {
                  r.H("Error executing handler:", "events.js", e);
                }
              });
            }(n, o.call(arguments, 1));
          }, n.off = function (n, t, i) {
            var o = e[n];
            r.xb(o) || r.xb(o.que) && r.xb(o[i]) || i && (r.xb(o[i]) || r.xb(o[i].que)) || (i ? r.yi(o[i].que, function (e) {
              var n = o[i].que;
              e === t && n.splice(n.indexOf(e), 1);
            }) : r.yi(o.que, function (e) {
              var n = o.que;
              e === t && n.splice(n.indexOf(e), 1);
            }), e[n] = o);
          }, n.get = function () {
            return e;
          }, n.addEvents = function (e) {
            u = u.concat(e);
          }, n.getEvents = function () {
            var e = [];
            return r.yi(d, function (n) {
              var t = Object.assign({}, n);
              e.push(t);
            }), e;
          }, n;
        }();

        r.u2(s.emit.bind(s));
        var f = s.on,
            l = s.off,
            g = (s.get, s.getEvents),
            p = s.emit;
        s.addEvents;
      },
      2797: function _(e, n, t) {
        t.d(n, {
          IF: function IF() {
            return d;
          },
          v5: function v5() {
            return c;
          },
          z3: function z3() {
            return a;
          }
        });
        var r = t(1432),
            i = t.n(r),
            o = t(8792),
            a = i()({
          ready: i().SYNC | i().ASYNC | i().QUEUE
        }),
            u = (0, o.P)();

        a.ready = function () {
          var e = a.ready;
          return function () {
            try {
              return e.apply(a, arguments);
            } finally {
              u.resolve();
            }
          };
        }();

        u.promise;
        var c = a.get;

        function d(e, n) {
          return Object.defineProperties(n, Object.fromEntries(["before", "after", "getHooks", "removeAll"].map(function (n) {
            return [n, {
              get: function get() {
                return e[n];
              }
            }];
          }))), n;
        }
      },
      4679: function _(e, n, t) {
        t.d(n, {
          B5: function B5() {
            return r;
          },
          Mk: function Mk() {
            return o;
          },
          Oh: function Oh() {
            return a;
          },
          pX: function pX() {
            return i;
          }
        });
        var r = "native",
            i = "video",
            o = "banner",
            a = "adpod";
      },
      59: function _(e, n, t) {
        t.d(n, {
          Fb: function Fb() {
            return I;
          },
          JL: function JL() {
            return q;
          },
          Sg: function Sg() {
            return v;
          },
          Ur: function Ur() {
            return P;
          },
          e6: function e6() {
            return U;
          },
          eK: function eK() {
            return N;
          },
          lY: function lY() {
            return D;
          },
          r4: function r4() {
            return S;
          },
          xc: function xc() {
            return h;
          }
        });
        var r = t(3324),
            i = t(4942),
            o = t(265),
            a = t(4358),
            u = t(4614),
            c = t(5383),
            d = t(5644),
            s = t(4679);

        function f(e, n) {
          var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

          if (!t) {
            if (Array.isArray(e) || (t = function (e, n) {
              if (!e) return;
              if ("string" == typeof e) return l(e, n);
              var t = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === t && e.constructor && (t = e.constructor.name);
              if ("Map" === t || "Set" === t) return Array.from(e);
              if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return l(e, n);
            }(e)) || n && e && "number" == typeof e.length) {
              t && (e = t);

              var r = 0,
                  i = function i() {};

              return {
                s: i,
                n: function n() {
                  return r >= e.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: e[r++]
                  };
                },
                e: function e(_e2) {
                  throw _e2;
                },
                f: i
              };
            }

            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          var o,
              a = !0,
              u = !1;
          return {
            s: function s() {
              t = t.call(e);
            },
            n: function n() {
              var e = t.next();
              return a = e.done, e;
            },
            e: function e(_e3) {
              u = !0, o = _e3;
            },
            f: function f() {
              try {
                a || null == t.return || t.return();
              } finally {
                if (u) throw o;
              }
            }
          };
        }

        function l(e, n) {
          (null == n || n > e.length) && (n = e.length);

          for (var t = 0, r = new Array(n); t < n; t++) {
            r[t] = e[t];
          }

          return r;
        }

        function g(e, n) {
          var t = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            n && (r = r.filter(function (n) {
              return Object.getOwnPropertyDescriptor(e, n).enumerable;
            })), t.push.apply(t, r);
          }

          return t;
        }

        function p(e) {
          for (var n = 1; n < arguments.length; n++) {
            var t = null != arguments[n] ? arguments[n] : {};
            n % 2 ? g(Object(t), !0).forEach(function (n) {
              (0, i.Z)(e, n, t[n]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : g(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
            });
          }

          return e;
        }

        var v = [],
            h = Object.keys(d.FY).map(function (e) {
          return d.FY[e];
        }),
            m = {
          image: {
            ortb: {
              ver: "1.2",
              assets: [{
                required: 1,
                id: 1,
                img: {
                  type: 3,
                  wmin: 100,
                  hmin: 100
                }
              }, {
                required: 1,
                id: 2,
                title: {
                  len: 140
                }
              }, {
                required: 1,
                id: 3,
                data: {
                  type: 1
                }
              }, {
                required: 0,
                id: 4,
                data: {
                  type: 2
                }
              }, {
                required: 0,
                id: 5,
                img: {
                  type: 1,
                  wmin: 20,
                  hmin: 20
                }
              }]
            },
            image: {
              required: !0
            },
            title: {
              required: !0
            },
            sponsoredBy: {
              required: !0
            },
            clickUrl: {
              required: !0
            },
            body: {
              required: !1
            },
            icon: {
              required: !1
            }
          }
        },
            b = d.s$,
            y = d.oF,
            w = d.V1,
            C = d.zA,
            A = d.FY,
            T = F(w),
            E = F(b),
            O = {
          img: 1,
          js: 2,
          1: "img",
          2: "js"
        },
            k = {
          impression: 1,
          "viewable-mrc50": 2,
          "viewable-mrc100": 3,
          "viewable-video50": 4
        };

        function B(e) {
          if (e && e.type && function (e) {
            if (!e || !(0, u.q9)(Object.keys(m), e)) return (0, a.H)("".concat(e, " nativeParam is not supported")), !1;
            return !0;
          }(e.type) && (e = m[e.type]), !e || !e.ortb || j(e.ortb)) return e;
        }

        function I(e) {
          e.forEach(function (e) {
            var n = e.nativeParams || (0, o.Z)(e, "mediaTypes.native");
            n && (e.nativeParams = B(n)), e.nativeParams && (e.nativeOrtbRequest = e.nativeParams.ortb || function (e) {
              if (!e && !(0, a.PO)(e)) return void (0, a.H)("Native assets object is empty or not an object: ", e);
              var n = {
                ver: "1.2",
                assets: []
              };

              for (var t in e) {
                if (!C.includes(t)) if (A.hasOwnProperty(t)) {
                  var r = e[t],
                      i = 0;
                  r.required && (0, a.jn)(r.required) && (i = Number(r.required));
                  var o = {
                    id: n.assets.length,
                    required: i
                  };
                  if (t in w) o.data = {
                    type: b[w[t]]
                  }, r.len && (o.data.len = r.len);else if ("icon" === t || "image" === t) {
                    if (o.img = {
                      type: "icon" === t ? y.ICON : y.MAIN
                    }, r.aspect_ratios) if ((0, a.kJ)(r.aspect_ratios)) {
                      if (r.aspect_ratios.length) {
                        var u = r.aspect_ratios[0],
                            c = u.min_width,
                            d = u.min_height;
                        (0, a.U)(c) && (0, a.U)(d) ? (o.img.wmin = c, o.img.hmin = d) : (0, a.H)("image.aspect_ratios min_width or min_height are invalid: ", c, d);
                        var s = r.aspect_ratios.filter(function (e) {
                          return e.ratio_width && e.ratio_height;
                        }).map(function (e) {
                          return "".concat(e.ratio_width, ":").concat(e.ratio_height);
                        });
                        s.length > 0 && (o.img.ext = {
                          aspectratios: s
                        });
                      } else (0, a.H)("image.aspect_ratios was passed, but it's empty:", r.aspect_ratios);
                    } else (0, a.H)("image.aspect_ratios was passed, but it's not a an array:", r.aspect_ratios);
                    r.sizes && (2 === r.sizes.length && (0, a.U)(r.sizes[0]) && (0, a.U)(r.sizes[1]) ? (o.img.w = r.sizes[0], o.img.h = r.sizes[1], delete o.img.hmin, delete o.img.wmin) : (0, a.H)("image.sizes was passed, but its value is not an array of integers:", r.sizes));
                  } else "title" === t ? o.title = {
                    len: r.len || 140
                  } : "ext" === t && (o.ext = r, delete o.required);
                  n.assets.push(o);
                } else (0, a.H)("Unrecognized native asset code: ".concat(t, ". Asset will be ignored."));
              }

              return n;
            }(e.nativeParams));
          });
        }

        function j(e) {
          var n = e.assets;
          if (!Array.isArray(n) || 0 === n.length) return (0, a.H)("assets in mediaTypes.native.ortb is not an array, or it's empty. Assets: ", n), !1;
          var t = n.map(function (e) {
            return e.id;
          });
          return n.length !== new Set(t).size || t.some(function (e) {
            return e !== parseInt(e, 10);
          }) ? ((0, a.H)("each asset object must have 'id' property, it must be unique and it must be an integer"), !1) : e.hasOwnProperty("eventtrackers") && !Array.isArray(e.eventtrackers) ? ((0, a.H)("ortb.eventtrackers is not an array. Eventtrackers: ", e.eventtrackers), !1) : n.every(function (e) {
            return function (e) {
              if (!(0, a.PO)(e)) return (0, a.H)("asset must be an object. Provided asset: ", e), !1;

              if (e.img) {
                if (!(0, a.hj)(e.img.w) && !(0, a.hj)(e.img.wmin)) return (0, a.H)("for img asset there must be 'w' or 'wmin' property"), !1;
                if (!(0, a.hj)(e.img.h) && !(0, a.hj)(e.img.hmin)) return (0, a.H)("for img asset there must be 'h' or 'hmin' property"), !1;
              } else if (e.title) {
                if (!(0, a.hj)(e.title.len)) return (0, a.H)("for title asset there must be 'len' property defined"), !1;
              } else if (e.data) {
                if (!(0, a.hj)(e.data.type)) return (0, a.H)("for data asset 'type' property must be a number"), !1;
              } else if (e.video && !(Array.isArray(e.video.mimes) && Array.isArray(e.video.protocols) && (0, a.hj)(e.video.minduration) && (0, a.hj)(e.video.maxduration))) return (0, a.H)("video asset is not properly configured"), !1;

              return !0;
            }(e);
          });
        }

        function S(e) {
          var n,
              t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).index,
              r = (void 0 === t ? c.K.index : t).getAdUnit(e);
          if (!r) return !1;

          var i = r.nativeOrtbRequest,
              d = (null === (n = e.native) || void 0 === n ? void 0 : n.ortb) || function (e, n) {
            var t = p(p({}, H(e)), {}, {
              assets: []
            });

            function r(e, r) {
              var i = n.assets.find(e);
              null != i && (r(i = (0, a.I8)(i)), t.assets.push(i));
            }

            return Object.keys(e).filter(function (n) {
              return !!e[n];
            }).forEach(function (n) {
              var t = e[n];

              switch (n) {
                case "title":
                  r(function (e) {
                    return null != e.title;
                  }, function (e) {
                    e.title = {
                      text: t
                    };
                  });
                  break;

                case "image":
                case "icon":
                  var i = "image" === n ? y.MAIN : y.ICON;
                  r(function (e) {
                    return null != e.img && e.img.type === i;
                  }, function (e) {
                    e.img = {
                      url: t
                    };
                  });
                  break;

                default:
                  n in w && r(function (e) {
                    return null != e.data && e.data.type === b[w[n]];
                  }, function (e) {
                    e.data = {
                      value: t
                    };
                  });
              }
            }), t;
          }(e.native, i);

          return function (e, n) {
            if (!(0, o.Z)(e, "link.url")) return (0, a.H)("native response doesn't have 'link' property. Ortb response: ", e), !1;
            var t = n.assets.filter(function (e) {
              return 1 === e.required;
            }).map(function (e) {
              return e.id;
            }),
                r = e.assets.map(function (e) {
              return e.id;
            }),
                i = t.every(function (e) {
              return (0, u.q9)(r, e);
            });
            i || (0, a.H)("didn't receive a bid with all required assets. Required ids: ".concat(t, ", but received ids in response: ").concat(r));
            return i;
          }(d, i);
        }

        function U(e, n) {
          var t = n.native.ortb || H(n.native);
          return "click" === e.action ? function (e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                r = t.fetchURL,
                i = void 0 === r ? a.hq : r;

            if (n) {
              var o,
                  u = (e.assets || []).filter(function (e) {
                return e.link;
              }).reduce(function (e, n) {
                return e[n.id] = n.link, e;
              }, {}),
                  c = (null === (o = e.link) || void 0 === o ? void 0 : o.clicktrackers) || [],
                  d = u[n],
                  s = c;
              d && (s = d.clicktrackers || []), s.forEach(function (e) {
                return i(e);
              });
            } else {
              var f;
              ((null === (f = e.link) || void 0 === f ? void 0 : f.clicktrackers) || []).forEach(function (e) {
                return i(e);
              });
            }
          }(t, null == e ? void 0 : e.assetId) : function (e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                t = n.runMarkup,
                r = void 0 === t ? function (e) {
              return (0, a.$8)(e);
            } : t,
                i = n.fetchURL,
                o = void 0 === i ? a.hq : i,
                u = (e.eventtrackers || []).filter(function (e) {
              return e.event === k.impression;
            }),
                c = u.reduce(function (e, n) {
              return O.hasOwnProperty(n.method) && e[O[n.method]].push(n.url), e;
            }, {
              img: [],
              js: []
            }),
                d = c.img,
                s = c.js;
            e.imptrackers && (d = d.concat(e.imptrackers));
            d.forEach(function (e) {
              return o(e);
            }), s = s.map(function (e) {
              return '<script async src="'.concat(e, '"><\/script>');
            }), e.jstracker && (s = s.concat([e.jstracker]));
            s.length && r(s.join("\n"));
          }(t), e.action;
        }

        function P(e) {
          var n = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).index,
              t = void 0 === n ? c.K.index : n,
              r = {},
              i = t.getAdUnit(e);
          (0, o.Z)(i, "nativeParams.rendererUrl") ? e.native.rendererUrl = Z(i.nativeParams.rendererUrl) : (0, o.Z)(i, "nativeParams.adTemplate") && (e.native.adTemplate = Z(i.nativeParams.adTemplate));

          var a = !1 !== (0, o.Z)(i, "nativeParams.sendTargetingKeys"),
              u = function (e) {
            var n = {};
            (0, o.Z)(e, "nativeParams.ext") && Object.keys(e.nativeParams.ext).forEach(function (e) {
              n[e] = "hb_native_".concat(e);
            });
            return p(p({}, d.FY), n);
          }(i),
              s = p(p({}, e.native), e.native.ext);

          return delete s.ext, Object.keys(s).forEach(function (n) {
            var t = u[n],
                c = Z(e.native[n]) || Z((0, o.Z)(e, "native.ext.".concat(n)));

            if ("adTemplate" !== n && t && c) {
              var d = (0, o.Z)(i, "nativeParams.".concat(n, ".sendId"));
              if ("boolean" != typeof d && (d = (0, o.Z)(i, "nativeParams.ext.".concat(n, ".sendId"))), d) c = "".concat(t, ":").concat(e.adId);
              var s = (0, o.Z)(i, "nativeParams.".concat(n, ".sendTargetingKeys"));
              "boolean" != typeof s && (s = (0, o.Z)(i, "nativeParams.ext.".concat(n, ".sendTargetingKeys"))), ("boolean" == typeof s ? s : a) && (r[t] = c);
            }
          }), r;
        }

        var _ = function _(e) {
          var n;
          return null === (n = c.K.index.getAdUnit(e)) || void 0 === n ? void 0 : n.nativeOrtbRequest;
        };

        function R(e, n, t) {
          var r,
              i = (arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}).getNativeReq,
              o = void 0 === i ? _ : i,
              a = {
            message: "assetResponse",
            adId: e.adId
          },
              u = o(n),
              c = n.native,
              s = null === (r = n.native) || void 0 === r ? void 0 : r.ortb,
              l = {};
          return u && s && (l = function (e, n) {
            var t = {},
                r = (null == n ? void 0 : n.assets) || [];
            t.clickUrl = e.link.url, t.privacyLink = e.privacy;
            var i,
                o = f((null == e ? void 0 : e.assets) || []);

            try {
              var a = function a() {
                var e = i.value,
                    n = r.find(function (n) {
                  return e.id === n.id;
                });
                e.title ? t.title = e.title.text : e.img ? t[n.img.type === y.MAIN ? "image" : "icon"] = e.img.url : e.data && (t[T[E[n.data.type]]] = e.data.value);
              };

              for (o.s(); !(i = o.n()).done;) {
                a();
              }
            } catch (e) {
              o.e(e);
            } finally {
              o.f();
            }

            return t;
          }(s, u), c = p(p({}, n.native), l)), n.native.ortb && (a.ortb = n.native.ortb), a.assets = [], (null == t ? Object.keys(c) : t).forEach(function (e) {
            if ("adTemplate" === e && c[e]) a.adTemplate = Z(c[e]);else if ("rendererUrl" === e && c[e]) a.rendererUrl = Z(c[e]);else if ("ext" === e) Object.keys(c[e]).forEach(function (n) {
              if (c[e][n]) {
                var t = Z(c[e][n]);
                a.assets.push({
                  key: n,
                  value: t
                });
              }
            });else if (c[e] && d.FY.hasOwnProperty(e)) {
              var n = Z(c[e]);
              a.assets.push({
                key: e,
                value: n
              });
            }
          }), a;
        }

        function N(e, n) {
          var t = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).getNativeReq,
              r = void 0 === t ? _ : t,
              i = e.assets.map(function (e) {
            return (0, a.V9)(d.FY, e);
          });
          return R(e, n, i, {
            getNativeReq: r
          });
        }

        function q(e, n) {
          var t = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).getNativeReq;
          return R(e, n, null, {
            getNativeReq: void 0 === t ? _ : t
          });
        }

        function Z(e) {
          return (null == e ? void 0 : e.url) || e;
        }

        function x(e) {
          if (j(e)) {
            var n,
                t = {},
                r = f(e.assets);

            try {
              var i = function i() {
                var e = n.value;

                if (e.title) {
                  var r = {
                    required: !!e.required && Boolean(e.required),
                    len: e.title.len
                  };
                  t.title = r;
                } else if (e.img) {
                  var i = {
                    required: !!e.required && Boolean(e.required)
                  };
                  e.img.w && e.img.h ? i.sizes = [e.img.w, e.img.h] : e.img.wmin && e.img.hmin && (i.aspect_ratios = {
                    min_width: e.img.wmin,
                    min_height: e.img.hmin,
                    ratio_width: e.img.wmin,
                    ratio_height: e.img.hmin
                  }), e.img.type === y.MAIN ? t.image = i : t.icon = i;
                } else if (e.data) {
                  var o = Object.keys(b).find(function (n) {
                    return b[n] === e.data.type;
                  }),
                      a = Object.keys(w).find(function (e) {
                    return w[e] === o;
                  });
                  t[a] = {
                    required: !!e.required && Boolean(e.required)
                  }, e.data.len && (t[a].len = e.data.len);
                }
              };

              for (r.s(); !(n = r.n()).done;) {
                i();
              }
            } catch (e) {
              r.e(e);
            } finally {
              r.f();
            }

            return t;
          }
        }

        function D(e) {
          if (!e || !(0, a.kJ)(e)) return e;
          if (!e.some(function (e) {
            var n;
            return null === (n = ((null == e ? void 0 : e.mediaTypes) || {})[s.B5]) || void 0 === n ? void 0 : n.ortb;
          })) return e;
          var n,
              t = (0, a.I8)(e),
              r = f(t);

          try {
            for (r.s(); !(n = r.n()).done;) {
              var i = n.value;
              i.mediaTypes && i.mediaTypes[s.B5] && i.mediaTypes[s.B5].ortb && (i.mediaTypes[s.B5] = Object.assign((0, a.ei)(i.mediaTypes[s.B5], C), x(i.mediaTypes[s.B5].ortb)), i.nativeParams = B(i.mediaTypes[s.B5]));
            }
          } catch (e) {
            r.e(e);
          } finally {
            r.f();
          }

          return t;
        }

        function H(e) {
          var n = {
            link: {},
            eventtrackers: []
          };
          return Object.entries(e).forEach(function (e) {
            var t = (0, r.Z)(e, 2),
                i = t[0],
                o = t[1];

            switch (i) {
              case "clickUrl":
                n.link.url = o;
                break;

              case "clickTrackers":
                n.link.clicktrackers = Array.isArray(o) ? o : [o];
                break;

              case "impressionTrackers":
                (Array.isArray(o) ? o : [o]).forEach(function (e) {
                  n.eventtrackers.push({
                    event: k.impression,
                    method: O.img,
                    url: e
                  });
                });
                break;

              case "javascriptTrackers":
                n.jstracker = Array.isArray(o) ? o.join("") : o;
            }
          }), n;
        }

        function F(e) {
          var n = {};

          for (var t in e) {
            n[e[t]] = t;
          }

          return n;
        }
      },
      4614: function _(e, n, t) {
        function r(e, n, t) {
          return e && e.includes(n, t) || !1;
        }

        function i() {
          return Array.from.apply(Array, arguments);
        }

        function o(e, n, t) {
          return e && e.find(n, t);
        }

        t.d(n, {
          Oc: function Oc() {
            return i;
          },
          q9: function q9() {
            return r;
          },
          sE: function sE() {
            return o;
          }
        });
      },
      8640: function _(e, n, t) {
        function r() {
          return window.pbjs;
        }

        t.d(n, {
          R: function R() {
            return r;
          }
        }), window.pbjs = window.pbjs || {}, window.pbjs.cmd = window.pbjs.cmd || [], window.pbjs.que = window.pbjs.que || [], window._pbjsGlobals = window._pbjsGlobals || [], window._pbjsGlobals.push("pbjs");
      },
      5102: function _(e, n, t) {
        t.d(n, {
          nH: function nH() {
            return u;
          }
        });
        var r = t(3193),
            i = t(4358);

        function o(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window;
          if (!e) return e;
          if (/\w+:\/\//.exec(e)) return e;
          var t = n.location.protocol;

          try {
            t = n.top.location.protocol;
          } catch (e) {}

          return /^\/\//.exec(e) ? t + e : "".concat(t, "//").concat(e);
        }

        function a(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              t = n.noLeadingWww,
              r = void 0 !== t && t,
              i = n.noPort,
              a = void 0 !== i && i;

          try {
            e = new URL(o(e));
          } catch (e) {
            return;
          }

          return e = a ? e.hostname : e.host, r && e.startsWith("www.") && (e = e.substring(4)), e;
        }

        var u = function (e) {
          function n(e) {
            try {
              var n = e.querySelector("link[rel='canonical']");
              if (null !== n) return n.href;
            } catch (e) {}

            return null;
          }

          return function () {
            var t,
                u,
                c,
                d = [],
                s = function (e) {
              try {
                if (!e.location.ancestorOrigins) return;
                return e.location.ancestorOrigins;
              } catch (e) {}
            }(e),
                f = r.vc.getConfig("maxNestedIframes"),
                l = 0,
                g = !1,
                p = !1;

            do {
              var v = t,
                  h = p,
                  m = void 0,
                  b = !1,
                  y = null;
              p = !1, t = t ? t.parent : e;

              try {
                m = t.location.href || null;
              } catch (e) {
                b = !0;
              }

              if (b) {
                if (h) {
                  var w = v.context;

                  try {
                    u = y = w.sourceUrl, !0, g = !0, t === e.top && !0, w.canonicalUrl && (c = w.canonicalUrl);
                  } catch (e) {}
                } else {
                  (0, i.yN)("Trying to access cross domain iframe. Continuing without referrer and location");

                  try {
                    var C = v.document.referrer;
                    C && (y = C, t === e.top && !0);
                  } catch (e) {}

                  !y && s && s[l - 1] && (y = s[l - 1], t === e.top && !0), y && !g && (u = y);
                }
              } else {
                if (m && (u = y = m, g = !1, t === e.top)) {
                  !0;
                  var A = n(t.document);
                  A && (c = A);
                }

                t.context && t.context.sourceUrl && (p = !0);
              }

              d.push(y), l++;
            } while (t !== e.top && l < f);

            d.reverse();

            try {
              e.top.document.referrer;
            } catch (e) {}

            var T = u,
                E = r.vc.getConfig("pageUrl") || c || T || null,
                O = o(E, e) || T;
            return {
              reachedTop: !0,
              isAmp: !1,
              numIframes: 0,
              stack: [E],
              topmostLocation: E,
              location: E,
              canonicalUrl: E,
              page: O,
              domain: a(O) || null,
              ref: E,
              legacy: {
                reachedTop: !0,
                isAmp: !1,
                numIframes: 0,
                stack: [E],
                referer: E,
                canonicalUrl: null
              }
            };
          };
        }(window);
      },
      5164: function _(e, n, t) {
        t.d(n, {
          Ld: function Ld() {
            return u;
          },
          df: function df() {
            return f;
          },
          eA: function eA() {
            return s;
          }
        });
        var r = t(2797),
            i = t(4358),
            o = t(5975),
            a = ["core", "prebid-module"],
            u = [];

        function c() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = e.gvlid,
              t = e.moduleName,
              r = e.bidderCode,
              c = e.moduleType,
              s = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).bidderSettings,
              f = void 0 === s ? o.S : s;
          var l = a.includes(c);

          function g(e) {
            if (function () {
              if (null == r) return !0;
              var e = f.get(r, "storageAllowed");
              return null != e && e;
            }()) {
              var o;
              return d(l, n, r || t, {
                hasEnforcementHook: !1
              }, function (n) {
                if (n && n.hasEnforcementHook) o = e(n);else {
                  var t = {
                    hasEnforcementHook: !1,
                    valid: (0, i.wn)()
                  };
                  o = e(t);
                }
              }), o;
            }

            (0, i.PN)("bidderSettings denied access to device storage for bidder '".concat(r, "'"));
            return e({
              valid: !1
            });
          }

          var p = function p(e) {
            var n = function n(e) {
              if (e && e.valid) try {
                return !!window.localStorage;
              } catch (e) {
                (0, i.H)("Local storage api disabled");
              }
              return !1;
            };

            if (!e || "function" != typeof e) return g(n);
            u.push(function () {
              var t = g(n);
              e(t);
            });
          };

          return {
            setCookie: function setCookie(e, n, t, r, i, o) {
              var a = function a(o) {
                if (o && o.valid) {
                  var a = i && "" !== i ? " ;domain=".concat(encodeURIComponent(i)) : "",
                      u = t && "" !== t ? " ;expires=".concat(t) : "",
                      c = null != r && "none" == r.toLowerCase() ? "; Secure" : "";
                  document.cookie = "".concat(e, "=").concat(encodeURIComponent(n)).concat(u, "; path=/").concat(a).concat(r ? "; SameSite=".concat(r) : "").concat(c);
                }
              };

              if (!o || "function" != typeof o) return g(a);
              u.push(function () {
                var e = g(a);
                o(e);
              });
            },
            getCookie: function getCookie(e, n) {
              var t = function t(n) {
                if (n && n.valid) {
                  var t = window.document.cookie.match("(^|;)\\s*" + e + "\\s*=\\s*([^;]*)\\s*(;|$)");
                  return t ? decodeURIComponent(t[2]) : null;
                }

                return null;
              };

              if (!n || "function" != typeof n) return g(t);
              u.push(function () {
                var e = g(t);
                n(e);
              });
            },
            localStorageIsEnabled: function localStorageIsEnabled(e) {
              var n = function n(e) {
                if (e && e.valid) try {
                  return localStorage.setItem("prebid.cookieTest", "1"), "1" === localStorage.getItem("prebid.cookieTest");
                } catch (e) {} finally {
                  try {
                    localStorage.removeItem("prebid.cookieTest");
                  } catch (e) {}
                }
                return !1;
              };

              if (!e || "function" != typeof e) return g(n);
              u.push(function () {
                var t = g(n);
                e(t);
              });
            },
            cookiesAreEnabled: function cookiesAreEnabled(e) {
              var n = function n(e) {
                return !(!e || !e.valid) && (0, i.IG)();
              };

              if (!e || "function" != typeof e) return g(n);
              u.push(function () {
                var t = g(n);
                e(t);
              });
            },
            setDataInLocalStorage: function setDataInLocalStorage(e, n, t) {
              var r = function r(t) {
                t && t.valid && p() && window.localStorage.setItem(e, n);
              };

              if (!t || "function" != typeof t) return g(r);
              u.push(function () {
                var e = g(r);
                t(e);
              });
            },
            getDataFromLocalStorage: function getDataFromLocalStorage(e, n) {
              var t = function t(n) {
                return n && n.valid && p() ? window.localStorage.getItem(e) : null;
              };

              if (!n || "function" != typeof n) return g(t);
              u.push(function () {
                var e = g(t);
                n(e);
              });
            },
            removeDataFromLocalStorage: function removeDataFromLocalStorage(e, n) {
              var t = function t(n) {
                n && n.valid && p() && window.localStorage.removeItem(e);
              };

              if (!n || "function" != typeof n) return g(t);
              u.push(function () {
                var e = g(t);
                n(e);
              });
            },
            hasLocalStorage: p,
            findSimilarCookies: function findSimilarCookies(e, n) {
              var t = function t(n) {
                if (n && n.valid) {
                  var t = [];
                  if ((0, i.wn)()) for (var r = document.cookie.split(";"); r.length;) {
                    var o = r.pop(),
                        a = o.indexOf("=");
                    a = a < 0 ? o.length : a, decodeURIComponent(o.slice(0, a).replace(/^\s+/, "")).indexOf(e) >= 0 && t.push(decodeURIComponent(o.slice(a + 1)));
                  }
                  return t;
                }
              };

              if (!n || "function" != typeof n) return g(t);
              u.push(function () {
                var e = g(t);
                n(e);
              });
            }
          };
        }

        var d = (0, r.z3)("async", function (e, n, t, r, i) {
          i(r);
        }, "validateStorageEnforcement");

        function s(e) {
          return c({
            moduleName: e,
            moduleType: "core"
          });
        }

        function f() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = e.gvlid,
              t = e.moduleName,
              r = e.bidderCode;
          if (arguments.length > 1 || arguments.length > 0 && !(0, i.PO)(arguments[0])) throw new Error("Invalid invocation for getStorageManager");
          return c({
            gvlid: n,
            moduleName: t,
            bidderCode: r
          });
        }
      },
      1974: function _(e, n, t) {
        t.d(n, {
          k_: function k_() {
            return d;
          }
        });
        var r = t(3324),
            i = t(4358),
            o = t(3193),
            a = t(4614),
            u = t(5164);
        o.vc.setDefaults({
          userSync: (0, i.I8)({
            syncEnabled: !0,
            filterSettings: {
              image: {
                bidders: "*",
                filter: "include"
              }
            },
            syncsPerBidder: 5,
            syncDelay: 3e3,
            auctionDelay: 0
          })
        });
        var c = (0, u.eA)("usersync");

        var d = function (e) {
          var n = {},
              t = {
            image: [],
            iframe: []
          },
              u = new Set(),
              c = {},
              d = {
            image: !0,
            iframe: !1
          },
              s = e.config;

          function f() {
            if (s.syncEnabled && e.browserSupportsCookies) {
              try {
                !function () {
                  if (!d.iframe) return;
                  l(t.iframe, function (e) {
                    var n = (0, r.Z)(e, 2),
                        o = n[0],
                        a = n[1];
                    (0, i.ji)("Invoking iframe user sync for bidder: ".concat(o)), (0, i.Vs)(a), function (e, n) {
                      e.image = e.image.filter(function (e) {
                        return e[0] !== n;
                      });
                    }(t, o);
                  });
                }(), function () {
                  if (!d.image) return;
                  l(t.image, function (e) {
                    var n = (0, r.Z)(e, 2),
                        t = n[0],
                        o = n[1];
                    (0, i.ji)("Invoking image pixel user sync for bidder: ".concat(t)), (0, i.hq)(o);
                  });
                }();
              } catch (e) {
                return (0, i.H)("Error firing user syncs", e);
              }

              t = {
                image: [],
                iframe: []
              };
            }
          }

          function l(e, n) {
            (0, i.TV)(e).forEach(function (e) {
              n(e), u.add(e[0]);
            });
          }

          function g(e, n) {
            var t = s.filterSettings;

            if (function (e, n) {
              if (e.all && e[n]) return (0, i.yN)('Detected presence of the "filterSettings.all" and "filterSettings.'.concat(n, '" in userSync config.  You cannot mix "all" with "iframe/image" configs; they are mutually exclusive.')), !1;
              var t = e.all ? e.all : e[n],
                  r = e.all ? "all" : n;
              if (!t) return !1;
              var o = t.filter,
                  a = t.bidders;
              if (o && "include" !== o && "exclude" !== o) return (0, i.yN)('UserSync "filterSettings.'.concat(r, ".filter\" setting '").concat(o, "' is not a valid option; use either 'include' or 'exclude'.")), !1;
              if ("*" !== a && !(Array.isArray(a) && a.length > 0 && a.every(function (e) {
                return (0, i.d8)(e) && "*" !== e;
              }))) return (0, i.yN)('Detected an invalid setup in userSync "filterSettings.'.concat(r, ".bidders\"; use either '*' (to represent all bidders) or an array of bidders.")), !1;
              return !0;
            }(t, e)) {
              d[e] = !0;
              var r = t.all ? t.all : t[e],
                  o = "*" === r.bidders ? [n] : r.bidders,
                  u = {
                include: function include(e, n) {
                  return !(0, a.q9)(e, n);
                },
                exclude: function exclude(e, n) {
                  return (0, a.q9)(e, n);
                }
              };
              return u[r.filter || "include"](o, n);
            }

            return !d[e];
          }

          return o.vc.getConfig("userSync", function (e) {
            if (e.userSync) {
              var n = e.userSync.filterSettings;
              (0, i.PO)(n) && (n.image || n.all || (e.userSync.filterSettings.image = {
                bidders: "*",
                filter: "include"
              }));
            }

            s = Object.assign(s, e.userSync);
          }), n.registerSync = function (e, r, o) {
            return u.has(r) ? (0, i.ji)('already fired syncs for "'.concat(r, '", ignoring registerSync call')) : s.syncEnabled && (0, i.kJ)(t[e]) ? r ? 0 !== s.syncsPerBidder && Number(c[r]) >= s.syncsPerBidder ? (0, i.yN)('Number of user syncs exceeded for "'.concat(r, '"')) : n.canBidderRegisterSync(e, r) ? (t[e].push([r, o]), void (c = function (e, n) {
              return e[n] ? e[n] += 1 : e[n] = 1, e;
            }(c, r))) : (0, i.yN)('Bidder "'.concat(r, '" not permitted to register their "').concat(e, '" userSync pixels.')) : (0, i.yN)("Bidder is required for registering sync") : (0, i.yN)('User sync type "'.concat(e, '" not supported'));
          }, n.syncUsers = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
            if (e) return setTimeout(f, Number(e));
            f();
          }, n.triggerUserSyncs = function () {
            s.enableOverride && n.syncUsers();
          }, n.canBidderRegisterSync = function (e, n) {
            return !s.filterSettings || !g(e, n);
          }, n;
        }(Object.defineProperties({
          config: o.vc.getConfig("userSync")
        }, {
          browserSupportsCookies: {
            get: function get() {
              return !(0, i.fr)() && c.cookiesAreEnabled();
            }
          }
        }));
      },
      4358: function _(e, n, t) {
        t.d(n, {
          $8: function $8() {
            return me;
          },
          $u: function $u() {
            return X;
          },
          AB: function AB() {
            return qe;
          },
          An: function An() {
            return N;
          },
          D9: function D9() {
            return cn;
          },
          DO: function DO() {
            return R;
          },
          Ee: function Ee() {
            return an;
          },
          FS: function FS() {
            return ze;
          },
          H: function H() {
            return J;
          },
          HA: function HA() {
            return fe;
          },
          HC: function HC() {
            return $e;
          },
          I8: function I8() {
            return Ue;
          },
          IG: function IG() {
            return De;
          },
          IK: function IK() {
            return Se;
          },
          K$: function K$() {
            return Be;
          },
          LQ: function LQ() {
            return ne;
          },
          NA: function NA() {
            return Ce;
          },
          NI: function NI() {
            return F;
          },
          Ob: function Ob() {
            return x;
          },
          PN: function PN() {
            return L;
          },
          PO: function PO() {
            return oe;
          },
          Q2: function Q2() {
            return rn;
          },
          R_: function R_() {
            return he;
          },
          Re: function Re() {
            return Z;
          },
          S0: function S0() {
            return We;
          },
          T9: function T9() {
            return Ee;
          },
          TV: function TV() {
            return je;
          },
          U: function U() {
            return Qe;
          },
          V9: function V9() {
            return Ae;
          },
          Vs: function Vs() {
            return be;
          },
          X4: function X4() {
            return Oe;
          },
          Yp: function Yp() {
            return nn;
          },
          ZH: function ZH() {
            return ke;
          },
          Zy: function Zy() {
            return z;
          },
          _d: function _d() {
            return _;
          },
          ak: function ak() {
            return U;
          },
          bd: function bd() {
            return Ze;
          },
          d8: function d8() {
            return te;
          },
          dj: function dj() {
            return un;
          },
          ei: function ei() {
            return Ye;
          },
          en: function en() {
            return tn;
          },
          ew: function ew() {
            return Re;
          },
          fr: function fr() {
            return _e;
          },
          hj: function hj() {
            return ie;
          },
          hq: function hq() {
            return ve;
          },
          iG: function iG() {
            return Me;
          },
          jC: function jC() {
            return ge;
          },
          jH: function jH() {
            return ce;
          },
          ji: function ji() {
            return K;
          },
          jn: function jn() {
            return ae;
          },
          kJ: function kJ() {
            return re;
          },
          ky: function ky() {
            return Je;
          },
          or: function or() {
            return Ve;
          },
          pP: function pP() {
            return Te;
          },
          qp: function qp() {
            return V;
          },
          r3: function r3() {
            return se;
          },
          rD: function rD() {
            return $;
          },
          sF: function sF() {
            return D;
          },
          t0: function t0() {
            return q;
          },
          tT: function tT() {
            return ye;
          },
          u2: function u2() {
            return k;
          },
          uh: function uh() {
            return Xe;
          },
          vM: function vM() {
            return Fe;
          },
          wn: function wn() {
            return xe;
          },
          xH: function xH() {
            return we;
          },
          x_: function x_() {
            return Ne;
          },
          xb: function xb() {
            return ue;
          },
          yL: function yL() {
            return Pe;
          },
          yN: function yN() {
            return G;
          },
          yi: function yi() {
            return de;
          },
          yx: function yx() {
            return He;
          },
          zV: function zV() {
            return Le;
          }
        });
        var r,
            i = t(3324),
            o = t(9062),
            a = t(4942),
            u = t(1002),
            c = t(3193),
            d = t(7079),
            s = t.n(d),
            f = t(4614),
            l = t(5644),
            g = t(8792),
            p = "Array",
            v = "String",
            h = "Function",
            m = "Number",
            b = "Object",
            y = "Boolean",
            w = Object.prototype.toString,
            C = Boolean(window.console),
            A = Boolean(C && window.console.log),
            T = Boolean(C && window.console.info),
            E = Boolean(C && window.console.warn),
            O = Boolean(C && window.console.error);

        function k(e) {
          r = e;
        }

        function B() {
          null != r && r.apply(void 0, arguments);
        }

        var I = {
          checkCookieSupport: De,
          createTrackPixelIframeHtml: function createTrackPixelIframeHtml(e) {
            var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
            if (!e) return "";
            n && (e = encodeURI(e));
            t && (t = 'sandbox="'.concat(t, '"'));
            return "<iframe ".concat(t, ' id="').concat(_(), '"\n      frameborder="0"\n      allowtransparency="true"\n      marginheight="0" marginwidth="0"\n      width="0" hspace="0" vspace="0" height="0"\n      style="height:0px;width:0px;display:none;"\n      scrolling="no"\n      src="').concat(e, '">\n    </iframe>');
          },
          getWindowSelf: function getWindowSelf() {
            return window.self;
          },
          getWindowTop: z,
          getWindowLocation: W,
          insertUserSyncIframe: be,
          insertElement: ge,
          isFn: ne,
          triggerPixel: ve,
          logError: J,
          logWarn: G,
          logMessage: K,
          logInfo: L,
          parseQS: en,
          formatQS: nn,
          deepEqual: on
        };
        var j,
            S = {},
            U = function (e, n) {
          return n;
        }.bind(null, 1, S)() === S ? Function.prototype.bind : function (e) {
          var n = this,
              t = Array.prototype.slice.call(arguments, 1);
          return function () {
            return n.apply(e, t.concat(Array.prototype.slice.call(arguments)));
          };
        },
            P = (j = 0, function () {
          return ++j;
        });

        function _() {
          return P() + Math.random().toString(16).substr(2);
        }

        function R(e) {
          return e ? (e ^ (window && window.crypto && window.crypto.getRandomValues ? crypto.getRandomValues(new Uint8Array(1))[0] % 16 : 16 * Math.random()) >> e / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, R);
        }

        function N(e, n) {
          return n && n[e] ? n[e] : "";
        }

        function q(e, n, t) {
          return t ? e + n + "=" + encodeURIComponent(t) + "&" : e;
        }

        function Z(e) {
          var n = "";

          for (var t in e) {
            e.hasOwnProperty(t) && (n += t + "=" + encodeURIComponent(e[t]) + "&");
          }

          return n = n.replace(/&$/, "");
        }

        function x(e) {
          return e && Object.getOwnPropertyNames(e).length > 0 ? (n = e, Object.keys(n)).map(function (n) {
            return "".concat(n, "=").concat(encodeURIComponent(Ce(e, n)));
          }).join("&") : "";
          var n;
        }

        function D(e) {
          var n = [];

          if ("string" == typeof e) {
            var t = e.split(","),
                r = /^(\d)+x(\d)+$/i;
            if (t) for (var i in t) {
              le(t, i) && t[i].match(r) && n.push(t[i]);
            }
          } else if ("object" === (0, u.Z)(e)) {
            var o = e.length;
            if (o > 0) if (2 === o && "number" == typeof e[0] && "number" == typeof e[1]) n.push(H(e));else for (var a = 0; a < o; a++) {
              n.push(H(e[a]));
            }
          }

          return n;
        }

        function H(e) {
          if (M(e)) return e[0] + "x" + e[1];
        }

        function F(e) {
          if (M(e)) return {
            w: e[0],
            h: e[1]
          };
        }

        function M(e) {
          return re(e) && 2 === e.length && !isNaN(e[0]) && !isNaN(e[1]);
        }

        function z() {
          return window.top;
        }

        function W() {
          return window.location;
        }

        function K() {
          Y() && A && console.log.apply(console, Q(arguments, "MESSAGE:"));
        }

        function L() {
          Y() && T && console.info.apply(console, Q(arguments, "INFO:"));
        }

        function G() {
          Y() && E && console.warn.apply(console, Q(arguments, "WARNING:")), B(l.FP.AUCTION_DEBUG, {
            type: "WARNING",
            arguments: arguments
          });
        }

        function J() {
          Y() && O && console.error.apply(console, Q(arguments, "ERROR:")), B(l.FP.AUCTION_DEBUG, {
            type: "ERROR",
            arguments: arguments
          });
        }

        function V(e) {
          function n(n) {
            return function () {
              for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++) {
                r[i] = arguments[i];
              }

              n.apply(void 0, [e].concat(r));
            };
          }

          return {
            logError: n(J),
            logWarn: n(G),
            logMessage: n(K),
            logInfo: n(L)
          };
        }

        function Q(e, n) {
          e = [].slice.call(e);
          var t = c.vc.getCurrentBidder();
          return n && e.unshift(n), t && e.unshift(r("#aaa")), e.unshift(r("#3b88c3")), e.unshift("%cPrebid" + (t ? "%c".concat(t) : "")), e;

          function r(e) {
            return "display: inline-block; color: #fff; background: ".concat(e, "; padding: 1px 4px; border-radius: 3px;");
          }
        }

        function Y() {
          return !!c.vc.getConfig("debug");
        }

        function X() {
          var e = document.createElement("iframe");
          return e.id = _(), e.height = 0, e.width = 0, e.border = "0px", e.hspace = "0", e.vspace = "0", e.marginWidth = "0", e.marginHeight = "0", e.style.border = "0", e.scrolling = "no", e.frameBorder = "0", e.src = "about:blank", e.style.display = "none", e;
        }

        function $(e) {
          return en(W().search)[e] || "";
        }

        function ee(e, n) {
          return w.call(e) === "[object " + n + "]";
        }

        function ne(e) {
          return ee(e, h);
        }

        function te(e) {
          return ee(e, v);
        }

        function re(e) {
          return ee(e, p);
        }

        function ie(e) {
          return ee(e, m);
        }

        function oe(e) {
          return ee(e, b);
        }

        function ae(e) {
          return ee(e, y);
        }

        function ue(e) {
          if (!e) return !0;
          if (re(e) || te(e)) return !(e.length > 0);

          for (var n in e) {
            if (hasOwnProperty.call(e, n)) return !1;
          }

          return !0;
        }

        function ce(e) {
          return te(e) && (!e || 0 === e.length);
        }

        function de(e, n) {
          if (!ue(e)) {
            if (ne(e.forEach)) return e.forEach(n, this);
            var t = 0,
                r = e.length;
            if (r > 0) for (; t < r; t++) {
              n(e[t], t, e);
            } else for (t in e) {
              hasOwnProperty.call(e, t) && n.call(this, e[t], t);
            }
          }
        }

        function se(e, n) {
          if (ue(e)) return !1;
          if (ne(e.indexOf)) return -1 !== e.indexOf(n);

          for (var t = e.length; t--;) {
            if (e[t] === n) return !0;
          }

          return !1;
        }

        function fe(e, n) {
          if (ue(e)) return [];
          if (ne(e.map)) return e.map(n);
          var t = [];
          return de(e, function (r, i) {
            t.push(n(r, i, e));
          }), t;
        }

        function le(e, n) {
          return e.hasOwnProperty ? e.hasOwnProperty(n) : void 0 !== e[n] && e.constructor.prototype[n] !== e[n];
        }

        function ge(e, n, t, r) {
          var i;
          n = n || document, i = t ? n.getElementsByTagName(t) : n.getElementsByTagName("head");

          try {
            if ((i = i.length ? i : n.getElementsByTagName("body")).length) {
              i = i[0];
              var o = r ? null : i.firstChild;
              return i.insertBefore(e, o);
            }
          } catch (e) {}
        }

        function pe(e, n) {
          var t = null;
          return new g.Z(function (r) {
            var i = function n() {
              e.removeEventListener("load", n), e.removeEventListener("error", n), null != t && window.clearTimeout(t), r();
            };

            e.addEventListener("load", i), e.addEventListener("error", i), null != n && (t = window.setTimeout(i, n));
          });
        }

        function ve(e, n, t) {
          var r = new Image();
          n && I.isFn(n) && pe(r, t).then(n), r.src = e;
        }

        function he(e) {
          var n = e.source,
              t = e.burl;
          n === l.os.YZ && t && I.triggerPixel(t);
        }

        function me(e) {
          if (e) {
            var n = document.createElement("iframe");
            n.id = _(), n.width = 0, n.height = 0, n.hspace = "0", n.vspace = "0", n.marginWidth = "0", n.marginHeight = "0", n.style.display = "none", n.style.height = "0px", n.style.width = "0px", n.scrolling = "no", n.frameBorder = "0", n.allowtransparency = "true", I.insertElement(n, document, "body"), n.contentWindow.document.open(), n.contentWindow.document.write(e), n.contentWindow.document.close();
          }
        }

        function be(e, n, t) {
          var r = I.createTrackPixelIframeHtml(e, !1, "allow-scripts allow-same-origin"),
              i = document.createElement("div");
          i.innerHTML = r;
          var o = i.firstChild;
          n && I.isFn(n) && pe(o, t).then(n), I.insertElement(o, document, "html", !0);
        }

        function ye(e, n, t) {
          return t.indexOf(e) === n;
        }

        function we(e, n) {
          return e.concat(n);
        }

        function Ce(e, n) {
          return e[n];
        }

        function Ae(e, n) {
          for (var t in e) {
            if (e.hasOwnProperty(t) && e[t] === n) return t;
          }
        }

        function Te() {
          return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : pbjs.adUnits).map(function (e) {
            return e.bids.map(function (e) {
              return e.bidder;
            }).reduce(we, []);
          }).reduce(we, []).filter(ye);
        }

        function Ee() {
          if (window.googletag && ne(window.googletag.pubads) && ne(window.googletag.pubads().getSlots)) return !0;
        }

        function Oe() {
          if (window.apntag && ne(window.apntag.getTag)) return !0;
        }

        var ke = Ie("timeToRespond", function (e, n) {
          return e > n;
        }),
            Be = Ie("responseTimestamp", function (e, n) {
          return e > n;
        });
        Ie("responseTimestamp", function (e, n) {
          return e < n;
        });

        function Ie(e, n) {
          return function (t, r) {
            return t.cpm === r.cpm ? n(t[e], r[e]) ? r : t : t.cpm < r.cpm ? r : t;
          };
        }

        function je(e) {
          for (var n = e.length; n > 0;) {
            var t = Math.floor(Math.random() * n),
                r = e[--n];
            e[n] = e[t], e[t] = r;
          }

          return e;
        }

        function Se(e, n) {
          return (0, f.q9)(e, n && n.adUnitCode);
        }

        function Ue(e) {
          return s()(e);
        }

        function Pe() {
          try {
            return I.getWindowSelf() !== I.getWindowTop();
          } catch (e) {
            return !0;
          }
        }

        function _e() {
          return /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);
        }

        function Re(e, n) {
          if (e) return e.replace(/\$\{AUCTION_PRICE\}/g, n);
        }

        function Ne(e, n) {
          if (e && n && "string" == typeof n) return e.replace(/\${CLICKTHROUGH}/g, n);
        }

        function qe() {
          return new Date().getTime();
        }

        function Ze() {
          return window.performance && window.performance.now && window.performance.now() || 0;
        }

        function xe() {
          return !1 !== c.vc.getConfig("deviceAccess");
        }

        function De() {
          if (window.navigator.cookieEnabled || document.cookie.length) return !0;
        }

        function He(e, n) {
          if (n < 1) throw new Error("numRequiredCalls must be a positive number. Got ".concat(n));
          var t = 0;
          return function () {
            ++t === n && e.apply(this, arguments);
          };
        }

        function Fe(e, n) {
          return e.reduce(function (e, t) {
            return (e[t[n]] = e[t[n]] || []).push(t), e;
          }, {});
        }

        function Me(e, n) {
          return n.filter(function (n) {
            return e[n];
          }).reduce(function (n, t) {
            return Object.assign(n, (0, a.Z)({}, t, e[t]));
          }, {});
        }

        function ze(e) {
          var n = ["banner", "native", "video"];
          return !!Object.keys(e).every(function (e) {
            return (0, f.q9)(n, e);
          }) && (!e.video || !e.video.context || (0, f.q9)(["instream", "outstream", "adpod"], e.video.context));
        }

        function We(e, n, t) {
          return e.filter(function (e) {
            return e.code === n;
          }).map(function (e) {
            return e.bids;
          }).reduce(we, []).filter(function (e) {
            return e.bidder === t;
          }).map(function (e) {
            return e.params || {};
          });
        }

        var Ke = function Ke(e, n) {
          return e.getAdUnitPath() === n || e.getSlotElementId() === n;
        };

        function Le(e) {
          return function (n) {
            return Ke(e, n);
          };
        }

        function Ge(e) {
          var n;
          return Ee() && (n = (0, f.sE)(window.googletag.pubads().getSlots(), function (e) {
            return function (n) {
              return Ke(n, e);
            };
          }(e))), n;
        }

        function Je(e) {
          var n = Ge(e);
          return n ? {
            gptSlot: n.getAdUnitPath(),
            divId: n.getSlotElementId()
          } : {};
        }

        function Ve(e, n) {
          var t = Object.keys(e.mediaTypes || {
            banner: "banner"
          }).join(", ");
          return "\n    ".concat(e.code, " is a ").concat(t, " ad unit\n    containing bidders that don't support ").concat(t, ": ").concat(n, ".\n    This bidder won't fetch demand.\n  ");
        }

        function Qe(e) {
          return Number.isInteger ? Number.isInteger(e) : "number" == typeof e && isFinite(e) && Math.floor(e) === e;
        }

        function Ye(e, n) {
          return "object" !== (0, u.Z)(e) ? {} : n.reduce(function (t, r, i) {
            if ("function" == typeof r) return t;
            var o = r,
                a = r.match(/^(.+?)\sas\s(.+?)$/i);
            a && (r = a[1], o = a[2]);
            var u = e[r];
            return "function" == typeof n[i + 1] && (u = n[i + 1](u, t)), void 0 !== u && (t[o] = u), t;
          }, {});
        }

        function Xe(e, n) {
          return Object.keys(e).forEach(function (t) {
            var r, i;
            n[t] && (ne(e[t]) ? n[t] = e[t](n[t]) : n[t] = (r = e[t], i = n[t], "string" === r ? i && i.toString() : "number" === r ? Number(i) : i), isNaN(n[t]) && delete n.key);
          }), n;
        }

        function $e(e, n) {
          return re(e) && (!n || e.length === n) && e.every(function (e) {
            return Qe(e);
          });
        }

        function en(e) {
          return e ? e.replace(/^\?/, "").split("&").reduce(function (e, n) {
            var t = n.split("="),
                r = (0, i.Z)(t, 2),
                o = r[0],
                a = r[1];
            return /\[\]$/.test(o) ? (e[o = o.replace("[]", "")] = e[o] || [], e[o].push(a)) : e[o] = a || "", e;
          }, {}) : {};
        }

        function nn(e) {
          return Object.keys(e).map(function (n) {
            return Array.isArray(e[n]) ? e[n].map(function (e) {
              return "".concat(n, "[]=").concat(e);
            }).join("&") : "".concat(n, "=").concat(e[n]);
          }).join("&");
        }

        function tn(e, n) {
          var t = document.createElement("a");
          n && "noDecodeWholeURL" in n && n.noDecodeWholeURL ? t.href = e : t.href = decodeURIComponent(e);
          var r = n && "decodeSearchAsString" in n && n.decodeSearchAsString;
          return {
            href: t.href,
            protocol: (t.protocol || "").replace(/:$/, ""),
            hostname: t.hostname,
            port: +t.port,
            pathname: t.pathname.replace(/^(?!\/)/, "/"),
            search: r ? t.search : I.parseQS(t.search || ""),
            hash: (t.hash || "").replace(/^#/, ""),
            host: t.host || window.location.host
          };
        }

        function rn(e) {
          return (e.protocol || "http") + "://" + (e.host || e.hostname + (e.port ? ":".concat(e.port) : "")) + (e.pathname || "") + (e.search ? "?".concat(I.formatQS(e.search || "")) : "") + (e.hash ? "#".concat(e.hash) : "");
        }

        function on(e, n) {
          var t = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).checkTypes,
              r = void 0 !== t && t;
          if (e === n) return !0;
          if ("object" !== (0, u.Z)(e) || null === e || "object" !== (0, u.Z)(n) || null === n || r && e.constructor !== n.constructor) return !1;
          if (Object.keys(e).length !== Object.keys(n).length) return !1;

          for (var i in e) {
            if (!n.hasOwnProperty(i)) return !1;
            if (!on(e[i], n[i], {
              checkTypes: r
            })) return !1;
          }

          return !0;
        }

        function an(e) {
          for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) {
            t[r - 1] = arguments[r];
          }

          if (!t.length) return e;
          var i = t.shift();

          if (oe(e) && oe(i)) {
            var u = function u(n) {
              oe(i[n]) ? (e[n] || Object.assign(e, (0, a.Z)({}, n, {})), an(e[n], i[n])) : re(i[n]) ? e[n] ? re(e[n]) && i[n].forEach(function (t) {
                for (var r = 1, i = 0; i < e[n].length; i++) {
                  if (on(e[n][i], t)) {
                    r = 0;
                    break;
                  }
                }

                r && e[n].push(t);
              }) : Object.assign(e, (0, a.Z)({}, n, (0, o.Z)(i[n]))) : Object.assign(e, (0, a.Z)({}, n, i[n]));
            };

            for (var c in i) {
              u(c);
            }
          }

          return an.apply(void 0, [e].concat(t));
        }

        function un(e) {
          try {
            return JSON.parse(e);
          } catch (e) {}
        }

        function cn(e, n) {
          for (var t in n) {
            n.hasOwnProperty(t) && e.setAttribute(t, n[t]);
          }
        }

        var dn;
        dn = {
          "<": "\\u003C",
          ">": "\\u003E",
          "/": "\\u002F",
          "\\": "\\\\",
          "\b": "\\b",
          "\f": "\\f",
          "\n": "\\n",
          "\r": "\\r",
          "\t": "\\t",
          "\0": "\\0",
          "\u2028": "\\u2028",
          "\u2029": "\\u2029"
        };
      },
      9128: function _(e, n, t) {
        t.d(n, {
          Bf: function Bf() {
            return h;
          },
          V6: function V6() {
            return b;
          },
          g3: function g3() {
            return w;
          }
        });
        var r = t(3324),
            i = t(3193);

        function o(e, n) {
          var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

          if (!t) {
            if (Array.isArray(e) || (t = function (e, n) {
              if (!e) return;
              if ("string" == typeof e) return a(e, n);
              var t = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === t && e.constructor && (t = e.constructor.name);
              if ("Map" === t || "Set" === t) return Array.from(e);
              if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return a(e, n);
            }(e)) || n && e && "number" == typeof e.length) {
              t && (e = t);

              var r = 0,
                  i = function i() {};

              return {
                s: i,
                n: function n() {
                  return r >= e.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: e[r++]
                  };
                },
                e: function e(_e4) {
                  throw _e4;
                },
                f: i
              };
            }

            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          var o,
              u = !0,
              c = !1;
          return {
            s: function s() {
              t = t.call(e);
            },
            n: function n() {
              var e = t.next();
              return u = e.done, e;
            },
            e: function e(_e5) {
              c = !0, o = _e5;
            },
            f: function f() {
              try {
                u || null == t.return || t.return();
              } finally {
                if (c) throw o;
              }
            }
          };
        }

        function a(e, n) {
          (null == n || n > e.length) && (n = e.length);

          for (var t = 0, r = new Array(n); t < n; t++) {
            r[t] = e[t];
          }

          return r;
        }

        var u = "performanceMetrics",
            c = window.performance && window.performance.now ? function () {
          return window.performance.now();
        } : function () {
          return Date.now();
        },
            d = new WeakMap();

        function s() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = e.now,
              t = void 0 === n ? c : n,
              r = e.mkNode,
              i = void 0 === r ? g : r,
              o = e.mkTimer,
              a = void 0 === o ? l : o,
              u = e.mkRenamer,
              s = void 0 === u ? function (e) {
            return e;
          } : u,
              f = e.nodes,
              p = void 0 === f ? d : f;
          return function () {
            return function e(n) {
              var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (e) {
                return {
                  forEach: function forEach(n) {
                    n(e);
                  }
                };
              };
              r = s(r);
              var o,
                  u = (o = "timestamps", function (e) {
                return n.dfWalk({
                  visit: function visit(n, t) {
                    var r = t[o];
                    if (r.hasOwnProperty(e)) return r[e];
                  }
                });
              });

              function c(e, t) {
                var i = r(e);
                n.dfWalk({
                  follow: function follow(e, n) {
                    return n.propagate && (!e || !e.stopPropagation);
                  },
                  visit: function visit(e, n) {
                    i.forEach(function (r) {
                      null == e ? n.metrics[r] = t : (n.groups.hasOwnProperty(r) || (n.groups[r] = []), n.groups[r].push(t));
                    });
                  }
                });
              }

              function d(e) {
                return a(t, function (n) {
                  return c(e, n);
                });
              }

              function f() {
                var e = {};
                return n.dfWalk({
                  visit: function visit(n, t) {
                    e = Object.assign({}, !n || n.includeGroups ? t.groups : null, t.metrics, e);
                  }
                }), e;
              }

              var l = {
                startTiming: d,
                measureTime: function measureTime(e, n) {
                  return d(e).stopAfter(n)();
                },
                measureHookTime: function measureHookTime(e, n, t) {
                  var r = d(e);
                  return t(function (e) {
                    var n = r.stopBefore(e);
                    return n.bail = e.bail && r.stopBefore(e.bail), n.stopTiming = r, n.untimed = e, n;
                  }(n));
                },
                checkpoint: function checkpoint(e) {
                  n.timestamps[e] = t();
                },
                timeSince: function timeSince(e, n) {
                  var r = u(e),
                      i = null != r ? t() - r : null;
                  return null != n && c(n, i), i;
                },
                timeBetween: function timeBetween(e, n, t) {
                  var r = u(e),
                      i = u(n),
                      o = null != r && null != i ? i - r : null;
                  return null != t && c(t, o), o;
                },
                setMetric: c,
                getMetrics: f,
                fork: function fork() {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                      o = t.propagate,
                      a = void 0 === o || o,
                      u = t.stopPropagation,
                      c = void 0 !== u && u,
                      d = t.includeGroups;
                  return e(i([[n, {
                    propagate: a,
                    stopPropagation: c,
                    includeGroups: void 0 !== d && d
                  }]]), r);
                },
                join: function join(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                      r = t.propagate,
                      i = void 0 === r || r,
                      o = t.stopPropagation,
                      a = void 0 !== o && o,
                      u = t.includeGroups,
                      c = void 0 !== u && u,
                      d = p.get(e);
                  null != d && d.addParent(n, {
                    propagate: i,
                    stopPropagation: a,
                    includeGroups: c
                  });
                },
                newMetrics: function newMetrics() {
                  return e(n.newSibling(), r);
                },
                renameWith: function renameWith(t) {
                  return e(n, t);
                },
                toJSON: function toJSON() {
                  return f();
                }
              };
              return p.set(l, n), l;
            }(i([]));
          };
        }

        function f(e, n, t) {
          return function () {
            n && n();

            try {
              return e.apply(this, arguments);
            } finally {
              t && t();
            }
          };
        }

        function l(e, n) {
          var t = e(),
              r = !1;

          function i() {
            r || (n(e() - t), r = !0);
          }

          return i.stopBefore = function (e) {
            return f(e, i);
          }, i.stopAfter = function (e) {
            return f(e, null, i);
          }, i;
        }

        function g(e) {
          return {
            metrics: {},
            timestamps: {},
            groups: {},
            addParent: function addParent(n, t) {
              e.push([n, t]);
            },
            newSibling: function newSibling() {
              return g(e.slice());
            },
            dfWalk: function dfWalk() {
              var n,
                  t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  i = t.visit,
                  a = t.follow,
                  u = void 0 === a ? function () {
                return !0;
              } : a,
                  c = t.visited,
                  d = void 0 === c ? new Set() : c,
                  s = t.inEdge;

              if (!d.has(this)) {
                if (d.add(this), null != (n = i(s, this))) return n;
                var f,
                    l = o(e);

                try {
                  for (l.s(); !(f = l.n()).done;) {
                    var g = (0, r.Z)(f.value, 2),
                        p = g[0],
                        v = g[1];
                    if (u(s, v) && null != (n = p.dfWalk({
                      visit: i,
                      follow: u,
                      visited: d,
                      inEdge: v
                    }))) return n;
                  }
                } catch (e) {
                  l.e(e);
                } finally {
                  l.f();
                }
              }
            }
          };
        }

        var p = function () {
          var e = function e() {},
              n = function n() {
            return {};
          },
              t = {
            forEach: e
          },
              r = function r() {
            return null;
          };

          r.stopBefore = function (e) {
            return e;
          }, r.stopAfter = function (e) {
            return e;
          };
          var i = Object.defineProperties({
            dfWalk: e,
            newSibling: function newSibling() {
              return i;
            },
            addParent: e
          }, Object.fromEntries(["metrics", "timestamps", "groups"].map(function (e) {
            return [e, {
              get: n
            }];
          })));
          return s({
            now: function now() {
              return 0;
            },
            mkNode: function mkNode() {
              return i;
            },
            mkRenamer: function mkRenamer() {
              return function () {
                return t;
              };
            },
            mkTimer: function mkTimer() {
              return r;
            },
            nodes: {
              get: e,
              set: e
            }
          })();
        }(),
            v = !0;

        function h(e) {
          return v && e || p;
        }

        i.vc.getConfig(u, function (e) {
          v = !!e[u];
        });
        var m,
            b = (m = s(), function () {
          return v ? m() : p;
        });

        function y(e, n) {
          return function (t, r) {
            return function (i) {
              for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), u = 1; u < o; u++) {
                a[u - 1] = arguments[u];
              }

              var c = this;
              return h(n.apply(c, a)).measureHookTime(e + t, i, function (e) {
                return r.call.apply(r, [c, e].concat(a));
              });
            };
          };
        }

        var w = y("requestBids.", function (e) {
          return e.metrics;
        });
        y("addBidResponse.", function (e, n) {
          return n.metrics;
        });
      },
      8792: function _(e, n, t) {
        t.d(n, {
          P: function P() {
            return w;
          },
          Z: function Z() {
            return y;
          }
        });
        var r = t(3324),
            i = t(5671),
            o = t(3144),
            a = t(7326),
            u = t(8301),
            c = t(136),
            d = t(2963),
            s = t(1120),
            f = t(8916),
            l = t(2793),
            g = t(8640);

        function p(e) {
          var n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var t,
                r = (0, s.Z)(e);

            if (n) {
              var i = (0, s.Z)(this).constructor;
              t = Reflect.construct(r, arguments, i);
            } else t = r.apply(this, arguments);

            return (0, d.Z)(this, t);
          };
        }

        function v(e, n, t) {
          !function (e, n) {
            if (n.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }(e, n), n.set(e, t);
        }

        var h = new WeakMap(),
            m = new WeakMap(),
            b = new WeakMap(),
            y = function (e) {
          (0, c.Z)(t, e);
          var n = p(t);

          function t(e) {
            var r;
            (0, i.Z)(this, t);
            var o = [],
                u = [];

            function c(e, n) {
              return function (t) {
                if (!o.length) {
                  for (o.push(e, t); u.length;) {
                    u.shift()();
                  }

                  n(t);
                }
              };
            }

            return r = n.call(this, "function" != typeof e ? e : function (n, t) {
              var r,
                  i = c(1, t),
                  o = (r = c(0, n), function (e) {
                return "function" == typeof (null == e ? void 0 : e.then) ? e.then(r, i) : r(e);
              });

              try {
                e(o, i);
              } catch (e) {
                i(e);
              }
            }), v((0, a.Z)(r), h, {
              writable: !0,
              value: void 0
            }), v((0, a.Z)(r), m, {
              writable: !0,
              value: void 0
            }), v((0, a.Z)(r), b, {
              writable: !0,
              value: null
            }), (0, l.Z)((0, a.Z)(r), h, o), (0, l.Z)((0, a.Z)(r), m, u), r;
          }

          return (0, o.Z)(t, [{
            key: "then",
            value: function value(e, n) {
              var i = this;
              if ("function" == typeof n) for (var o = this; o;) {
                (0, u.Z)((0, s.Z)(t.prototype), "then", this).call(o, null, function () {
                  return null;
                });
                var a = (0, f.Z)(o, b);
                (0, l.Z)(o, b, null), o = a;
              }
              var c = (0, f.Z)(this, h),
                  d = new t(function (t, o) {
                var a = function a() {
                  var i = c[1],
                      a = 0 === c[0] ? [e, t] : [n, o],
                      u = (0, r.Z)(a, 2),
                      d = u[0],
                      s = u[1];

                  if ("function" == typeof d) {
                    try {
                      i = d(i);
                    } catch (e) {
                      return void o(e);
                    }

                    s = t;
                  }

                  s(i);
                };

                c.length ? a() : (0, f.Z)(i, m).push(a);
              });
              return (0, l.Z)(d, b, this), d;
            }
          }], [{
            key: "timeout",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
              return new t(function (n) {
                0 === e ? n() : setTimeout(n, e);
              });
            }
          }]), t;
        }((0, g.R)().Promise || Promise);

        function w() {
          var e,
              n,
              t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).promiseFactory;

          function r(e) {
            return function (n) {
              return e(n);
            };
          }

          return {
            promise: (void 0 === t ? function (e) {
              return new y(e);
            } : t)(function (t, r) {
              e = t, n = r;
            }),
            resolve: r(e),
            reject: r(n)
          };
        }
      },
      154: function _(e, n, t) {
        t.d(n, {
          Dn: function Dn() {
            return s;
          },
          LD: function LD() {
            return d;
          },
          gZ: function gZ() {
            return c;
          }
        });
        var r = t(265),
            i = t(4358),
            o = t(3193),
            a = t(2797),
            u = t(5383),
            c = "outstream",
            d = "instream";

        function s(e) {
          var n = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).index,
              t = void 0 === n ? u.K.index : n,
              i = (0, r.Z)(t.getMediaTypes(e), "video"),
              o = i && (0, r.Z)(i, "context"),
              a = i && (0, r.Z)(i, "useCacheKey"),
              c = t.getAdUnit(e);
          return f(e, c, i, o, a);
        }

        var f = (0, a.z3)("sync", function (e, n, t, r, a) {
          return t && (a || r !== c) ? o.vc.getConfig("cache.url") || !e.vastXml || e.vastUrl ? !(!e.vastUrl && !e.vastXml) : ((0, i.H)('\n        This bid contains only vastXml and will not work when a prebid cache url is not specified.\n        Try enabling prebid cache with pbjs.setConfig({ cache: {url: "..."} });\n      '), !1) : !(r === c && !a) || !!(e.renderer || n && n.renderer || t.renderer);
        }, "checkVideoBidSetup");
      },
      265: function _(e, n, t) {
        function r(e, n, t, r, i) {
          for (n = n.split ? n.split(".") : n, r = 0; r < n.length; r++) {
            e = e ? e[n[r]] : i;
          }

          return e === i ? t : e;
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      1432: function _(e) {
        /*
        * @license MIT
        * Fun Hooks v0.9.10
        * (c) @snapwich
        */
        u.SYNC = 1, u.ASYNC = 2, u.QUEUE = 4;
        var n = "fun-hooks";
        var t = Object.freeze({
          useProxy: !0,
          ready: 0
        }),
            r = new WeakMap(),
            i = "2,1,0" === [1].reduce(function (e, n, t) {
          return [e, n, t];
        }, 2).toString() ? Array.prototype.reduce : function (e, n) {
          var t,
              r = Object(this),
              i = r.length >>> 0,
              o = 0;
          if (n) t = n;else {
            for (; o < i && !(o in r);) {
              o++;
            }

            t = r[o++];
          }

          for (; o < i;) {
            o in r && (t = e(t, r[o], o, r)), o++;
          }

          return t;
        };

        function o(e, n) {
          return Array.prototype.slice.call(e, n);
        }

        var a = Object.assign || function (e) {
          return i.call(o(arguments, 1), function (e, n) {
            return n && Object.keys(n).forEach(function (t) {
              e[t] = n[t];
            }), e;
          }, e);
        };

        function u(e) {
          var c,
              d = {},
              s = [];

          function f(e, n) {
            return "function" == typeof e ? v.call(null, "sync", e, n) : "string" == typeof e && "function" == typeof n ? v.apply(null, arguments) : "object" == (0, _typeof2.default)(e) ? l.apply(null, arguments) : void 0;
          }

          function l(e, n, t) {
            var r = !0;
            void 0 === n && (n = Object.getOwnPropertyNames(e), r = !1);
            var i = {},
                o = ["constructor"];

            do {
              (n = n.filter(function (n) {
                return !("function" != typeof e[n] || -1 !== o.indexOf(n) || n.match(/^_/));
              })).forEach(function (n) {
                var r = n.split(":"),
                    o = r[0],
                    a = r[1] || "sync";

                if (!i[o]) {
                  var u = e[o];
                  i[o] = e[o] = v(a, u, t ? [t, o] : void 0);
                }
              }), e = Object.getPrototypeOf(e);
            } while (r && e);

            return i;
          }

          function g(e) {
            var t = Array.isArray(e) ? e : e.split(".");
            return i.call(t, function (r, i, o) {
              var a = r[i],
                  u = !1;
              return a || (o === t.length - 1 ? (c || s.push(function () {
                u || console.warn(n + ": referenced '" + e + "' but it was never created");
              }), r[i] = p(function (e) {
                r[i] = e, u = !0;
              })) : r[i] = {});
            }, d);
          }

          function p(e) {
            var n = [],
                t = [],
                i = function i() {},
                o = {
              before: function before(e, t) {
                return c.call(this, n, "before", e, t);
              },
              after: function after(e, n) {
                return c.call(this, t, "after", e, n);
              },
              getHooks: function getHooks(e) {
                var r = n.concat(t);
                "object" == (0, _typeof2.default)(e) && (r = r.filter(function (n) {
                  return Object.keys(e).every(function (t) {
                    return n[t] === e[t];
                  });
                }));

                try {
                  a(r, {
                    remove: function remove() {
                      return r.forEach(function (e) {
                        e.remove();
                      }), this;
                    }
                  });
                } catch (e) {
                  console.error("error adding `remove` to array, did you modify Array.prototype?");
                }

                return r;
              },
              removeAll: function removeAll() {
                return this.getHooks().remove();
              }
            },
                u = {
              install: function install(r, o, a) {
                this.type = r, i = a, a(n, t), e && e(o);
              }
            };

            return r.set(o.after, u), o;

            function c(e, r, o, a) {
              var u = {
                hook: o,
                type: r,
                priority: a || 10,
                remove: function remove() {
                  var r = e.indexOf(u);
                  -1 !== r && (e.splice(r, 1), i(n, t));
                }
              };
              return e.push(u), e.sort(function (e, n) {
                return n.priority - e.priority;
              }), i(n, t), this;
            }
          }

          function v(t, i, d) {
            var f = i.after && r.get(i.after);

            if (f) {
              if (f.type !== t) throw n + ": recreated hookable with different type";
              return i;
            }

            var l,
                v,
                h = d ? g(d) : p(),
                m = {
              get: function get(e, n) {
                return h[n] || Reflect.get.apply(Reflect, arguments);
              }
            };
            return c || s.push(b), e.useProxy && "function" == typeof Proxy && Proxy.revocable ? v = new Proxy(i, m) : (v = function v() {
              return m.apply ? m.apply(i, this, o(arguments)) : i.apply(this, arguments);
            }, a(v, h)), r.get(v.after).install(t, v, function (e, n) {
              var r,
                  i = [];
              e.length || n.length ? (e.forEach(a), r = i.push(void 0) - 1, n.forEach(a), l = function l(e, n, a) {
                var u,
                    c = 0,
                    d = "async" === t && "function" == typeof a[a.length - 1] && a.pop();

                function s(e) {
                  "sync" === t ? u = e : d && d.apply(null, arguments);
                }

                function f(e) {
                  if (i[c]) {
                    var r = o(arguments);
                    return f.bail = s, r.unshift(f), i[c++].apply(n, r);
                  }

                  "sync" === t ? u = e : d && d.apply(null, arguments);
                }

                return i[r] = function () {
                  var r = o(arguments, 1);
                  "async" === t && d && (delete f.bail, r.push(f));
                  var i = e.apply(n, r);
                  "sync" === t && f(i);
                }, f.apply(null, a), u;
              }) : l = void 0;

              function a(e) {
                i.push(e.hook);
              }

              b();
            }), v;

            function b() {
              !c && ("sync" !== t || e.ready & u.SYNC) && ("async" !== t || e.ready & u.ASYNC) ? "sync" !== t && e.ready & u.QUEUE ? m.apply = function () {
                var e = arguments;
                s.push(function () {
                  v.apply(e[1], e[2]);
                });
              } : m.apply = function () {
                throw n + ": hooked function not ready";
              } : m.apply = l;
            }
          }

          return (e = a({}, t, e)).ready ? f.ready = function () {
            c = !0, function (e) {
              for (var n; n = e.shift();) {
                n();
              }
            }(s);
          } : c = !0, f.get = g, f;
        }

        e.exports = u;
      },
      7079: function _(e) {
        e.exports = function e(n) {
          var t = Array.isArray(n) ? [] : {};

          for (var r in n) {
            var i = n[r];
            t[r] = i && "object" == (0, _typeof2.default)(i) ? e(i) : i;
          }

          return t;
        };
      },
      907: function _(e, n, t) {
        function r(e, n) {
          (null == n || n > e.length) && (n = e.length);

          for (var t = 0, r = new Array(n); t < n; t++) {
            r[t] = e[t];
          }

          return r;
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      3878: function _(e, n, t) {
        function r(e) {
          if (Array.isArray(e)) return e;
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      5057: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return i;
          }
        });
        var r = t(907);

        function i(e) {
          if (Array.isArray(e)) return (0, r.Z)(e);
        }
      },
      7326: function _(e, n, t) {
        function r(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      6983: function _(e, n, t) {
        function r(e, n) {
          return n.get ? n.get.call(e) : n.value;
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      6011: function _(e, n, t) {
        function r(e, n, t) {
          if (n.set) n.set.call(e, t);else {
            if (!n.writable) throw new TypeError("attempted to set read only private field");
            n.value = t;
          }
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      5671: function _(e, n, t) {
        function r(e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      1519: function _(e, n, t) {
        function r(e, n, t) {
          if (!n.has(e)) throw new TypeError("attempted to " + t + " private field on non-instance");
          return n.get(e);
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      8916: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return o;
          }
        });
        var r = t(6983),
            i = t(1519);

        function o(e, n) {
          var t = (0, i.Z)(e, n, "get");
          return (0, r.Z)(e, t);
        }
      },
      2793: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return o;
          }
        });
        var r = t(6011),
            i = t(1519);

        function o(e, n, t) {
          var o = (0, i.Z)(e, n, "set");
          return (0, r.Z)(e, o, t), t;
        }
      },
      3144: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return o;
          }
        });
        var r = t(7343);

        function i(e, n) {
          for (var t = 0; t < n.length; t++) {
            var i = n[t];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, (0, r.Z)(i.key), i);
          }
        }

        function o(e, n, t) {
          return n && i(e.prototype, n), t && i(e, t), Object.defineProperty(e, "prototype", {
            writable: !1
          }), e;
        }
      },
      4942: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return i;
          }
        });
        var r = t(7343);

        function i(e, n, t) {
          return (n = (0, r.Z)(n)) in e ? Object.defineProperty(e, n, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[n] = t, e;
        }
      },
      8301: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return i;
          }
        });
        var r = t(8415);

        function i() {
          return i = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, n, t) {
            var i = (0, r.Z)(e, n);

            if (i) {
              var o = Object.getOwnPropertyDescriptor(i, n);
              return o.get ? o.get.call(arguments.length < 3 ? e : t) : o.value;
            }
          }, i.apply(this, arguments);
        }
      },
      1120: function _(e, n, t) {
        function r(e) {
          return r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, r(e);
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      136: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return i;
          }
        });
        var r = t(9611);

        function i(e, n) {
          if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(n && n.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), n && (0, r.Z)(e, n);
        }
      },
      9199: function _(e, n, t) {
        function r(e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      1902: function _(e, n, t) {
        function r(e, n) {
          var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

          if (null != t) {
            var r,
                i,
                o,
                a,
                u = [],
                c = !0,
                d = !1;

            try {
              if (o = (t = t.call(e)).next, 0 === n) {
                if (Object(t) !== t) return;
                c = !1;
              } else for (; !(c = (r = o.call(t)).done) && (u.push(r.value), u.length !== n); c = !0) {
                ;
              }
            } catch (e) {
              d = !0, i = e;
            } finally {
              try {
                if (!c && null != t.return && (a = t.return(), Object(a) !== a)) return;
              } finally {
                if (d) throw i;
              }
            }

            return u;
          }
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      5267: function _(e, n, t) {
        function r() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      2786: function _(e, n, t) {
        function r() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      2963: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return o;
          }
        });
        var r = t(1002),
            i = t(7326);

        function o(e, n) {
          if (n && ("object" === (0, r.Z)(n) || "function" == typeof n)) return n;
          if (void 0 !== n) throw new TypeError("Derived constructors may only return object or undefined");
          return (0, i.Z)(e);
        }
      },
      9611: function _(e, n, t) {
        function r(e, n) {
          return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, n) {
            return e.__proto__ = n, e;
          }, r(e, n);
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      3324: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return u;
          }
        });
        var r = t(3878),
            i = t(1902),
            o = t(181),
            a = t(5267);

        function u(e, n) {
          return (0, r.Z)(e) || (0, i.Z)(e, n) || (0, o.Z)(e, n) || (0, a.Z)();
        }
      },
      8415: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return i;
          }
        });
        var r = t(1120);

        function i(e, n) {
          for (; !Object.prototype.hasOwnProperty.call(e, n) && null !== (e = (0, r.Z)(e));) {
            ;
          }

          return e;
        }
      },
      9062: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return u;
          }
        });
        var r = t(5057),
            i = t(9199),
            o = t(181),
            a = t(2786);

        function u(e) {
          return (0, r.Z)(e) || (0, i.Z)(e) || (0, o.Z)(e) || (0, a.Z)();
        }
      },
      5512: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return i;
          }
        });
        var r = t(1002);

        function i(e, n) {
          if ("object" !== (0, r.Z)(e) || null === e) return e;
          var t = e[Symbol.toPrimitive];

          if (void 0 !== t) {
            var i = t.call(e, n || "default");
            if ("object" !== (0, r.Z)(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === n ? String : Number)(e);
        }
      },
      7343: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return o;
          }
        });
        var r = t(1002),
            i = t(5512);

        function o(e) {
          var n = (0, i.Z)(e, "string");
          return "symbol" === (0, r.Z)(n) ? n : String(n);
        }
      },
      1002: function _(e, n, t) {
        function r(e) {
          return r = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (e) {
            return (0, _typeof2.default)(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(e);
          }, r(e);
        }

        t.d(n, {
          Z: function Z() {
            return r;
          }
        });
      },
      181: function _(e, n, t) {
        t.d(n, {
          Z: function Z() {
            return i;
          }
        });
        var r = t(907);

        function i(e, n) {
          if (e) {
            if ("string" == typeof e) return (0, r.Z)(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, r.Z)(e, n) : void 0;
          }
        }
      },
      6475: function _(e, n, t) {
        function r(e, n, t) {
          n.split && (n = n.split("."));

          for (var r, i, o = 0, a = n.length, u = e; o < a && "__proto__" !== (i = n[o++]) && "constructor" !== i && "prototype" !== i;) {
            u = u[i] = o === a ? t : (0, _typeof2.default)(r = u[i]) == (0, _typeof2.default)(n) ? r : 0 * n[o] != 0 || ~("" + n[o]).indexOf(".") ? {} : [];
          }
        }

        t.d(n, {
          N: function N() {
            return r;
          }
        });
      },
      5644: function _(e) {
        e.exports = JSON.parse('{"k2":{"xn":"adserverTargeting","zF":"standard"},"f":"pbjs_debug","Q_":{"Q":1,"H":2},"FP":{"AUCTION_INIT":"auctionInit","AUCTION_END":"auctionEnd","BID_ADJUSTMENT":"bidAdjustment","BID_TIMEOUT":"bidTimeout","BID_REQUESTED":"bidRequested","BID_RESPONSE":"bidResponse","BID_REJECTED":"bidRejected","NO_BID":"noBid","BID_WON":"bidWon","BIDDER_DONE":"bidderDone","BIDDER_ERROR":"bidderError","SET_TARGETING":"setTargeting","BEFORE_REQUEST_BIDS":"beforeRequestBids","BEFORE_BIDDER_HTTP":"beforeBidderHttp","REQUEST_BIDS":"requestBids","ADD_AD_UNITS":"addAdUnits","AD_RENDER_FAILED":"adRenderFailed","AD_RENDER_SUCCEEDED":"adRenderSucceeded","TCF2_ENFORCEMENT":"tcf2Enforcement","AUCTION_DEBUG":"auctionDebug","BID_VIEWABLE":"bidViewable","STALE_RENDER":"staleRender","BILLABLE_EVENT":"billableEvent"},"q_":{"PREVENT_WRITING_ON_MAIN_DOCUMENT":"preventWritingOnMainDocument","NO_AD":"noAd","EXCEPTION":"exception","CANNOT_FIND_AD":"cannotFindAd","MISSING_DOC_OR_ADID":"missingDocOrAdid"},"aI":{"bidWon":"adUnitCode"},"Ql":{"yE":"low","M2":"medium","lj":"high","B7":"auto","uN":"dense","qN":"custom"},"TD":{"BIDDER":"hb_bidder","AD_ID":"hb_adid","PRICE_BUCKET":"hb_pb","SIZE":"hb_size","DEAL":"hb_deal","SOURCE":"hb_source","FORMAT":"hb_format","UUID":"hb_uuid","CACHE_ID":"hb_cache_id","CACHE_HOST":"hb_cache_host","ADOMAIN":"hb_adomain"},"kF":{"BIDDER":"hb_bidder","AD_ID":"hb_adid","PRICE_BUCKET":"hb_pb","SIZE":"hb_size","DEAL":"hb_deal","FORMAT":"hb_format","UUID":"hb_uuid","CACHE_HOST":"hb_cache_host"},"FY":{"title":"hb_native_title","body":"hb_native_body","body2":"hb_native_body2","privacyLink":"hb_native_privacy","privacyIcon":"hb_native_privicon","sponsoredBy":"hb_native_brand","image":"hb_native_image","icon":"hb_native_icon","clickUrl":"hb_native_linkurl","displayUrl":"hb_native_displayurl","cta":"hb_native_cta","rating":"hb_native_rating","address":"hb_native_address","downloads":"hb_native_downloads","likes":"hb_native_likes","phone":"hb_native_phone","price":"hb_native_price","salePrice":"hb_native_saleprice","rendererUrl":"hb_renderer_url","adTemplate":"hb_adTemplate"},"os":{"YZ":"s2s"},"UE":{"CK":"targetingSet","fe":"rendered","G9":"bidRejected"},"Gw":{"UI":"Bid has missing or invalid properties","Gp":"Invalid request ID","Dg":"Bidder code is not allowed by allowedAlternateBidderCodes / allowUnknownBidderCodes"},"V1":{"body":"desc","body2":"desc2","sponsoredBy":"sponsored","cta":"ctatext","rating":"rating","address":"address","downloads":"downloads","likes":"likes","phone":"phone","price":"price","salePrice":"saleprice","displayUrl":"displayurl"},"s$":{"sponsored":1,"desc":2,"rating":3,"likes":4,"downloads":5,"price":6,"saleprice":7,"phone":8,"address":9,"desc2":10,"displayurl":11,"ctatext":12},"oF":{"ICON":1,"MAIN":3},"zA":["privacyLink","clickUrl","sendTargetingKeys","adTemplate","rendererUrl","type"]}');
      }
    },
        t = {};

    function r(e) {
      var i = t[e];
      if (void 0 !== i) return i.exports;
      var o = t[e] = {
        exports: {}
      };
      return n[e](o, o.exports, r), o.exports;
    }

    r.m = n, e = [], r.O = function (n, t, i, o) {
      if (!t) {
        var a = 1 / 0;

        for (s = 0; s < e.length; s++) {
          t = e[s][0], i = e[s][1], o = e[s][2];

          for (var u = !0, c = 0; c < t.length; c++) {
            (!1 & o || a >= o) && Object.keys(r.O).every(function (e) {
              return r.O[e](t[c]);
            }) ? t.splice(c--, 1) : (u = !1, o < a && (a = o));
          }

          if (u) {
            e.splice(s--, 1);
            var d = i();
            void 0 !== d && (n = d);
          }
        }

        return n;
      }

      o = o || 0;

      for (var s = e.length; s > 0 && e[s - 1][2] > o; s--) {
        e[s] = e[s - 1];
      }

      e[s] = [t, i, o];
    }, r.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(n, {
        a: n
      }), n;
    }, r.d = function (e, n) {
      for (var t in n) {
        r.o(n, t) && !r.o(e, t) && Object.defineProperty(e, t, {
          enumerable: !0,
          get: n[t]
        });
      }
    }, r.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, function () {
      var e = {
        602: 0
      };

      r.O.j = function (n) {
        return 0 === e[n];
      };

      var n = function n(_n, t) {
        var i,
            o,
            a = t[0],
            u = t[1],
            c = t[2],
            d = 0;

        if (a.some(function (n) {
          return 0 !== e[n];
        })) {
          for (i in u) {
            r.o(u, i) && (r.m[i] = u[i]);
          }

          if (c) var s = c(r);
        }

        for (_n && _n(t); d < a.length; d++) {
          o = a[d], r.o(e, o) && e[o] && e[o][0](), e[o] = 0;
        }

        return r.O(s);
      },
          t = self.pbjsChunk = self.pbjsChunk || [];

      t.forEach(n.bind(null, 0)), t.push = n.bind(null, t.push.bind(t));
    }();
    var i = {};
    !function () {
      var e = r(3324),
          n = r(4942),
          t = r(8640),
          i = r(4358),
          o = r(265),
          a = r(6475),
          u = r(2021),
          c = r(59),
          d = r(5644),
          s = r(5383),
          f = r(4614),
          l = r(5706),
          g = r(3193),
          p = d.FP,
          v = p.AD_RENDER_FAILED,
          h = p.AD_RENDER_SUCCEEDED;

      function m(e) {
        var n = e.reason,
            t = e.message,
            r = e.bid,
            o = e.id,
            a = {
          reason: n,
          message: t
        };
        r && (a.bid = r), o && (a.adId = o), (0, i.H)(t), u.j8(v, a);
      }

      function b(e) {
        var n = e.doc,
            t = e.bid,
            r = e.id,
            i = {
          doc: n
        };
        t && (i.bid = t), r && (i.adId = r), u.j8(h, i);
      }

      var y = d.FP.BID_WON,
          w = d.FP.STALE_RENDER,
          C = new WeakSet(),
          A = {
        "Prebid Request": function PrebidRequest(e, n, t) {
          if (null == t) return void m({
            reason: d.q_.CANNOT_FIND_AD,
            message: "Cannot find ad '".concat(n.adId, "' for cross-origin render request"),
            id: n.adId
          });
          if (t.status === d.UE.fe && ((0, i.yN)("Ad id ".concat(t.adId, " has been rendered before")), u.j8(w, t), (0, o.Z)(g.vc.getConfig("auctionOptions"), "suppressStaleRender"))) return;

          try {
            !function (e, n) {
              var t = e.adId,
                  r = e.ad,
                  o = e.adUrl,
                  a = e.width,
                  u = e.height,
                  c = e.renderer,
                  d = e.cpm,
                  s = e.originalCpm;
              (0, l.Pd)(c) ? (0, l._U)(c, e) : t && (E(e), n({
                message: "Prebid Response",
                ad: (0, i.ew)(r, s || d),
                adUrl: (0, i.ew)(o, s || d),
                adId: t,
                width: a,
                height: u
              }));
            }(t, e);
          } catch (e) {
            return void m({
              reason: d.q_.EXCEPTION,
              message: e.message,
              id: n.adId,
              bid: t
            });
          }

          s.K.addWinningBid(t), u.j8(y, t);
        },
        "Prebid Event": function PrebidEvent(e, n, t) {
          if (null == t) return void (0, i.H)("Cannot find ad '".concat(n.adId, "' for x-origin event request"));
          if (t.status !== d.UE.fe) return void (0, i.yN)("Received x-origin event request without corresponding render request for ad '".concat(n.adId, "'"));

          switch (n.event) {
            case d.FP.AD_RENDER_FAILED:
              m({
                bid: t,
                id: n.adId,
                reason: n.info.reason,
                message: n.info.message
              });
              break;

            case d.FP.AD_RENDER_SUCCEEDED:
              b({
                doc: null,
                bid: t,
                id: n.adId
              });
              break;

            default:
              (0, i.H)("Received x-origin event request for unsupported event: '".concat(n.event, "' (adId: '").concat(n.adId, "')"));
          }
        }
      };

      function T(e) {
        var n = e.message ? "message" : "data",
            t = {};

        try {
          t = JSON.parse(e[n]);
        } catch (e) {
          return;
        }

        if (t && t.adId && t.message) {
          var r = (0, f.sE)(s.K.getBidsReceived(), function (e) {
            return e.adId === t.adId;
          });
          A.hasOwnProperty(t.message) && A[t.message](function (e) {
            return null == e.origin && 0 === e.ports.length ? function () {
              var e = "Cannot post message to a frame with null origin. Please update creatives to use MessageChannel, see https://github.com/prebid/Prebid.js/issues/7870";
              throw (0, i.H)(e), new Error(e);
            } : e.ports.length > 0 ? function (n) {
              e.ports[0].postMessage(JSON.stringify(n));
            } : function (n) {
              e.source.postMessage(JSON.stringify(n), e.origin);
            };
          }(e), t, r);
        }
      }

      function E(e) {
        var n = e.adId,
            t = e.adUnitCode,
            r = e.width,
            o = e.height;
        ["div", "iframe"].forEach(function (e) {
          var a = function (e) {
            var r = function (e, n) {
              return (0, i.T9)() ? function (e) {
                var n = (0, f.sE)(window.googletag.pubads().getSlots(), function (n) {
                  return (0, f.sE)(n.getTargetingKeys(), function (t) {
                    return (0, f.q9)(n.getTargeting(t), e);
                  });
                });
                return n ? n.getSlotElementId() : null;
              }(e) : (0, i.X4)() ? function (e) {
                var n = window.apntag.getTag(e);
                return n && n.targetId;
              }(n) : n;
            }(n, t),
                o = document.getElementById(r);

            return o && o.querySelector(e);
          }(e + ':not([style*="display: none"])');

          if (a) {
            var u = a.style;
            u.width = r ? r + "px" : "100%", u.height = o + "px";
          } else (0, i.yN)("Unable to locate matching page element for adUnitCode ".concat(t, ".  Can't resize it to ad's dimensions.  Please review setup."));
        });
      }

      Object.assign(A, {
        "Prebid Native": function PrebidNative(e, n, t) {
          if (null == t) return void (0, i.H)("Cannot find ad '".concat(n.adId, "' for x-origin event request"));
          C.has(t) || (C.add(t), s.K.addWinningBid(t), u.j8(y, t));

          switch (n.action) {
            case "assetRequest":
              e((0, c.eK)(n, t));
              break;

            case "allAssetRequest":
              e((0, c.JL)(n, t));
              break;

            case "resizeNativeHeight":
              t.height = n.height, t.width = n.width, E(t);
              break;

            default:
              (0, c.e6)(n, t);
          }
        }
      });
      var O = r(1974),
          k = r(9062),
          B = r(4679),
          I = r(2797),
          j = r(5975),
          S = [],
          U = 1;
      g.vc.getConfig("ttlBuffer", function (e) {
        "number" == typeof e.ttlBuffer ? U = e.ttlBuffer : (0, i.H)("Invalid value for ttlBuffer", e.ttlBuffer);
      });
      var P = "targetingControls.allowTargetingKeys",
          _ = "targetingControls.addTargetingKeys",
          R = 'Only one of "'.concat(P, '" or "').concat(_, '" can be set'),
          N = Object.keys(d.TD).map(function (e) {
        return d.TD[e];
      }),
          q = {
        isActualBid: function isActualBid(e) {
          return e.getStatusCode() === d.Q_.Q;
        },
        isBidNotExpired: function isBidNotExpired(e) {
          return e.responseTimestamp + 1e3 * (e.ttl - (e.hasOwnProperty("ttlBuffer") ? e.ttlBuffer : U)) > (0, i.AB)();
        },
        isUnusedBid: function isUnusedBid(e) {
          return e && (e.status && !(0, f.q9)([d.UE.fe], e.status) || !e.status);
        }
      };

      function Z(e) {
        return !Object.values(q).some(function (n) {
          return !n(e);
        });
      }

      var x = (0, I.z3)("sync", function (e, n) {
        var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;

        if (!(arguments.length > 3 && void 0 !== arguments[3] && arguments[3])) {
          var r = [],
              o = g.vc.getConfig("sendBidsControl.dealPrioritization"),
              a = (0, i.vM)(e, "adUnitCode");
          return Object.keys(a).forEach(function (e) {
            var u = [],
                c = (0, i.vM)(a[e], "bidderCode");
            Object.keys(c).forEach(function (e) {
              return u.push(c[e].reduce(n));
            }), t > 0 ? (u = o ? u.sort(D(!0)) : u.sort(function (e, n) {
              return n.cpm - e.cpm;
            }), r.push.apply(r, (0, k.Z)(u.slice(0, t)))) : r.push.apply(r, (0, k.Z)(u));
          }), r;
        }

        return e;
      });

      function D() {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        return function (n, t) {
          return void 0 !== n.adserverTargeting.hb_deal && void 0 === t.adserverTargeting.hb_deal ? -1 : void 0 === n.adserverTargeting.hb_deal && void 0 !== t.adserverTargeting.hb_deal ? 1 : e ? t.cpm - n.cpm : t.adserverTargeting.hb_pb - n.adserverTargeting.hb_pb;
        };
      }

      var H = function (e) {
        var t = {},
            r = {};

        function a(e, n) {
          return e.adserverTargeting && n && ((0, i.kJ)(n) && (0, f.q9)(n, e.adUnitCode) || "string" == typeof n && e.adUnitCode === n);
        }

        function u(n) {
          return "string" == typeof n ? [n] : (0, i.kJ)(n) ? n : e.getAdUnitCodes() || [];
        }

        function s() {
          var n = e.getBidsReceived();

          if (g.vc.getConfig("useBidCache")) {
            var t = g.vc.getConfig("bidCacheFilterFunction");
            "function" == typeof t && (n = n.filter(function (e) {
              return r[e.adUnitCode] === e.auctionId || !!t(e);
            }));
          } else n = n.filter(function (e) {
            return r[e.adUnitCode] === e.auctionId;
          });

          return n = n.filter(function (e) {
            return (0, o.Z)(e, "video.context") !== B.Oh;
          }).filter(Z), x(n, i.K$);
        }

        function l(e, r) {
          var i = t.getWinningBids(e, r),
              o = p();
          return i = i.map(function (e) {
            return (0, n.Z)({}, e.adUnitCode, Object.keys(e.adserverTargeting).filter(function (n) {
              return void 0 === e.sendStandardTargeting || e.sendStandardTargeting || -1 === o.indexOf(n);
            }).reduce(function (t, r) {
              var i = [e.adserverTargeting[r]],
                  o = (0, n.Z)({}, r.substring(0, 20), i);

              if (r === d.TD.DEAL) {
                var a = "".concat(r, "_").concat(e.bidderCode).substring(0, 20),
                    u = (0, n.Z)({}, a, i);
                return [].concat((0, k.Z)(t), [o, u]);
              }

              return [].concat((0, k.Z)(t), [o]);
            }, []));
          }), i;
        }

        function p() {
          return e.getStandardBidderAdServerTargeting().map(function (e) {
            return e.key;
          }).concat(N).filter(i.tT);
        }

        function v(e, n, t, r) {
          return Object.keys(n.adserverTargeting).filter(h()).forEach(function (t) {
            e.length && e.filter(function (e) {
              return function (t) {
                return t.adUnitCode === n.adUnitCode && t.adserverTargeting[e];
              };
            }(t)).forEach(function (e) {
              return function (t) {
                (0, i.kJ)(t.adserverTargeting[e]) || (t.adserverTargeting[e] = [t.adserverTargeting[e]]), t.adserverTargeting[e] = t.adserverTargeting[e].concat(n.adserverTargeting[e]).filter(i.tT), delete n.adserverTargeting[e];
              };
            }(t));
          }), e.push(n), e;
        }

        function h() {
          var e = p();
          return e = e.concat(c.xc), function (n) {
            return -1 === e.indexOf(n);
          };
        }

        function m(e) {
          return (0, n.Z)({}, e.adUnitCode, Object.keys(e.adserverTargeting).filter(h()).map(function (t) {
            return (0, n.Z)({}, t.substring(0, 20), [e.adserverTargeting[t]]);
          }));
        }

        function b(e, t) {
          return t.map(function (t) {
            return (0, n.Z)({}, "".concat(t, "_").concat(e.bidderCode).substring(0, 20), [e.adserverTargeting[t]]);
          });
        }

        return t.setLatestAuctionForAdUnit = function (e, n) {
          r[e] = n;
        }, t.resetPresetTargeting = function (n, t) {
          if ((0, i.T9)()) {
            var r = u(n),
                o = e.getAdUnits().filter(function (e) {
              return (0, f.q9)(r, e.code);
            }),
                a = S.reduce(function (e, n) {
              return e[n] = null, e;
            }, {});
            window.googletag.pubads().getSlots().forEach(function (e) {
              var n = (0, i.LQ)(t) && t(e);
              o.forEach(function (t) {
                (t.code === e.getAdUnitPath() || t.code === e.getSlotElementId() || (0, i.LQ)(n) && n(t.code)) && e.updateTargetingFromMap(a);
              });
            });
          }
        }, t.resetPresetTargetingAST = function (e) {
          u(e).forEach(function (e) {
            var n = window.apntag.getTag(e);

            if (n && n.keywords) {
              var t = Object.keys(n.keywords),
                  r = {};
              t.forEach(function (e) {
                (0, f.q9)(S, e.toLowerCase()) || (r[e] = n.keywords[e]);
              }), window.apntag.modifyTag(e, {
                keywords: r
              });
            }
          });
        }, t.getAllTargeting = function (t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s(),
              p = u(t),
              h = l(p, r).concat(function (e, n) {
            return n.filter(function (n) {
              return (0, f.q9)(e, n.adUnitCode);
            }).map(function (e) {
              return Object.assign({}, e);
            }).reduce(v, []).map(m).filter(function (e) {
              return e;
            });
          }(p, r)).concat(g.vc.getConfig("enableSendAllBids") ? function (e, t) {
            var r = N.concat(c.xc),
                o = g.vc.getConfig("sendBidsControl.bidLimit"),
                u = x(t, i.ZH, o),
                s = g.vc.getConfig("targetingControls.allowSendAllBidsTargetingKeys"),
                f = s ? s.map(function (e) {
              return d.TD[e];
            }) : r;
            return u.map(function (t) {
              if (a(t, e)) return (0, n.Z)({}, t.adUnitCode, b(t, r.filter(function (e) {
                return void 0 !== t.adserverTargeting[e] && -1 !== f.indexOf(e);
              })));
            }).filter(function (e) {
              return e;
            });
          }(p, r) : function (e, t) {
            if (!0 === g.vc.getConfig("targetingControls.alwaysIncludeDeals")) {
              var r = N.concat(c.xc);
              return x(t, i.ZH).map(function (t) {
                if (t.dealId && a(t, e)) return (0, n.Z)({}, t.adUnitCode, b(t, r.filter(function (e) {
                  return void 0 !== t.adserverTargeting[e];
                })));
              }).filter(function (e) {
                return e;
              });
            }

            return [];
          }(p, r)).concat(function (t) {
            function r(e) {
              return (0, o.Z)(e, d.k2.xn);
            }

            function a(e) {
              var t = r(e);
              return Object.keys(t).map(function (e) {
                return (0, i.d8)(t[e]) && (t[e] = t[e].split(",").map(function (e) {
                  return e.trim();
                })), (0, i.kJ)(t[e]) || (t[e] = [t[e]]), (0, n.Z)({}, e, t[e]);
              });
            }

            return e.getAdUnits().filter(function (e) {
              return (0, f.q9)(t, e.code) && r(e);
            }).map(function (e) {
              return (0, n.Z)({}, e.code, a(e));
            });
          }(p));
          h.map(function (e) {
            Object.keys(e).map(function (n) {
              e[n].map(function (e) {
                -1 === S.indexOf(Object.keys(e)[0]) && (S = Object.keys(e).concat(S));
              });
            });
          });
          var y = Object.keys(Object.assign({}, d.kF, d.FY)),
              w = g.vc.getConfig(P),
              C = g.vc.getConfig(_);
          if (null != C && null != w) throw new Error(R);
          w = null != C ? y.concat(C) : w || y, Array.isArray(w) && w.length > 0 && (h = function (e, n) {
            var t = Object.assign({}, d.TD, d.FY),
                r = Object.keys(t),
                o = {};
            (0, i.PN)("allowTargetingKeys - allowed keys [ ".concat(n.map(function (e) {
              return t[e];
            }).join(", "), " ]")), e.map(function (e) {
              var i = Object.keys(e)[0],
                  a = e[i].filter(function (e) {
                var i = Object.keys(e)[0],
                    a = 0 === r.filter(function (e) {
                  return 0 === i.indexOf(t[e]);
                }).length || (0, f.sE)(n, function (e) {
                  var n = t[e];
                  return 0 === i.indexOf(n);
                });
                return o[i] = !a, a;
              });
              e[i] = a;
            });
            var a = Object.keys(o).filter(function (e) {
              return o[e];
            });
            return (0, i.PN)("allowTargetingKeys - removed keys [ ".concat(a.join(", "), " ]")), e.filter(function (e) {
              return e[Object.keys(e)[0]].length > 0;
            });
          }(h, w)), h = function (e) {
            var t = e.map(function (e) {
              return (0, n.Z)({}, Object.keys(e)[0], e[Object.keys(e)[0]].map(function (e) {
                return (0, n.Z)({}, Object.keys(e)[0], e[Object.keys(e)[0]].join(","));
              }).reduce(function (e, n) {
                return Object.assign(n, e);
              }, {}));
            }).reduce(function (e, n) {
              var t = Object.keys(n)[0];
              return e[t] = Object.assign({}, e[t], n[t]), e;
            }, {});
            return t;
          }(h);
          var A = g.vc.getConfig("targetingControls.auctionKeyMaxChars");
          return A && ((0, i.PN)("Detected 'targetingControls.auctionKeyMaxChars' was active for this auction; set with a limit of ".concat(A, " characters.  Running checks on auction keys...")), h = function (e, n) {
            var t = (0, i.I8)(e),
                r = Object.keys(t).map(function (e) {
              return {
                adUnitCode: e,
                adserverTargeting: t[e]
              };
            }).sort(D());
            return r.reduce(function (e, r, o, a) {
              var u,
                  c = (u = r.adserverTargeting, Object.keys(u).reduce(function (e, n) {
                return e + "".concat(n, "%3d").concat(encodeURIComponent(u[n]), "%26");
              }, ""));
              o + 1 === a.length && (c = c.slice(0, -3));
              var d = r.adUnitCode,
                  s = c.length;
              return s <= n ? (n -= s, (0, i.PN)("AdUnit '".concat(d, "' auction keys comprised of ").concat(s, " characters.  Deducted from running threshold; new limit is ").concat(n), t[d]), e[d] = t[d]) : (0, i.yN)("The following keys for adUnitCode '".concat(d, "' exceeded the current limit of the 'auctionKeyMaxChars' setting.\nThe key-set size was ").concat(s, ", the current allotted amount was ").concat(n, ".\n"), t[d]), o + 1 === a.length && 0 === Object.keys(e).length && (0, i.H)("No auction targeting keys were permitted due to the setting in setConfig(targetingControls.auctionKeyMaxChars).  Please review setup and consider adjusting."), e;
            }, {});
          }(h, A)), p.forEach(function (e) {
            h[e] || (h[e] = {});
          }), h;
        }, g.vc.getConfig("targetingControls", function (e) {
          null != (0, o.Z)(e, P) && null != (0, o.Z)(e, _) && (0, i.H)(R);
        }), t.setTargetingForGPT = function (e, n) {
          window.googletag.pubads().getSlots().forEach(function (t) {
            Object.keys(e).filter(n ? n(t) : (0, i.zV)(t)).forEach(function (n) {
              Object.keys(e[n]).forEach(function (t) {
                var r = e[n][t];
                "string" == typeof r && -1 !== r.indexOf(",") && (r = r.split(",")), e[n][t] = r;
              }), (0, i.ji)("Attempting to set targeting-map for slot: ".concat(t.getSlotElementId(), " with targeting-map:"), e[n]), t.updateTargetingFromMap(e[n]);
            });
          });
        }, t.getWinningBids = function (e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s(),
              t = u(e);
          return n.filter(function (e) {
            return (0, f.q9)(t, e.adUnitCode);
          }).filter(function (e) {
            return !0 === j.S.get(e.bidderCode, "allowZeroCpmBids") ? e.cpm >= 0 : e.cpm > 0;
          }).map(function (e) {
            return e.adUnitCode;
          }).filter(i.tT).map(function (e) {
            return n.filter(function (n) {
              return n.adUnitCode === e ? n : null;
            }).reduce(i.ZH);
          });
        }, t.setTargetingForAst = function (e) {
          var n = t.getAllTargeting(e);

          try {
            t.resetPresetTargetingAST(e);
          } catch (e) {
            (0, i.H)("unable to reset targeting for AST" + e);
          }

          Object.keys(n).forEach(function (e) {
            return Object.keys(n[e]).forEach(function (t) {
              if ((0, i.ji)("Attempting to set targeting for targetId: ".concat(e, " key: ").concat(t, " value: ").concat(n[e][t])), (0, i.d8)(n[e][t]) || (0, i.kJ)(n[e][t])) {
                var r = {};
                t.search(/pt[0-9]/) < 0 ? r[t.toUpperCase()] = n[e][t] : r[t] = n[e][t], window.apntag.setKeywords(e, r, {
                  overrideKeyValue: !0
                });
              }
            });
          });
        }, t.isApntagDefined = function () {
          if (window.apntag && (0, i.LQ)(window.apntag.setKeywords)) return !0;
        }, t;
      }(s.K),
          F = r(9626),
          M = r(5730),
          z = r(8792),
          W = "__pbjs_debugging__";

      function K() {
        return (0, t.R)().installedModules.includes("debugging");
      }

      function L(e) {
        return new z.Z(function (n) {
          (0, M.B)(e, "debugging", n);
        });
      }

      var G = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = e.load,
            r = void 0 === n ? function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = e.alreadyInstalled,
              r = void 0 === n ? K : n,
              o = e.script,
              a = void 0 === o ? L : o,
              u = null;
          return function () {
            return null == u && (u = new z.Z(function (e, n) {
              setTimeout(function () {
                if (r()) e();else {
                  var o = "https://cdn.jsdelivr.net/npm/prebid.js@7.25.0/dist/debugging-standalone.js";
                  (0, i.ji)('Debugging module not installed, loading it from "'.concat(o, '"...')), (0, t.R)()._installDebugging = !0, a(o).then(function () {
                    (0, t.R)()._installDebugging({
                      DEBUG_KEY: W,
                      hook: I.z3,
                      config: g.vc,
                      createBid: F.m,
                      logger: (0, i.qp)("DEBUG:")
                    });
                  }).then(e, n);
                }
              });
            })), u;
          };
        }() : n,
            o = e.hook,
            a = void 0 === o ? (0, I.v5)("requestBids") : o,
            u = null,
            c = !1;

        function d(e) {
          for (var n = this, t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
            r[i - 1] = arguments[i];
          }

          return (u || z.Z.resolve()).then(function () {
            return e.apply(n, r);
          });
        }

        function s() {
          a.getHooks({
            hook: d
          }).remove(), c = !1;
        }

        return {
          enable: function enable() {
            c || (u = r(), a.before(d, 99), c = !0);
          },
          disable: s,
          reset: function reset() {
            u = null, s();
          }
        };
      }();

      G.reset;
      g.vc.getConfig("debugging", function (e) {
        var n = e.debugging;
        null != n && n.enabled ? G.enable() : G.disable();
      });
      var J = r(875),
          V = r(5164),
          Q = r(3092),
          Y = r(9128),
          X = (0, t.R)(),
          $ = O.k_.triggerUserSyncs,
          ee = d.FP,
          ne = ee.ADD_AD_UNITS,
          te = ee.BID_WON,
          re = ee.REQUEST_BIDS,
          ie = ee.SET_TARGETING,
          oe = ee.STALE_RENDER,
          ae = d.q_,
          ue = ae.PREVENT_WRITING_ON_MAIN_DOCUMENT,
          ce = ae.NO_AD,
          de = ae.EXCEPTION,
          se = ae.CANNOT_FIND_AD,
          fe = ae.MISSING_DOC_OR_ADID,
          le = {
        bidWon: function bidWon(e) {
          var n = s.K.getBidsRequested().map(function (e) {
            return e.bids.map(function (e) {
              return e.adUnitCode;
            });
          }).reduce(i.xH).filter(i.tT);
          if (!(0, i.r3)(n, e)) return void (0, i.H)('The "' + e + '" placement is not defined.');
          return !0;
        }
      };

      function ge(e, n, t) {
        e.defaultView && e.defaultView.frameElement && (e.defaultView.frameElement.width = n, e.defaultView.frameElement.height = t);
      }

      function pe(e, n) {
        var t = [];
        return (0, i.kJ)(e) && (n ? e.length === n : e.length > 0) && (e.every(function (e) {
          return (0, i.HC)(e, 2);
        }) ? t = e : (0, i.HC)(e, 2) && t.push(e)), t;
      }

      function ve(e) {
        var n = (0, i.I8)(e),
            t = n.mediaTypes.banner,
            r = pe(t.sizes);
        return r.length > 0 ? (t.sizes = r, n.sizes = r) : ((0, i.H)("Detected a mediaTypes.banner object without a proper sizes field.  Please ensure the sizes are listed like: [[300, 250], ...].  Removing invalid mediaTypes.banner object from request."), delete n.mediaTypes.banner), n;
      }

      function he(e) {
        var n = (0, i.I8)(e),
            t = n.mediaTypes.video;

        if (t.playerSize) {
          var r = "number" == typeof t.playerSize[0] ? 2 : 1,
              o = pe(t.playerSize, r);
          o.length > 0 ? (2 === r && (0, i.PN)("Transforming video.playerSize from [640,480] to [[640,480]] so it's in the proper format."), t.playerSize = o, n.sizes = o) : ((0, i.H)("Detected incorrect configuration of mediaTypes.video.playerSize.  Please specify only one set of dimensions in a format like: [[640, 480]]. Removing invalid mediaTypes.video.playerSize property from request."), delete n.mediaTypes.video.playerSize);
        }

        return n;
      }

      function me(e) {
        var n = (0, i.I8)(e),
            t = n.mediaTypes.native;

        if (t.ortb) {
          var r = Object.keys(d.FY).filter(function (e) {
            return d.FY[e].includes("hb_native_");
          }),
              o = Object.keys(t).filter(function (e) {
            return r.includes(e);
          });
          o.length > 0 && ((0, i.H)("when using native OpenRTB format, you cannot use legacy native properties. Deleting ".concat(o, " keys from request.")), o.forEach(function (e) {
            return delete n.mediaTypes.native[e];
          }));
        }

        return t.image && t.image.sizes && !Array.isArray(t.image.sizes) && ((0, i.H)("Please use an array of sizes for native.image.sizes field.  Removing invalid mediaTypes.native.image.sizes property from request."), delete n.mediaTypes.native.image.sizes), t.image && t.image.aspect_ratios && !Array.isArray(t.image.aspect_ratios) && ((0, i.H)("Please use an array of sizes for native.image.aspect_ratios field.  Removing invalid mediaTypes.native.image.aspect_ratios property from request."), delete n.mediaTypes.native.image.aspect_ratios), t.icon && t.icon.sizes && !Array.isArray(t.icon.sizes) && ((0, i.H)("Please use an array of sizes for native.icon.sizes field.  Removing invalid mediaTypes.native.icon.sizes property from request."), delete n.mediaTypes.native.icon.sizes), n;
      }

      function be(e, n) {
        var t = (0, o.Z)(e, "mediaTypes.".concat(n, ".pos"));

        if (!(0, i.hj)(t) || isNaN(t) || !isFinite(t)) {
          var r = "Value of property 'pos' on ad unit ".concat(e.code, " should be of type: Number");
          (0, i.yN)(r), u.j8(d.FP.AUCTION_DEBUG, {
            type: "WARNING",
            arguments: r
          }), delete e.mediaTypes[n].pos;
        }

        return e;
      }

      function ye(e) {
        var n = function n(_n2) {
          return "adUnit.code '".concat(e.code, "' ").concat(_n2);
        },
            t = e.mediaTypes,
            r = e.bids;

        return null == r || (0, i.kJ)(r) ? null == r && null == e.ortb2Imp ? ((0, i.H)(n("has no 'adUnit.bids' and no 'adUnit.ortb2Imp'. Removing adUnit from auction")), null) : t && 0 !== Object.keys(t).length ? (null == e.ortb2Imp || null != r && 0 !== r.length || (e.bids = [{
          bidder: null
        }], (0, i.ji)(n("defines 'adUnit.ortb2Imp' with no 'adUnit.bids'; it will be seen only by S2S adapters"))), e) : ((0, i.H)(n("does not define a 'mediaTypes' object.  This is a required field for the auction, so this adUnit has been removed.")), null) : ((0, i.H)(n("defines 'adUnit.bids' that is not an array. Removing adUnit from auction")), null);
      }

      !function () {
        var e = null;

        try {
          e = window.sessionStorage;
        } catch (e) {}

        if (null !== e) {
          var n = G,
              t = null;

          try {
            t = e.getItem(W);
          } catch (e) {}

          null !== t && n.enable();
        }
      }(), X.bidderSettings = X.bidderSettings || {}, X.libLoaded = !0, X.version = "v7.25.0", (0, i.PN)("Prebid.js v7.25.0 loaded"), X.installedModules = X.installedModules || [], X.adUnits = X.adUnits || [], X.triggerUserSyncs = $;
      var we = {
        validateAdUnit: ye,
        validateBannerMediaType: ve,
        validateVideoMediaType: he,
        validateSizes: pe
      };
      Object.assign(we, {
        validateNativeMediaType: me
      });
      var Ce,
          Ae = (0, I.z3)("sync", function (e) {
        var n = [];
        return e.forEach(function (e) {
          if (null != (e = ye(e))) {
            var t,
                r,
                i,
                o = e.mediaTypes;
            o.banner && (t = ve(e), o.banner.hasOwnProperty("pos") && (t = be(t, "banner"))), o.video && (r = he(t || e), o.video.hasOwnProperty("pos") && (r = be(r, "video"))), o.native && (i = me(r || t || e));
            var a = Object.assign({}, t, r, i);
            n.push(a);
          }
        }), n;
      }, "checkAdUnitSetup");

      function Te(e) {
        var t = s.K[e]().filter(i.ak.call(i.IK, this, s.K.getAdUnitCodes())),
            r = s.K.getLastAuctionId();
        return t.map(function (e) {
          return e.adUnitCode;
        }).filter(i.tT).map(function (e) {
          return t.filter(function (n) {
            return n.auctionId === r && n.adUnitCode === e;
          });
        }).filter(function (e) {
          return e && e[0] && e[0].adUnitCode;
        }).map(function (e) {
          return (0, n.Z)({}, e[0].adUnitCode, {
            bids: e
          });
        }).reduce(function (e, n) {
          return Object.assign(e, n);
        }, {});
      }

      function Ee(e, n, t) {
        var r = n.querySelector(t);
        e.parentNode && e.parentNode === r || (0, i.jC)(e, n, t);
      }

      X.getAdserverTargetingForAdUnitCodeStr = function (e) {
        if ((0, i.PN)("Invoking pbjs.getAdserverTargetingForAdUnitCodeStr", arguments), e) {
          var n = X.getAdserverTargetingForAdUnitCode(e);
          return (0, i.Ob)(n);
        }

        (0, i.ji)("Need to call getAdserverTargetingForAdUnitCodeStr with adunitCode");
      }, X.getHighestUnusedBidResponseForAdUnitCode = function (e) {
        if (e) {
          var n = s.K.getAllBidsForAdUnitCode(e).filter(Z);
          return n.length ? n.reduce(i.ZH) : {};
        }

        (0, i.ji)("Need to call getHighestUnusedBidResponseForAdUnitCode with adunitCode");
      }, X.getAdserverTargetingForAdUnitCode = function (e) {
        return X.getAdserverTargeting(e)[e];
      }, X.getAdserverTargeting = function (e) {
        return (0, i.PN)("Invoking pbjs.getAdserverTargeting", arguments), H.getAllTargeting(e);
      }, X.getConsentMetadata = function () {
        return (0, i.PN)("Invoking pbjs.getConsentMetadata"), {
          gdpr: Q.rp.getConsentMeta(),
          usp: Q.nX.getConsentMeta(),
          coppa: !!g.vc.getConfig("coppa")
        };
      }, X.getNoBids = function () {
        return (0, i.PN)("Invoking pbjs.getNoBids", arguments), Te("getNoBids");
      }, X.getNoBidsForAdUnitCode = function (e) {
        return {
          bids: s.K.getNoBids().filter(function (n) {
            return n.adUnitCode === e;
          })
        };
      }, X.getBidResponses = function () {
        return (0, i.PN)("Invoking pbjs.getBidResponses", arguments), Te("getBidsReceived");
      }, X.getBidResponsesForAdUnitCode = function (e) {
        return {
          bids: s.K.getBidsReceived().filter(function (n) {
            return n.adUnitCode === e;
          })
        };
      }, X.setTargetingForGPTAsync = function (e, n) {
        if ((0, i.PN)("Invoking pbjs.setTargetingForGPTAsync", arguments), (0, i.T9)()) {
          var t = H.getAllTargeting(e);
          H.resetPresetTargeting(e, n), H.setTargetingForGPT(t, n), Object.keys(t).forEach(function (e) {
            Object.keys(t[e]).forEach(function (n) {
              "hb_adid" === n && s.K.setStatusForBids(t[e][n], d.UE.CK);
            });
          }), u.j8(ie, t);
        } else (0, i.H)("window.googletag is not defined on the page");
      }, X.setTargetingForAst = function (e) {
        (0, i.PN)("Invoking pbjs.setTargetingForAn", arguments), H.isApntagDefined() ? (H.setTargetingForAst(e), u.j8(ie, H.getAllTargeting())) : (0, i.H)("window.apntag is not defined on the page");
      }, X.renderAd = (0, I.z3)("async", function (e, n, t) {
        if ((0, i.PN)("Invoking pbjs.renderAd", arguments), (0, i.ji)("Calling renderAd with adId :" + n), n) try {
          var r = s.K.findBidByAdId(n);

          if (!r) {
            var a = "Error trying to write ad. Cannot find ad by given id : ".concat(n);
            return void m({
              reason: se,
              message: a,
              id: n
            });
          }

          if (r.status === d.UE.fe && ((0, i.yN)("Ad id ".concat(r.adId, " has been rendered before")), u.j8(oe, r), (0, o.Z)(g.vc.getConfig("auctionOptions"), "suppressStaleRender"))) return;

          if (r.ad = (0, i.ew)(r.ad, r.originalCpm || r.cpm), r.adUrl = (0, i.ew)(r.adUrl, r.originalCpm || r.cpm), t && t.clickThrough) {
            var c = t.clickThrough;
            r.ad = (0, i.x_)(r.ad, c), r.adUrl = (0, i.x_)(r.adUrl, c);
          }

          s.K.addWinningBid(r), u.j8(te, r);
          var f = r.height,
              p = r.width,
              v = r.ad,
              h = r.mediaType,
              y = r.adUrl,
              w = r.renderer,
              C = r.adUnitCode,
              A = X.adUnits.filter(function (e) {
            return e.code === C;
          }),
              T = X.videoModule;
          if (A.video && T) return void T.renderBid(A.video.divId, r);

          if (!e) {
            var E = "Error trying to write ad Id :".concat(n, " to the page. Missing document");
            return void m({
              reason: fe,
              message: E,
              id: n
            });
          }

          var O = document.createComment("Creative ".concat(r.creativeId, " served by ").concat(r.bidder, " Prebid.js Header Bidding"));
          if ((0, i.jC)(O, e, "html"), (0, l.Pd)(w)) (0, l._U)(w, r, e), Ee(O, e, "html"), b({
            doc: e,
            bid: r,
            id: n
          });else if (e === document && !(0, i.yL)() || "video" === h) {
            var k = "Error trying to write ad. Ad render call ad id ".concat(n, " was prevented from writing to the main document.");
            m({
              reason: ue,
              message: k,
              bid: r,
              id: n
            });
          } else if (v) e.write(v), e.close(), ge(e, p, f), Ee(O, e, "html"), (0, i.R_)(r), b({
            doc: e,
            bid: r,
            id: n
          });else if (y) {
            var B = (0, i.$u)();
            B.height = f, B.width = p, B.style.display = "inline", B.style.overflow = "hidden", B.src = y, (0, i.jC)(B, e, "body"), ge(e, p, f), Ee(O, e, "html"), (0, i.R_)(r), b({
              doc: e,
              bid: r,
              id: n
            });
          } else {
            var I = "Error trying to write ad. No ad for bid response id: ".concat(n);
            m({
              reason: ce,
              message: I,
              bid: r,
              id: n
            });
          }
        } catch (e) {
          var j = "Error trying to write ad Id :".concat(n, " to the page:").concat(e.message);
          m({
            reason: de,
            message: j,
            id: n
          });
        } else {
          var S = "Error trying to write ad Id :".concat(n, " to the page. Missing adId");
          m({
            reason: fe,
            message: S,
            id: n
          });
        }
      }), X.removeAdUnit = function (e) {
        ((0, i.PN)("Invoking pbjs.removeAdUnit", arguments), e) ? ((0, i.kJ)(e) ? e : [e]).forEach(function (e) {
          for (var n = X.adUnits.length - 1; n >= 0; n--) {
            X.adUnits[n].code === e && X.adUnits.splice(n, 1);
          }
        }) : X.adUnits = [];
      }, X.requestBids = (Ce = (0, I.z3)("async", function () {
        var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = n.bidsBackHandler,
            r = n.timeout,
            o = n.adUnits,
            a = n.adUnitCodes,
            c = n.labels,
            d = n.auctionId,
            s = n.ttlBuffer,
            f = n.ortb2,
            l = n.metrics,
            p = n.defer;
        u.j8(re);
        var v = r || g.vc.getConfig("bidderTimeout");
        (0, i.PN)("Invoking pbjs.requestBids", arguments);
        var h = {
          global: (0, i.Ee)({}, g.vc.getAnyConfig("ortb2") || {}, f || {}),
          bidder: Object.fromEntries(Object.entries(g.vc.getBidderConfig()).map(function (n) {
            var t = (0, e.Z)(n, 2);
            return [t[0], t[1].ortb2];
          }).filter(function (n) {
            var t = (0, e.Z)(n, 2);
            return t[0], null != t[1];
          }))
        };
        return Oe({
          bidsBackHandler: t,
          timeout: v,
          adUnits: o,
          adUnitCodes: a,
          labels: c,
          auctionId: d,
          ttlBuffer: s,
          ortb2Fragments: h,
          metrics: l,
          defer: p
        });
      }, "requestBids"), (0, I.IF)(Ce, function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = e.adUnits || X.adUnits;
        return e.adUnits = (0, i.kJ)(n) ? n.slice() : [n], e.metrics = (0, Y.V6)(), e.metrics.checkpoint("requestBids"), e.defer = (0, z.P)({
          promiseFactory: function promiseFactory(e) {
            return new Promise(e);
          }
        }), Ce.call(this, e), e.defer.promise;
      }));
      var Oe = (0, I.z3)("async", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = e.bidsBackHandler,
            t = e.timeout,
            r = e.adUnits,
            o = e.ttlBuffer,
            u = e.adUnitCodes,
            c = e.labels,
            d = e.auctionId,
            l = e.ortb2Fragments,
            p = e.metrics,
            v = e.defer,
            h = (0, Q.uV)(g.vc.getConfig("s2sConfig") || []);

        function m(e, t, r) {
          if ("function" == typeof n) try {
            n(e, t, r);
          } catch (e) {
            (0, i.H)("Error executing bidsBackHandler", null, e);
          }
          v.resolve({
            bids: e,
            timedOut: t,
            auctionId: r
          });
        }

        if (r = (0, Y.Bf)(p).measureTime("requestBids.validate", function () {
          return Ae(r);
        }), u && u.length ? r = r.filter(function (e) {
          return (0, f.q9)(u, e.code);
        }) : u = r && r.map(function (e) {
          return e.code;
        }), r.forEach(function (e) {
          var n,
              t = Object.keys(e.mediaTypes || {
            banner: "banner"
          }),
              r = e.bids.map(function (e) {
            return e.bidder;
          }),
              u = Q.ZP.bidderRegistry,
              c = r.filter(function (e) {
            return !h.has(e);
          }),
              d = (null === (n = e.ortb2Imp) || void 0 === n || null === (n = n.ext) || void 0 === n ? void 0 : n.tid) || (0, i.DO)();
          e.transactionId = d, null == o || e.hasOwnProperty("ttlBuffer") || (e.ttlBuffer = o), (0, a.N)(e, "ortb2Imp.ext.tid", d), c.forEach(function (n) {
            var r = u[n],
                o = r && r.getSpec && r.getSpec(),
                a = o && o.supportedMediaTypes || ["banner"];
            t.some(function (e) {
              return (0, f.q9)(a, e);
            }) ? J.f.incrementBidderRequestsCounter(e.code, n) : ((0, i.yN)((0, i.or)(e, n)), e.bids = e.bids.filter(function (e) {
              return e.bidder !== n;
            }));
          }), J.f.incrementRequestsCounter(e.code);
        }), r && 0 !== r.length) {
          var b = s.K.createAuction({
            adUnits: r,
            adUnitCodes: u,
            callback: m,
            cbTimeout: t,
            labels: c,
            auctionId: d,
            ortb2Fragments: l,
            metrics: p
          }),
              y = r.length;
          y > 15 && (0, i.PN)("Current auction ".concat(b.getAuctionId(), " contains ").concat(y, " adUnits."), r), u.forEach(function (e) {
            return H.setLatestAuctionForAdUnit(e, b.getAuctionId());
          }), b.callBids();
        } else (0, i.ji)("No adUnits configured. No bids requested."), m();
      }, "startAuction");
      X.requestBids.before(function (e, n) {
        function t(e) {
          for (var n; n = e.shift();) {
            n();
          }
        }

        t(V.Ld), t(ke), e.call(this, n);
      }, 49), X.addAdUnits = function (e) {
        (0, i.PN)("Invoking pbjs.addAdUnits", arguments), X.adUnits.push.apply(X.adUnits, (0, i.kJ)(e) ? e : [e]), u.j8(ne);
      }, X.onEvent = function (e, n, t) {
        (0, i.PN)("Invoking pbjs.onEvent", arguments), (0, i.LQ)(n) ? !t || le[e].call(null, t) ? u.on(e, n, t) : (0, i.H)('The id provided is not valid for event "' + e + '" and no handler was set.') : (0, i.H)('The event handler provided is not a function and was not set on event "' + e + '".');
      }, X.offEvent = function (e, n, t) {
        (0, i.PN)("Invoking pbjs.offEvent", arguments), t && !le[e].call(null, t) || u.S1(e, n, t);
      }, X.getEvents = function () {
        return (0, i.PN)("Invoking pbjs.getEvents"), u.vw();
      }, X.registerBidAdapter = function (e, n) {
        (0, i.PN)("Invoking pbjs.registerBidAdapter", arguments);

        try {
          Q.ZP.registerBidAdapter(e(), n);
        } catch (e) {
          (0, i.H)("Error registering bidder adapter : " + e.message);
        }
      }, X.registerAnalyticsAdapter = function (e) {
        (0, i.PN)("Invoking pbjs.registerAnalyticsAdapter", arguments);

        try {
          Q.ZP.registerAnalyticsAdapter(e);
        } catch (e) {
          (0, i.H)("Error registering analytics adapter : " + e.message);
        }
      }, X.createBid = function (e) {
        return (0, i.PN)("Invoking pbjs.createBid", arguments), (0, F.m)(e);
      };
      var ke = [],
          Be = (0, I.z3)("async", function (e) {
        e && !(0, i.xb)(e) ? ((0, i.PN)("Invoking pbjs.enableAnalytics for: ", e), Q.ZP.enableAnalytics(e)) : (0, i.H)("pbjs.enableAnalytics should be called with option {}");
      }, "enableAnalyticsCb");

      function Ie(e) {
        e.forEach(function (e) {
          if (void 0 === e.called) try {
            e.call(), e.called = !0;
          } catch (e) {
            (0, i.H)("Error processing command :", "prebid.js", e);
          }
        });
      }

      X.enableAnalytics = function (e) {
        ke.push(Be.bind(this, e));
      }, X.aliasBidder = function (e, n, t) {
        (0, i.PN)("Invoking pbjs.aliasBidder", arguments), e && n ? Q.ZP.aliasBidAdapter(e, n, t) : (0, i.H)("bidderCode and alias must be passed as arguments", "pbjs.aliasBidder");
      }, X.getAllWinningBids = function () {
        return s.K.getAllWinningBids();
      }, X.getAllPrebidWinningBids = function () {
        return s.K.getBidsReceived().filter(function (e) {
          return e.status === d.UE.CK;
        });
      }, X.getHighestCpmBids = function (e) {
        return H.getWinningBids(e);
      }, X.markWinningBidAsUsed = function (e) {
        var n = [];
        e.adUnitCode && e.adId ? n = s.K.getBidsReceived().filter(function (n) {
          return n.adId === e.adId && n.adUnitCode === e.adUnitCode;
        }) : e.adUnitCode ? n = H.getWinningBids(e.adUnitCode) : e.adId ? n = s.K.getBidsReceived().filter(function (n) {
          return n.adId === e.adId;
        }) : (0, i.yN)("Improper use of markWinningBidAsUsed. It needs an adUnitCode or an adId to function."), n.length > 0 && (n[0].status = d.UE.fe);
      }, X.getConfig = g.vc.getAnyConfig, X.readConfig = g.vc.readAnyConfig, X.mergeConfig = g.vc.mergeConfig, X.mergeBidderConfig = g.vc.mergeBidderConfig, X.setConfig = g.vc.setConfig, X.setBidderConfig = g.vc.setBidderConfig, X.que.push(function () {
        window.addEventListener("message", T, !1);
      }), X.cmd.push = function (e) {
        if ("function" == typeof e) try {
          e.call();
        } catch (e) {
          (0, i.H)("Error processing command :", e.message, e.stack);
        } else (0, i.H)("Commands written into pbjs.cmd.push must be wrapped in a function");
      }, X.que.push = X.cmd.push, X.processQueue = function () {
        I.z3.ready(), Ie(X.que), Ie(X.cmd);
      };
    }(), i = r.O(i);
  }();
  (self.pbjsChunk = self.pbjsChunk || []).push([[266], {
    5630: function _(n, e, t) {
      var o,
          r,
          a,
          i,
          c,
          s,
          d = t(1002),
          p = t(4942),
          u = t(4358),
          f = t(6475),
          l = t(3193),
          g = t(3092),
          m = t(4614),
          v = t(9128),
          y = t(6372),
          b = 2,
          w = !1,
          P = {
        iab: function iab(n) {
          var e = n.onSuccess,
              t = n.onError;

          function o(n, o) {
            (0, u.PN)("Received a response from CMP", n), o ? !1 === n.gdprApplies || "tcloaded" === n.eventStatus || "useractioncomplete" === n.eventStatus ? M(n, {
              onSuccess: e,
              onError: t
            }) : s = n : t("CMP unable to register callback function.  Please check CMP setup.");
          }

          var r = {},
              a = function () {
            for (var n, e, t = window;;) {
              try {
                if ("function" == typeof t.__tcfapi) {
                  e = t.__tcfapi, n = t;
                  break;
                }
              } catch (n) {}

              try {
                if (t.frames.__tcfapiLocator) {
                  n = t;
                  break;
                }
              } catch (n) {}

              if (t === window.top) break;
              t = t.parent;
            }

            return {
              cmpFrame: n,
              cmpFunction: e
            };
          }(),
              i = a.cmpFrame,
              c = a.cmpFunction;

          if (!i) return t("CMP not found.");
          "function" == typeof c ? ((0, u.PN)("Detected CMP API is directly accessible, calling it now..."), c("addEventListener", b, o)) : ((0, u.PN)("Detected CMP is outside the current iframe where Prebid.js is located, calling it now..."), function (n, e, t) {
            var o = "__tcfapi",
                a = "".concat(o, "Call");

            function i(n) {
              var e = "".concat(o, "Return"),
                  t = "string" == typeof n.data && (0, m.q9)(n.data, e) ? JSON.parse(n.data) : n.data;

              if (t[e] && t[e].callId) {
                var a = t[e];
                r.hasOwnProperty(a.callId) && r[a.callId](a.returnValue, a.success);
              }
            }

            window[o] = function (n, t, o, i) {
              var c = Math.random() + "",
                  s = (0, p.Z)({}, a, {
                command: n,
                version: t,
                parameter: i,
                callId: c
              });
              r[c] = o, e.postMessage(s, "*");
            }, window.addEventListener("message", i, !1), window[o](n, b, t);
          }("addEventListener", i, o));
        },
        static: function _static(n) {
          var e = n.onSuccess,
              t = n.onError;
          M(i, {
            onSuccess: e,
            onError: t
          });
        }
      };

      function C(n) {
        var e = !1,
            t = null;

        function a(o, r, a) {
          if (null != t && clearTimeout(t), e = !0, g.rp.setConsentData(o), "function" == typeof n) {
            for (var i = arguments.length, c = new Array(i > 3 ? i - 3 : 0), s = 3; s < i; s++) {
              c[s - 3] = arguments[s];
            }

            n.apply(void 0, [r, a].concat(c));
          }
        }

        if ((0, m.q9)(Object.keys(P), o)) {
          var i = {
            onSuccess: function onSuccess(n) {
              return a(n, !1);
            },
            onError: function onError(n) {
              for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++) {
                t[o - 1] = arguments[o];
              }

              a.apply(void 0, [null, !0, n].concat(t));
            }
          };

          if (P[o](i), !e) {
            var c = function c() {
              var n = function n(_n3) {
                a(_n3, !1, "CMP did not load, continuing auction...");
              };

              M(s, {
                onSuccess: n,
                onError: function onError() {
                  return n(A(void 0));
                }
              });
            };

            0 === r ? c() : t = setTimeout(c, r);
          }
        } else a(null, !1, "CMP framework (".concat(o, ") is not a supported framework.  Aborting consentManagement module and resuming auction."));
      }

      var h = (0, v.g3)("gdpr", function (n, e) {
        var t;
        t = function t(_t, o) {
          if (o) {
            var r = u.yN;
            _t && (r = u.H, o = "".concat(o, " Canceling auction as per consentManagement config."));

            for (var a = arguments.length, i = new Array(a > 2 ? a - 2 : 0), c = 2; c < a; c++) {
              i[c - 2] = arguments[c];
            }

            r.apply(void 0, [o].concat(i));
          }

          _t ? (n.stopTiming(), "function" == typeof e.bidsBackHandler ? e.bidsBackHandler() : (0, u.H)("Error executing bidsBackHandler")) : n.call(this, e);
        }, c ? ((0, u.PN)("User consent information already known.  Pulling internally stored information..."), t(!1)) : C(t);
      });

      function M(n, e) {
        var t,
            r,
            i = e.onSuccess,
            c = e.onError;
        "static" === o && (n = n.getTCData), t = n && "boolean" == typeof n.gdprApplies ? n.gdprApplies : a, r = n && n.tcString, "boolean" == typeof t && (!0 !== t || r && (0, u.d8)(r)) ? i(A(n)) : c("CMP returned unexpected value during lookup process.", n);
      }

      function A(n) {
        return c = {
          consentString: n ? n.tcString : void 0,
          vendorData: n || void 0,
          gdprApplies: n && "boolean" == typeof n.gdprApplies ? n.gdprApplies : a
        }, n && n.addtlConsent && (0, u.d8)(n.addtlConsent) && (c.addtlConsent = n.addtlConsent), c.apiVersion = b, c;
      }

      l.vc.getConfig("consentManagement", function (n) {
        return function (n) {
          (n = n && (n.gdpr || n.usp ? n.gdpr : n)) && "object" === (0, d.Z)(n) ? ((0, u.d8)(n.cmpApi) ? o = n.cmpApi : (o = "iab", (0, u.PN)("consentManagement config did not specify cmp.  Using system default setting (".concat("iab", ")."))), (0, u.hj)(n.timeout) ? r = n.timeout : (r = 1e4, (0, u.PN)("consentManagement config did not specify timeout.  Using system default setting (".concat(1e4, ")."))), a = !0 === n.defaultGdprScope, (0, u.PN)("consentManagement module has been activated..."), "static" === o && ((0, u.PO)(n.consentData) ? (i = n.consentData, r = 0) : (0, u.H)("consentManagement config with cmpApi: 'static' did not specify consentData. No consents will be available to adapters.")), w || pbjs.requestBids.before(h, 50), w = !0, g.rp.enable(), C()) : (0, u.yN)("consentManagement config not defined, exiting consent manager");
        }(n.consentManagement);
      }), (0, y.f8)({
        type: y.Z,
        name: "gdpr",
        fn: function fn(n, e) {
          var t = e.gdprConsent;
          t && ("boolean" == typeof t.gdprApplies && (0, f.N)(n, "regs.ext.gdpr", t.gdprApplies ? 1 : 0), (0, f.N)(n, "user.ext.consent", t.consentString));
        }
      }), (0, y.f8)({
        type: y.Z,
        name: "gdprAddtlConsent",
        fn: function fn(n, e) {
          var t,
              o = null === (t = e.gdprConsent) || void 0 === t ? void 0 : t.addtlConsent;
          o && "string" == typeof o && (0, f.N)(n, "user.ext.ConsentedProvidersSettings.consented_providers", o);
        }
      }), window.pbjs.installedModules.push("consentManagement");
    },
    6372: function _(n, e, t) {
      t.d(e, {
        Z: function Z() {
          return a;
        },
        f8: function f8() {
          return p;
        }
      });
      var o = ["request", "imp", "bidResponse", "response"],
          r = ["default", "pbs"],
          a = o[0],
          i = (o[1], o[2], o[3], r[0]),
          c = new Set(o);
      var s,
          d = (s = {}, {
        registerOrtbProcessor: function registerOrtbProcessor(n) {
          var e = n.type,
              t = n.name,
              r = n.fn,
              a = n.priority,
              d = void 0 === a ? 0 : a,
              p = n.dialects,
              u = void 0 === p ? [i] : p;
          if (!c.has(e)) throw new Error("ORTB processor type must be one of: ".concat(o.join(", ")));
          u.forEach(function (n) {
            s.hasOwnProperty(n) || (s[n] = {}), s[n].hasOwnProperty(e) || (s[n][e] = {}), s[n][e][t] = {
              priority: d,
              fn: r
            };
          });
        },
        getProcessors: function getProcessors(n) {
          return s[n] || {};
        }
      }),
          p = d.registerOrtbProcessor;
    }
  }, function (n) {
    var e;
    e = 5630, n(n.s = e);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[160], {
    9099: function _(n, t, e) {
      var a,
          o,
          s = e(1002),
          r = e(4358),
          i = e(6475),
          c = e(3193),
          u = e(3092),
          l = e(6372),
          p = e(9128),
          f = e(2797),
          d = "iab",
          g = d,
          v = 50,
          m = !1,
          P = {
        iab: function iab(n) {
          var t = n.onSuccess,
              e = n.onError;

          var a = (l = {}, {
            consentDataCallback: function consentDataCallback(n, a) {
              a && n.uspString && (l.usPrivacy = n.uspString), l.usPrivacy ? w(l, {
                onSuccess: t,
                onError: e
              }) : e("Unable to get USP consent string.");
            }
          }),
              o = {},
              s = function () {
            for (var n, t, e = window;;) {
              try {
                if ("function" == typeof e.__uspapi) {
                  t = e.__uspapi, n = e;
                  break;
                }
              } catch (n) {}

              try {
                if (e.frames.__uspapiLocator) {
                  n = e;
                  break;
                }
              } catch (n) {}

              if (e === window.top) break;
              e = e.parent;
            }

            return {
              uspapiFrame: n,
              uspapiFunction: t
            };
          }(),
              i = s.uspapiFrame,
              c = s.uspapiFunction;

          var l;
          if (!i) return e("USP CMP not found.");
          (0, r.LQ)(c) ? ((0, r.PN)("Detected USP CMP is directly accessible, calling it now..."), c("getUSPData", 1, a.consentDataCallback), c("registerDeletion", 1, u.ZP.callDataDeletionRequest)) : ((0, r.PN)("Detected USP CMP is outside the current iframe where Prebid.js is located, calling it now..."), f("getUSPData", i, a.consentDataCallback), f("registerDeletion", i, u.ZP.callDataDeletionRequest));
          var p = !1;

          function f(n, t, e) {
            var a, s, r, i, c;
            p || (window.addEventListener("message", function (n) {
              var t = n && n.data && n.data.__uspapiReturn;
              t && t.callId && o.hasOwnProperty(t.callId) && (o[t.callId](t.returnValue, t.success), delete o[t.callId]);
            }, !1), p = !0), a = n, s = 1, r = e, i = Math.random() + "", c = {
              __uspapiCall: {
                command: a,
                version: s,
                callId: i
              }
            }, o[i] = r, t.postMessage(c, "*");
          }
        },
        static: function _static(n) {
          var t = n.onSuccess,
              e = n.onError;
          w(a, {
            onSuccess: t,
            onError: e
          });
        }
      };

      function y(n) {
        var t = null,
            e = !1;

        function a(a, o) {
          if (null != t && clearTimeout(t), e = !0, u.nX.setConsentData(a), null != n) {
            for (var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), i = 2; i < s; i++) {
              r[i - 2] = arguments[i];
            }

            n.apply(void 0, [o].concat(r));
          }
        }

        if (P[g]) {
          var o = {
            onSuccess: a,
            onError: function onError(n) {
              for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) {
                e[o - 1] = arguments[o];
              }

              a.apply(void 0, [null, "".concat(n, " Resuming auction without consent data as per consentManagement config.")].concat(e));
            }
          };
          P[g](o), e || (0 === v ? w(void 0, o) : t = setTimeout(o.onError.bind(null, "USPAPI workflow exceeded timeout threshold."), v));
        } else a(null, "USP framework (".concat(g, ") is not a supported framework. Aborting consentManagement module and resuming auction."));
      }

      var b = (0, p.g3)("usp", function (n, t) {
        var e = this;
        m || h(), y(function (a) {
          if (null != a) {
            for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++) {
              s[i - 1] = arguments[i];
            }

            r.yN.apply(void 0, [a].concat(s));
          }

          n.call(e, t);
        });
      });

      function w(n, t) {
        var e = t.onSuccess,
            a = t.onError;
        !n || !n.usPrivacy ? a("USPAPI returned unexpected value during lookup process.", n) : (!function (n) {
          n && n.usPrivacy && (o = n.usPrivacy);
        }(n), e(o));
      }

      function h() {
        var n = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        m || ((0, r.PN)("USPAPI consentManagement module has been activated".concat(n ? "" : " using default values (api: '".concat(g, "', timeout: ").concat(v, "ms)"))), m = !0, u.nX.enable()), y();
      }

      c.vc.getConfig("consentManagement", function (n) {
        return function (n) {
          (n = n && n.usp) && "object" === (0, s.Z)(n) || (0, r.yN)("consentManagement.usp config not defined, using defaults"), n && (0, r.d8)(n.cmpApi) ? g = n.cmpApi : (g = d, (0, r.PN)("consentManagement.usp config did not specify cmpApi. Using system default setting (".concat(d, ")."))), n && (0, r.hj)(n.timeout) ? v = n.timeout : (v = 50, (0, r.PN)("consentManagement.usp config did not specify timeout. Using system default setting (".concat(50, ")."))), "static" === g && ((0, r.PO)(n.consentData) && (0, r.PO)(n.consentData.getUSPData) ? (n.consentData.getUSPData.uspString && (a = {
            usPrivacy: n.consentData.getUSPData.uspString
          }), v = 0) : (0, r.H)("consentManagement config with cmpApi: 'static' did not specify consentData. No consents will be available to adapters.")), h(!0);
        }(n.consentManagement);
      }), (0, f.v5)("requestBids").before(b, 50), (0, l.f8)({
        type: l.Z,
        name: "usp",
        fn: function fn(n, t) {
          t.uspConsent && (0, i.N)(n, "regs.ext.us_privacy", t.uspConsent);
        }
      }), window.pbjs.installedModules.push("consentManagementUsp");
    },
    6372: function _(n, t, e) {
      e.d(t, {
        Z: function Z() {
          return s;
        },
        f8: function f8() {
          return l;
        }
      });
      var a = ["request", "imp", "bidResponse", "response"],
          o = ["default", "pbs"],
          s = a[0],
          r = (a[1], a[2], a[3], o[0]),
          i = new Set(a);
      var c,
          u = (c = {}, {
        registerOrtbProcessor: function registerOrtbProcessor(n) {
          var t = n.type,
              e = n.name,
              o = n.fn,
              s = n.priority,
              u = void 0 === s ? 0 : s,
              l = n.dialects,
              p = void 0 === l ? [r] : l;
          if (!i.has(t)) throw new Error("ORTB processor type must be one of: ".concat(a.join(", ")));
          p.forEach(function (n) {
            c.hasOwnProperty(n) || (c[n] = {}), c[n].hasOwnProperty(t) || (c[n][t] = {}), c[n][t][e] = {
              priority: u,
              fn: o
            };
          });
        },
        getProcessors: function getProcessors(n) {
          return c[n] || {};
        }
      }),
          l = u.registerOrtbProcessor;
    }
  }, function (n) {
    var t;
    t = 9099, n(n.s = t);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[750], {
    7206: function _(e, t, r) {
      var n = r(1002),
          i = r(3324),
          a = r(4942),
          s = r(9062),
          d = r(4358),
          o = r(265),
          c = r(5339),
          u = r(5706),
          p = r(4679),
          l = r(3193),
          g = r(5164);

      function f(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function m(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? f(Object(r), !0).forEach(function (t) {
            (0, a.Z)(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }

      var b = "grid",
          v = "https://grid.bidswitch.net/hbjson",
          h = "https://x.bidswitch.net/sync?ssp=themediagrid",
          y = "tmguid",
          x = "https://acdn.adnxs.com/video/outstream/ANOutstreamVideo.js",
          w = (0, g.df)({
        gvlid: 686,
        bidderCode: b
      }),
          S = "Bid from response has no auid parameter - ",
          j = "Bid from response has no adm parameter - ",
          O = "Array of bid objects is empty",
          I = "Seatbid array from response has empty item",
          k = "Response is empty",
          R = "Response has empty seatbid array",
          E = "Seatbid from response has no array of bid objects - ",
          N = {
        trustx: {
          endpoint: "https://grid.bidswitch.net/hbjson?sp=trustx",
          syncurl: "https://x.bidswitch.net/sync?ssp=themediagrid",
          bidResponseExternal: {
            netRevenue: !1
          }
        }
      },
          Z = !1,
          A = {
        code: b,
        gvlid: 686,
        aliases: ["playwire", "adlivetech", {
          code: "trustx",
          skipPbsAliasing: !0
        }],
        supportedMediaTypes: [p.Mk, p.pX],
        isBidRequestValid: function isBidRequestValid(e) {
          return !!e.params.uid;
        },
        buildRequests: function buildRequests(e, t) {
          if (!e.length) return null;
          var r = null,
              a = null,
              c = null,
              u = null,
              g = null,
              f = null,
              b = null,
              h = null,
              x = !1,
              S = t || {},
              j = S.bidderRequestId,
              O = S.auctionId,
              I = S.gdprConsent,
              k = S.uspConsent,
              R = S.timeout,
              E = S.refererInfo,
              Z = E ? encodeURIComponent(E.page) : "",
              A = l.vc.getConfig("bidderTimeout") || R,
              P = R ? Math.min(A, R) : A,
              T = [],
              C = {},
              D = [],
              M = [],
              B = [];
          e.forEach(function (e) {
            j || (j = e.bidderRequestId), O || (O = e.auctionId), u || (u = e.schain), g || (g = e.userIdAsEids), h || (h = N[e.bidder] && N[e.bidder].endpoint);
            var t = e.params,
                s = t.uid,
                o = t.keywords,
                l = t.forceBidder,
                f = t.multiRequest,
                m = e.mediaTypes,
                b = e.bidId,
                v = e.adUnitCode,
                y = e.rtd,
                w = e.ortb2Imp,
                S = e.params,
                I = S.pubdata,
                k = S.secid,
                R = S.pubid,
                E = S.source,
                A = S.content;
            C[b] = e;

            var q = function (e, t) {
              var r = e.video ? "video" : "banner",
                  a = t.params.bidFloor || t.params.floorcpm || 0;

              if ("function" == typeof t.getFloor) {
                var s = t.getFloor({
                  currency: "USD",
                  mediaType: r,
                  size: t.sizes.map(function (e) {
                    var t = (0, i.Z)(e, 2);
                    return {
                      w: t[0],
                      h: t[1]
                    };
                  })
                });
                "object" !== (0, n.Z)(s) || "USD" !== s.currency || isNaN(parseFloat(s.floor)) || (a = Math.max(a, parseFloat(s.floor)));
              }

              return a;
            }(m || {}, e),
                U = y && y.jwplayer && y.jwplayer.targeting;

            U && (!a && U.segments && (a = U.segments), !c && U.content && (c = U.content));
            var X = {
              id: b.toString(),
              tagid: (k || s).toString(),
              ext: {
                divid: v.toString()
              }
            };

            if (w && (w.instl && (X.instl = w.instl), w.ext && w.ext.data && (X.ext.data = w.ext.data, X.ext.data.adserver && X.ext.data.adserver.adslot ? X.ext.gpid = X.ext.data.adserver.adslot.toString() : X.ext.gpid = w.ext.data.pbadslot && w.ext.data.pbadslot.toString())), (0, d.xb)(o) || (r || (r = o), X.ext.bidder = {
              keywords: o
            }), q && (X.bidfloor = q), !m || m[p.Mk]) {
              var z = function (e, t) {
                var r = t.sizes || e.sizes;
                if (!r || !r.length) return;
                var n = r.map(function (e) {
                  return (0, d.NI)(e);
                }),
                    i = (0, d.NI)(r[0]);
                n.length && (i.format = n);
                return i;
              }(e, m ? m[p.Mk] : {});

              z && (X.banner = z);
            }

            if (m && m[p.pX]) {
              var F = function (e, t) {
                var r = t.playerSize,
                    n = t.mimes,
                    i = t.durationRangeSec,
                    a = t.protocols,
                    s = (r || e.sizes || [])[0];
                if (!s) return;
                var o = (0, d.NI)(s);
                n && (o.mimes = n);
                i && 2 === i.length && (o.minduration = i[0], o.maxduration = i[1]);
                a && a.length && (o.protocols = a);
                return o;
              }(e, m[p.pX]);

              F && (X.video = F);
            }

            if (X.banner || X.video) if (f) {
              var H = {
                tid: e.auctionId && e.auctionId.toString(),
                ext: {
                  wrapper: "Prebid_js",
                  wrapper_version: "7.25.0"
                }
              };
              e.schain && (H.ext.schain = e.schain);
              var J = {
                id: e.bidderRequestId && e.bidderRequestId.toString(),
                site: {
                  page: Z
                },
                tmax: P,
                source: H,
                imp: [X]
              };
              R && (J.site.publisher = {
                id: R
              });
              var V = I && I.jwpseg || U && U.segments,
                  L = A || U && U.content;
              L && (J.site.content = L), V && V.length && (J.user = {
                data: [{
                  name: "iow_labs_pub_data",
                  segment: _(V, "jwpseg")
                }]
              }), D.push(J), M.push(E), B.push(e);
            } else T.push(X);
            !x && l && N[l] && (x = l);
          }), (x = l.vc.getConfig("forceBidderName") || x) && N[x] && (h = N[x].endpoint, this.forceBidderName = x);
          var q = {
            tid: O && O.toString(),
            ext: {
              wrapper: "Prebid_js",
              wrapper_version: "7.25.0"
            }
          };
          u && (q.ext.schain = u);
          var U = T.length || !D.length ? {
            id: j && j.toString(),
            site: {
              page: Z
            },
            tmax: P,
            source: q,
            imp: T
          } : null;
          return c && (U.site.content = c), a && a.length && (U.user = {
            data: [{
              name: "iow_labs_pub_data",
              segment: _(a, "jwpseg")
            }]
          }), [].concat(D, [U]).forEach(function (e) {
            if (e) {
              var i = (0, o.Z)(t, "ortb2.user.data");
              i && i.length && (f = e.user || {
                data: []
              }, f = (0, d.Ee)(f, {
                data: (0, s.Z)(i)
              })), I && I.consentString && (b = {
                consent: I.consentString
              });
              var a = (0, o.Z)(t, "ortb2.user.ext.device");
              a && ((b = b || {}).device = m({}, a)), g && g.length && ((b = b || {}).eids = (0, s.Z)(g)), b && Object.keys(b).length && ((f = f || {}).ext = b);

              var c = w.getDataFromLocalStorage(y) || function () {
                if (l.vc.getConfig("localStorageWriteAllowed")) {
                  var e = (0, d.DO)().replace(/-/g, "");
                  return w.setDataInLocalStorage(y, e), e;
                }

                return null;
              }();

              c && ((f = f || {}).id = c.toString()), f && (e.user = f);
              var u = (0, o.Z)(t, "ortb2.user.keywords") || null,
                  p = (0, o.Z)(t, "ortb2.site.keywords") || null;
              u && ((r = r || {}).user = r.user || {}, r.user.ortb2 = [{
                name: "keywords",
                keywords: u.split(",")
              }]), p && ((r = r || {}).site = r.site || {}, r.site.ortb2 = [{
                name: "keywords",
                keywords: p.split(",")
              }]), r && (r = function (e) {
                var t = {};
                return Object.keys(e).forEach(function (r) {
                  var i = e[r];
                  if (i) if ("site" === r || "user" === r) {
                    var a = {};
                    Object.keys(i).forEach(function (e) {
                      if (Array.isArray(i[e])) {
                        var t = [];
                        i[e].forEach(function (e) {
                          if ("object" === (0, n.Z)(e) && e.name) {
                            var r = {
                              name: e.name,
                              segments: []
                            };
                            Object.keys(e).forEach(function (t) {
                              Array.isArray(e[t]) && e[t].forEach(function (e) {
                                e && ("string" == typeof e ? r.segments.push({
                                  name: t,
                                  value: e
                                }) : "segments" === t && "string" == typeof e.name && "string" == typeof e.value && r.segments.push(e));
                              });
                            }), r.segments.length && t.push(r);
                          }
                        }), t.length && (a[e] = t);
                      }
                    }), t[r] = a;
                  } else t[r] = i;
                }), Object.keys(t).length && t;
              }(r)) && (e.ext = {
                keywords: r
              }), I && I.gdprApplies && (e.regs = {
                ext: {
                  gdpr: I.gdprApplies ? 1 : 0
                }
              }), k && (e.regs || (e.regs = {
                ext: {}
              }), e.regs.ext.us_privacy = k), !0 === l.vc.getConfig("coppa") && (e.regs || (e.regs = {}), e.regs.coppa = 1);
              var v = (0, o.Z)(t, "ortb2.site");

              if (v) {
                var h = [].concat((0, s.Z)(v.cat || []), (0, s.Z)(v.pagecat || [])).filter(function (e) {
                  return e && "string" == typeof e;
                });
                h.length && (e.site.cat = h);
                var x = (0, o.Z)(v, "content.genre");
                x && "string" == typeof x && (e.site.content = m(m({}, e.site.content), {}, {
                  genre: x
                }));
                var S = (0, o.Z)(v, "content.data");

                if (S && S.length) {
                  var j = e.site.content || {};
                  e.site.content = (0, d.Ee)(j, {
                    data: S
                  });
                }

                var O = (0, o.Z)(v, "content.id");
                O && (e.site.content = m(m({}, e.site.content), {}, {
                  id: O
                }));
              }
            }
          }), [].concat((0, s.Z)(D.map(function (e, t) {
            var r,
                n = (h || v).replace(/[?&]sp=([^?&=]+)/, function (e, t) {
              return t && (r = t), "";
            }),
                i = M[t] || r;
            return {
              method: "POST",
              url: n + (n.indexOf("?") > -1 ? "&" : "?") + "no_mapping=1" + (i ? "&sp=".concat(i) : ""),
              data: JSON.stringify(e),
              bid: B[t]
            };
          })), (0, s.Z)(U ? [{
            method: "POST",
            url: h || v,
            data: JSON.stringify(U),
            bidsMap: C
          }] : []));
        },
        interpretResponse: function interpretResponse(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : u.Th;
          e = e && e.body;
          var n,
              i = [];
          e ? e.seatbid && !e.seatbid.length && (n = R) : n = k;
          var a = this.forceBidderName || this.code;
          return !n && e.seatbid && e.seatbid.forEach(function (e) {
            !function (e, t, r, n, i) {
              if (!e) return;
              var a;
              e.auid || (a = S + JSON.stringify(e));

              if (a || e.adm || e.nurl) {
                var s = t.bidsMap ? t.bidsMap[e.impid] : t.bid;

                if (s) {
                  var o = {
                    requestId: s.bidId,
                    cpm: e.price,
                    width: e.w,
                    height: e.h,
                    creativeId: e.auid,
                    currency: "USD",
                    netRevenue: !0,
                    ttl: 360,
                    meta: {
                      advertiserDomains: e.adomain ? e.adomain : []
                    },
                    dealId: e.dealid
                  };
                  e.ext && e.ext.bidder && e.ext.bidder.grid && e.ext.bidder.grid.demandSource && (o.adserverTargeting = {
                    hb_ds: e.ext.bidder.grid.demandSource
                  }, o.meta.demandSource = e.ext.bidder.grid.demandSource), "video" === e.content_type ? (e.adm ? (o.vastXml = e.adm, o.adResponse = {
                    content: o.vastXml
                  }) : e.nurl && (o.vastUrl = e.nurl), o.mediaType = p.pX, s.renderer || s.mediaTypes && s.mediaTypes.video && "outstream" !== s.mediaTypes.video.context || (o.renderer = function (e, t, r) {
                    var n = r.install({
                      id: t.id,
                      url: t.url,
                      loaded: !1
                    });

                    try {
                      n.setRender(P);
                    } catch (e) {
                      (0, d.yN)("Prebid Error calling setRender on renderer", e);
                    }

                    return n;
                  }(0, {
                    id: s.bidId,
                    url: x
                  }, n))) : (o.ad = e.adm, o.mediaType = p.Mk);
                  var c = N[i] && N[i].bidResponseExternal || {};
                  r.push((0, d.Ee)(o, c));
                }
              } else a = j + JSON.stringify(e);

              a && (0, d.H)(a);
            }(function (e) {
              e ? e.bid ? e.bid[0] || (0, d.H)(O) : (0, d.H)(E + JSON.stringify(e)) : (0, d.H)(I);
              return e && e.bid && e.bid[0];
            }(e), t, i, r, a);
          }), n && (0, d.H)(n), i;
        },
        getUserSyncs: function getUserSyncs() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }

          var n = t[0],
              i = t[2],
              a = t[3];

          if (!Z && n.pixelEnabled) {
            var s = "";
            i && ("boolean" == typeof i.gdprApplies && (s += "&gdpr=".concat(Number(i.gdprApplies))), "string" == typeof i.consentString && (s += "&gdpr_consent=".concat(i.consentString))), a && (s += "&us_privacy=".concat(a));
            var d = this.forceBidderName || this.code,
                o = N[d] && N[d].syncurl || h;
            return Z = !0, {
              type: "image",
              url: o + s
            };
          }
        }
      };

      function _(e, t) {
        return e.map(function (e) {
          var r = e && (e.value || e.id || e);
          return "string" == typeof r || "number" == typeof r ? m(m({
            value: r.toString()
          }, t && {
            name: t
          }), e.name && {
            name: e.name
          }) : null;
        }).filter(function (e) {
          return !!e;
        });
      }

      function P(e) {
        e.renderer.push(function () {
          window.ANOutstreamVideo.renderAd({
            targetId: e.adUnitCode,
            adResponse: e.adResponse
          });
        });
      }

      (0, c.dX)(A), window.pbjs.installedModules.push("gridBidAdapter");
    }
  }, function (e) {
    var t;
    t = 7206, e(e.s = t);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[155], {
    3390: function _(e, t, r) {
      var a = r(9062),
          n = r(1002),
          i = r(4942),
          o = r(265),
          d = r(4358),
          s = r(6475),
          c = r(4679),
          p = r(3193),
          u = r(5644),
          l = r(5164),
          m = r(2021),
          f = r(4614),
          g = r(5339),
          v = r(154),
          I = r(5706);

      function y(e, t) {
        var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (!r) {
          if (Array.isArray(e) || (r = function (e, t) {
            if (!e) return;
            if ("string" == typeof e) return b(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return b(e, t);
          }(e)) || t && e && "number" == typeof e.length) {
            r && (e = r);

            var a = 0,
                n = function n() {};

            return {
              s: n,
              n: function n() {
                return a >= e.length ? {
                  done: !0
                } : {
                  done: !1,
                  value: e[a++]
                };
              },
              e: function e(_e6) {
                throw _e6;
              },
              f: n
            };
          }

          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }

        var i,
            o = !0,
            d = !1;
        return {
          s: function s() {
            r = r.call(e);
          },
          n: function n() {
            var e = r.next();
            return o = e.done, e;
          },
          e: function e(_e7) {
            d = !0, i = _e7;
          },
          f: function f() {
            try {
              o || null == r.return || r.return();
            } finally {
              if (d) throw i;
            }
          }
        };
      }

      function b(e, t) {
        (null == t || t > e.length) && (t = e.length);

        for (var r = 0, a = new Array(t); r < t; r++) {
          a[r] = e[r];
        }

        return a;
      }

      function h(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          t && (a = a.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, a);
        }

        return r;
      }

      function x(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? h(Object(r), !0).forEach(function (t) {
            (0, i.Z)(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }

      var O = "ix",
          S = "roundel",
          E = [c.Mk, c.pX, c.B5],
          Z = [144, 144],
          _ = {
        JPY: 1
      },
          w = {
        PBJS: "p",
        IX: "x"
      },
          D = {
        BID_SIZE_INVALID_FORMAT: 1,
        BID_SIZE_NOT_INCLUDED: 2,
        PROPERTY_NOT_INCLUDED: 3,
        SITE_ID_INVALID_VALUE: 4,
        BID_FLOOR_INVALID_FORMAT: 5,
        IX_FPD_EXCEEDS_MAX_SIZE: 6,
        EXCEEDS_MAX_SIZE: 7,
        PB_FPD_EXCEEDS_MAX_SIZE: 8,
        VIDEO_DURATION_INVALID: 9
      },
          T = {
        SITE: ["id", "name", "domain", "cat", "sectioncat", "pagecat", "page", "ref", "search", "mobile", "privacypolicy", "publisher", "content", "keywords", "ext"],
        USER: ["id", "buyeruid", "yob", "gender", "keywords", "customdata", "geo", "data", "ext"]
      },
          P = {
        "liveramp.com": "idl",
        "netid.de": "NETID",
        "neustar.biz": "fabrickId",
        "zeotap.com": "zeotapIdPlus",
        "uidapi.com": "UID2",
        "adserver.org": "TDID",
        "id5-sync.com": "",
        "crwdcntrl.net": "",
        "epsilon.com": "",
        "audigent.com": "",
        "pubcid.org": "",
        "trustpid.com": ""
      },
          A = ["britepoolid", "lipbid", "criteoId", "merkleId", "parrableId", "connectid", "tapadId", "quantcastId", "pubProvidedId"],
          k = ["mimes", "minduration", "maxduration"],
          N = ["mimes", "minduration", "maxduration", "protocols", "protocol", "startdelay", "placement", "linearity", "skip", "skipmin", "skipafter", "sequence", "battr", "maxextended", "minbitrate", "maxbitrate", "boxingallowed", "playbackmethod", "playbackend", "delivery", "pos", "companionad", "api", "companiontype", "ext", "playerSize", "w", "h"],
          C = "ixdiag",
          B = "".concat(O, "_features"),
          X = !1,
          R = (0, l.df)({
        gvlid: 10,
        bidderCode: O
      }),
          j = {
        featureToggles: {},
        isFeatureEnabled: function isFeatureEnabled(e) {
          return (0, o.Z)(this.featureToggles, "features.".concat(e, ".activated"));
        },
        getFeatureToggles: function getFeatureToggles() {
          if (R.localStorageIsEnabled()) {
            var e = (0, d.dj)(R.getDataFromLocalStorage(B));
            (0, o.Z)(e, "expiry") && e.expiry >= new Date().getTime() ? this.featureToggles = e : this.clearFeatureToggles();
          }
        },
        setFeatureToggles: function setFeatureToggles(e) {
          var t = e.body,
              r = new Date(),
              a = (0, o.Z)(t, "ext.features");
          a && (this.featureToggles = {
            expiry: r.setHours(r.getHours() + 1),
            features: a
          }, R.localStorageIsEnabled() && R.setDataInLocalStorage(B, JSON.stringify(this.featureToggles)));
        },
        clearFeatureToggles: function clearFeatureToggles() {
          this.featureToggles = {}, R.localStorageIsEnabled() && R.removeDataFromLocalStorage(B);
        }
      },
          F = 0,
          U = "",
          z = "",
          L = 2;

      function M(e) {
        var t = q(e, c.pX),
            r = (0, o.Z)(e, "mediaTypes.video"),
            a = (0, o.Z)(e, "params.video");
        if ($(r, a).length) return {};

        for (var n in t.video = a ? (0, d.I8)(e.params.video) : {}, t.ext.tid = (0, o.Z)(e, "ortb2Imp.ext.tid"), r) {
          -1 === N.indexOf(n) || t.video.hasOwnProperty(n) || (t.video[n] = r[n]);
        }

        if (t.video.minduration > t.video.maxduration) return (0, d.H)("IX Bid Adapter: video minduration [".concat(t.video.minduration, "] cannot be greater than video maxduration [").concat(t.video.maxduration, "]"), {
          bidder: O,
          code: D.VIDEO_DURATION_INVALID
        }), {};
        var i = a && a.context || r && r.context;

        if (i && !t.video.hasOwnProperty("placement") && (i === v.LD ? t.video.placement = 1 : i === v.gZ ? (0, o.Z)(a, "playerConfig.floatOnScroll") ? t.video.placement = 5 : t.video.placement = 4 : (0, d.yN)("IX Bid Adapter: Video context '".concat(i, "' is not supported"))), !t.video.w || !t.video.h) {
          var s = G((0, o.Z)(t, "video.playerSize")) || G((0, o.Z)(e, "params.size"));
          if (!s) return (0, d.yN)("IX Bid Adapter: Video size is missing in [mediaTypes.video]"), {};
          t.video.w = s[0], t.video.h = s[1];
        }

        return J(e, t, c.pX), t;
      }

      function q(e, t) {
        var r = {};
        if (r.id = e.bidId, r.ext = {}, (0, o.Z)(e, "params.".concat(t, ".siteId")) && !isNaN(Number(e.params[t].siteId))) switch (t) {
          case c.Mk:
            r.ext.siteID = e.params.banner.siteId.toString();
            break;

          case c.pX:
            r.ext.siteID = e.params.video.siteId.toString();
            break;

          case c.B5:
            r.ext.siteID = e.params.native.siteId.toString();
        } else r.ext.siteID = e.params.siteId.toString();
        return !e.params.hasOwnProperty("id") || "string" != typeof e.params.id && "number" != typeof e.params.id || (r.ext.sid = String(e.params.id)), r;
      }

      function J(e, t, r) {
        var a = null,
            n = null;

        if (e.params.bidFloor && e.params.bidFloorCur && (a = {
          floor: e.params.bidFloor,
          currency: e.params.bidFloorCur
        }), (0, d.LQ)(e.getFloor)) {
          var i = "*",
              o = "*";

          if (r && (0, d.r3)(E, r)) {
            var s = t[r];
            i = r, o = [s.w, s.h];
          }

          try {
            n = e.getFloor({
              mediaType: i,
              size: o
            });
          } catch (e) {
            (0, d.yN)("priceFloors module call getFloor failed, error : ", e);
          }
        }

        n ? (t.bidfloor = n.floor, t.bidfloorcur = n.currency, t.ext.fl = w.PBJS) : a && (t.bidfloor = a.floor, t.bidfloorcur = a.currency, t.ext.fl = w.IX);
      }

      function V(e, t, r) {
        var a = {},
            n = !(!(0, o.Z)(e, "exp") || !(0, d.U)(e.exp)),
            i = (0, o.Z)(e, "dealid") || (0, o.Z)(e, "ext.dealid");
        _.hasOwnProperty(t) ? a.cpm = e.price / _[t] : a.cpm = e.price / 100, a.requestId = e.impid, i && (a.dealId = i), a.netRevenue = true, a.currency = t, a.creativeId = e.hasOwnProperty("crid") ? e.crid : "-", e.mtype == L ? a.vastXml = e.adm : e.ext && e.ext.vasturl && (a.vastUrl = e.ext.vasturl);
        var s = null;
        if ("string" == typeof e.adm && "{" === e.adm[0] && "}" === e.adm[e.adm.length - 1]) try {
          s = JSON.parse(e.adm);
        } catch (e) {
          (0, d.yN)("adm looks like JSON but failed to parse: ", e);
        }
        return e.ext && e.ext.vasturl || e.mtype == L ? (a.width = r.video.w, a.height = r.video.h, a.mediaType = c.pX, a.mediaTypes = r.mediaTypes, a.ttl = n ? e.exp : 3600) : s && s.native ? (a.native = {
          ortb: s.native
        }, a.width = e.w ? e.w : 1, a.height = e.h ? e.h : 1, a.mediaType = c.B5, a.ttl = n ? e.exp : 3600) : (a.ad = e.adm, a.width = e.w, a.height = e.h, a.mediaType = c.Mk, a.ttl = n ? e.exp : 300), a.meta = {}, a.meta.networkId = (0, o.Z)(e, "ext.dspid"), a.meta.brandId = (0, o.Z)(e, "ext.advbrandid"), a.meta.brandName = (0, o.Z)(e, "ext.advbrand"), e.adomain && e.adomain.length > 0 && (a.meta.advertiserDomains = e.adomain), a;
      }

      function H(e) {
        return Array.isArray(e) && 2 === e.length && (0, d.U)(e[0]) && (0, d.U)(e[1]);
      }

      function Y() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
        if (H(e)) return e[0] === t[0] && e[1] === t[1];

        for (var r = 0; r < e.length; r++) {
          if (e[r][0] === t[0] && e[r][1] === t[1]) return !0;
        }

        return !1;
      }

      function $(e, t) {
        var r = [];
        e || (0, d.yN)("IX Bid Adapter: mediaTypes.video is the preferred location for video params in ad unit");

        for (var a = 0, n = k; a < n.length; a++) {
          var i = n[a],
              o = e && e.hasOwnProperty(i),
              s = t && t.hasOwnProperty(i);
          o || s || r.push("IX Bid Adapter: ".concat(i, " is not included in either the adunit or params level"));
        }

        var c = e && e.hasOwnProperty("protocol"),
            p = e && e.hasOwnProperty("protocols"),
            u = t && t.hasOwnProperty("protocol"),
            l = t && t.hasOwnProperty("protocols");
        return c || p || u || l || r.push("IX Bid Adapter: protocol/protcols is not included in either the adunit or params level"), r;
      }

      function G() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        return H(e) ? e : !!H(e[0]) && e[0];
      }

      function Q(e, t, r) {
        if (e) return x(x({}, (0, f.sE)(r, function (t) {
          return t.bidId === e;
        })), (0, f.sE)(t, function (t) {
          return t.id === e;
        }));
      }

      function K(e, t, r, i) {
        var u = "https://htlb.casalemedia.com/openrtb/pbjs",
            l = function (e) {
          var t = [],
              r = {};

          if ((0, d.kJ)(e)) {
            var a,
                n = y(e);

            try {
              for (n.s(); !(a = n.n()).done;) {
                var i = a.value;
                P.hasOwnProperty(i.source) && (0, o.Z)(i, "uids.0") && (r[i.source] = !0, "" != P[i.source] && (i.uids[0].ext = {
                  rtiPartner: P[i.source]
                }), delete i.uids[0].atype, t.push(i));
              }
            } catch (e) {
              n.e(e);
            } finally {
              n.f();
            }
          }

          return {
            toSend: t,
            seenSources: r
          };
        }((0, o.Z)(e, "0.userIdAsEids")),
            m = l.toSend,
            f = (0, o.Z)(t, "refererInfo.page"),
            g = 8e3;

        if (j.isFeatureEnabled("pbjs_use_32kb_size_limit") && (g = 32e3), window.headertag && "function" == typeof window.headertag.getIdentityInfo) {
          var v = window.headertag.getIdentityInfo();
          if (v && "object" === (0, n.Z)(v)) for (var I in v) {
            if (v.hasOwnProperty(I)) {
              var b = v[I];
              !b.responsePending && b.data && "object" === (0, n.Z)(b.data) && Object.keys(b.data).length && !l.seenSources[b.data.source] && m.push(b.data);
            }
          }
        }

        if (t && t.bidderCode === S && !l.seenSources["liveramp.com"]) return [];
        var h = {},
            E = p.vc.getConfig("bidderTimeout");
        h.id = e[0].bidderRequestId.toString(), h.site = {}, h.ext = {}, h.ext.source = "prebid", h.ext.ixdiag = {}, h.ext.ixdiag.ls = R.localStorageIsEnabled(), h.imp = [], h.at = 1;

        var Z = function (e) {
          for (var t = e.map(function (e) {
            return e.transactionId;
          }).filter(function (e, t, r) {
            return r.indexOf(e) === t;
          }), r = {
            mfu: 0,
            bu: 0,
            iu: 0,
            nu: 0,
            ou: 0,
            allu: 0,
            ren: !1,
            version: "7.25.0",
            userIds: W(e[0]),
            url: window.location.href.split("?")[0]
          }, a = function a(_a) {
            i = e.filter(function (e) {
              return e.transactionId === t[_a];
            })[0], (0, o.Z)(i, "mediaTypes") && (Object.keys(i.mediaTypes).length > 1 && r.mfu++, (0, o.Z)(i, "mediaTypes.native") && r.nu++, (0, o.Z)(i, "mediaTypes.banner") && r.bu++, "outstream" === (0, o.Z)(i, "mediaTypes.video.context") && (r.ou++, se(i) && (r.ren = !0)), "instream" === (0, o.Z)(i, "mediaTypes.video.context") && r.iu++, r.allu++);
          }, n = 0; n < t.length; n++) {
            var i;
            a(n);
          }

          return r;
        }(e);

        for (var _ in Z) {
          h.ext.ixdiag[_] = Z[_];
        }

        E && (h.ext.ixdiag.tmax = E), p.vc.getConfig("userSync") && (h.ext.ixdiag.syncsPerBidder = p.vc.getConfig("userSync").syncsPerBidder);

        var w = function () {
          if (!R.localStorageIsEnabled()) return;
          var e,
              t = {};

          try {
            e = JSON.parse(R.getDataFromLocalStorage(C) || "{}");
          } catch (e) {
            return (0, d.H)("ix can not read ixdiag from localStorage."), null;
          }

          return Object.keys(e).forEach(function (r) {
            Object.keys(e[r]).forEach(function (a) {
              "number" == typeof e[r][a] && (t[a] = t[a] ? t[a] + e[r][a] : e[r][a]);
            });
          }), t;
        }();

        (0, d.xb)(w) || (h.ext.ixdiag.err = w), h.ext.ixdiag.imps = Object.keys(r).length, h.source = {
          tid: e[0].auctionId
        }, e[0].schain && (h.source.ext = {}, h.source.ext.schain = e[0].schain), m.length > 0 && (h.user = {}, h.user.eids = m), document.referrer && "" !== document.referrer && (h.site.ref = document.referrer), t && (t.gdprConsent && ((U = t.gdprConsent).hasOwnProperty("gdprApplies") && (h.regs = {
          ext: {
            gdpr: U.gdprApplies ? 1 : 0
          }
        }), U.hasOwnProperty("consentString") && (h.user = h.user || {}, h.user.ext = {
          consent: U.consentString || ""
        }, U.hasOwnProperty("addtlConsent") && U.addtlConsent && (h.user.ext.consented_providers_settings = {
          consented_providers: U.addtlConsent
        }))), t.uspConsent && ((0, s.N)(h, "regs.ext.us_privacy", t.uspConsent), z = t.uspConsent), f && (h.site.page = f)), p.vc.getConfig("coppa") && (0, s.N)(h, "regs.coppa", 1);
        var A = {};
        F = e[0].params.siteId, A.s = F;
        var k = t && t.bidderCode || "ix",
            N = p.vc.getConfig(k),
            B = [],
            X = 0,
            L = Object.keys(r),
            M = "".concat(u).concat((0, d.Re)(x(x({}, A), {}, {
          r: JSON.stringify(h)
        }))).length;
        if (M > g) return (0, d.H)("IX Bid Adapter: Base request size has exceeded maximum request size.", {
          bidder: O,
          code: D.EXCEEDS_MAX_SIZE
        }), B;
        var q = M,
            J = 0,
            V = !1;

        if (N && "object" === (0, n.Z)(N.firstPartyData)) {
          var H = N.firstPartyData,
              Y = "?";

          for (var $ in H) {
            H.hasOwnProperty($) && (Y += "".concat(encodeURIComponent($), "=").concat(encodeURIComponent(H[$]), "&"));
          }

          Y = Y.slice(0, -1), (J = encodeURIComponent(Y).length) < g ? ("page" in h.site ? h.site.page += Y : h.site.page = Y, q += J) : (0, d.H)("IX Bid Adapter: IX config FPD request size has exceeded maximum request size.", {
            bidder: O,
            code: D.IX_FPD_EXCEEDS_MAX_SIZE
          });
        }

        for (var G = function G() {
          if (q >= g || B.length >= 4) return "break";

          for (var n = r[L[Q]], i = n.missingImps, p = void 0 === i ? [] : i, l = n.ixImps, m = !1, f = g - q, v = {
            ixImps: void 0 === l ? [] : l,
            missingBannerImpressions: p
          }, I = Object.keys(v).map(function (e) {
            return v[e];
          }).filter(function (e) {
            return Array.isArray(e);
          }).reduce(function (e, t) {
            return e.concat.apply(e, (0, a.Z)(t));
          }, []), y = encodeURIComponent(JSON.stringify({
            impressionObjects: I
          })).length; I.length && y > f;) {
            m = !0, I.pop(), y = encodeURIComponent(JSON.stringify({
              impressionObjects: I
            })).length;
          }

          var b = r[L[Q]].gpid,
              S = r[L[Q]].dfp_ad_unit_code,
              E = r[L[Q]].tid,
              Z = r[L[Q]].sid;

          if (I.length && (c.Mk in I[0])) {
            for (var _ = I[0], w = {
              id: _.id,
              banner: {
                topframe: _.banner.topframe,
                format: I.map(function (e) {
                  var t = e.banner;
                  return {
                    w: t.w,
                    h: t.h,
                    ext: e.ext
                  };
                })
              }
            }, P = 0; P < w.banner.format.length; P++) {
              null != w.banner.format[P].ext && null != w.banner.format[P].ext.sid && delete w.banner.format[P].ext.sid, ("bidfloor" in I[P]) && (w.banner.format[P].ext.bidfloor = I[P].bidfloor);
            }

            var k = r[L[Q]].pos;
            (0, d.U)(k) && (w.banner.pos = k), (S || b || E || Z) && (w.ext = {}, w.ext.dfp_ad_unit_code = S, w.ext.gpid = b, w.ext.tid = E, w.ext.sid = Z), ("bidfloor" in I[0]) && (w.bidfloor = I[0].bidfloor), ("bidfloorcur" in I[0]) && (w.bidfloorcur = I[0].bidfloorcur), h.imp.push(w);
          } else {
            var N;
            I.forEach(function (e) {
              return (0, s.N)(e, "ext.gpid", b);
            }), (N = h.imp).push.apply(N, (0, a.Z)(I));
          }

          q += y;
          var C = (0, o.Z)(t, "ortb2") || {};

          if (!(0, d.xb)(C) && !V) {
            h.ext.ixdiag.fpd = !0;
            var R = x({}, C.site || C.context);
            Object.keys(R).forEach(function (e) {
              -1 === T.SITE.indexOf(e) && delete R[e];
            });
            var j = x({}, C.user);
            Object.keys(j).forEach(function (e) {
              -1 === T.USER.indexOf(e) && delete j[e];
            });
            var U = (0, d.I8)(h);

            if (U.site = (0, d.Ee)({}, U.site, R), U.user = (0, d.Ee)({}, U.user, j), "".concat(u).concat((0, d.Re)(x(x({}, A), {}, {
              r: JSON.stringify(U)
            }))).length < g) {
              h.site = (0, d.Ee)({}, h.site, R), h.user = (0, d.Ee)({}, h.user, j), V = !0;
              var z = encodeURIComponent(JSON.stringify(x(x({}, R), j))).length;
              q += z;
            } else (0, d.H)("IX Bid Adapter: FPD request size has exceeded maximum request size.", {
              bidder: O,
              code: D.PB_FPD_EXCEEDS_MAX_SIZE
            });
          }

          var J = r[L[Q]].pbadslot,
              H = r[L[Q]].tagId,
              Y = r[L[Q]].adUnitCode,
              $ = r[L[Q]].divId;

          if (J || H || Y || $) {
            var G = (0, d.I8)(h);
            "".concat(u).concat((0, d.Re)(x(x({}, A), {}, {
              r: JSON.stringify(G)
            }))).length < g && (h.ext.ixdiag.pbadslot = J, h.ext.ixdiag.tagid = H, h.ext.ixdiag.adunitcode = Y, h.ext.ixdiag.divId = $);
          }

          var K = Q === L.length - 1;
          (m || K) && (K && !X || (h.ext.ixdiag.sn = X), X++, B.push({
            method: "POST",
            url: u + "?s=" + F,
            data: (0, d.I8)(h),
            option: {
              contentType: "text/plain"
            },
            validBidRequests: e
          }), q = M, h.imp = [], V = !1);
        }, Q = 0; Q < L.length; Q++) {
          if ("break" === G()) break;
        }

        return B;
      }

      function W(e) {
        var t = e.userId || {};
        return A.filter(function (e) {
          return t[e];
        });
      }

      function ee(e, t) {
        if (t) for (var r = 0; r < e.length; r++) {
          var a = e[r];

          if (t[0] === a[0] && t[1] === a[1]) {
            e.splice(r, 1);
            break;
          }
        }
      }

      function te(e, t) {
        var r = function (e) {
          var t = q(e, c.B5),
              r = e.nativeOrtbRequest;
          return r.eventtrackers = [{
            event: 1,
            methods: [1, 2]
          }], r.privacy = 1, t.native = {
            request: JSON.stringify(r),
            ver: "1.2"
          }, t.ext.tid = (0, o.Z)(e, "ortb2Imp.ext.tid"), J(e, t, c.B5), t;
        }(e);

        if (0 != Object.keys(r).length) {
          t[e.transactionId] = {}, t[e.transactionId].ixImps = [], t[e.transactionId].ixImps.push(r), t[e.transactionId].gpid = (0, o.Z)(e, "ortb2Imp.ext.gpid"), t[e.transactionId].dfp_ad_unit_code = (0, o.Z)(e, "ortb2Imp.ext.data.adserver.adslot"), t[e.transactionId].pbadslot = (0, o.Z)(e, "ortb2Imp.ext.data.pbadslot"), t[e.transactionId].tagId = (0, o.Z)(e, "params.tagId");
          var a = e.adUnitCode,
              n = document.getElementById(a) ? a : (0, d.ky)(a).divId;
          t[e.transactionId].adUnitCode = a, t[e.transactionId].divId = n;
        }
      }

      function re(e, t) {
        var r = M(e);

        if (0 != Object.keys(r).length) {
          t[e.transactionId] = {}, t[e.transactionId].ixImps = [], t[e.transactionId].ixImps.push(r), t[e.transactionId].gpid = (0, o.Z)(e, "ortb2Imp.ext.gpid"), t[e.transactionId].dfp_ad_unit_code = (0, o.Z)(e, "ortb2Imp.ext.data.adserver.adslot"), t[e.transactionId].pbadslot = (0, o.Z)(e, "ortb2Imp.ext.data.pbadslot"), t[e.transactionId].tagId = (0, o.Z)(e, "params.tagId");
          var a = e.adUnitCode,
              n = document.getElementById(a) ? a : (0, d.ky)(a).divId;
          t[e.transactionId].adUnitCode = a, t[e.transactionId].divId = n;
        }
      }

      function ae(e, t, r) {
        var a = function (e) {
          var t = q(e, c.Mk);
          t.banner = {};
          var r = (0, o.Z)(e, "params.size");
          return r && (t.banner.w = r[0], t.banner.h = r[1]), t.banner.topframe = (0, d.yL)() ? 0 : 1, J(e, t, c.Mk), t;
        }(e),
            n = Y((0, o.Z)(e, "mediaTypes.banner.sizes"), (0, o.Z)(e, "params.size"));

        r.hasOwnProperty(e.transactionId) || (r[e.transactionId] = {}), r[e.transactionId].gpid = (0, o.Z)(e, "ortb2Imp.ext.gpid"), r[e.transactionId].dfp_ad_unit_code = (0, o.Z)(e, "ortb2Imp.ext.data.adserver.adslot"), r[e.transactionId].tid = (0, o.Z)(e, "ortb2Imp.ext.tid"), r[e.transactionId].pbadslot = (0, o.Z)(e, "ortb2Imp.ext.data.pbadslot"), r[e.transactionId].tagId = (0, o.Z)(e, "params.tagId"), r[e.transactionId].pos = (0, o.Z)(e, "mediaTypes.banner.pos");
        var i = (0, o.Z)(e, "params.id");
        !i || "string" != typeof i && "number" != typeof i || (r[e.transactionId].sid = String(i));
        var s = e.adUnitCode,
            p = document.getElementById(s) ? s : (0, d.ky)(s).divId;
        r[e.transactionId].adUnitCode = s, r[e.transactionId].divId = p, n && (r[e.transactionId].hasOwnProperty("ixImps") || (r[e.transactionId].ixImps = []), r[e.transactionId].ixImps.push(a)), function (e, t, r) {
          var a = e.transactionId;

          if (t.hasOwnProperty(a)) {
            var n = [];
            t[a].hasOwnProperty("missingSizes") && (n = t[a].missingSizes), ee(n, e.params.size), t[a].missingSizes = n;
          } else if ((0, o.Z)(e, "mediaTypes.banner.sizes")) {
            var i = (0, d.I8)(e.mediaTypes.banner.sizes);
            ee(i, e.params.size);
            var s = {
              missingSizes: i,
              impression: r
            };
            t[a] = s;
          }
        }(e, t, a);
      }

      function ne(e, t, r) {
        var a = (0, d.I8)(t);
        return a.banner.w = r[0], a.banner.h = r[1], J(e, a, c.Mk), a;
      }

      function ie(e) {
        "ERROR" === e.type && e.arguments && e.arguments[1] && e.arguments[1].bidder === O && function (e) {
          if (R.localStorageIsEnabled()) {
            var t;

            try {
              t = JSON.parse(R.getDataFromLocalStorage(C) || "{}");
            } catch (e) {
              (0, d.yN)("ix can not read ixdiag from localStorage.");
            }

            var r = new Date();

            if (Object.keys(t).map(function (e) {
              var a = new Date(e);
              a.setDate(a.getDate() + 7) - r < 0 && delete t[e];
            }), "ERROR" === e.type && e.arguments && e.arguments[1] && e.arguments[1].bidder === O) {
              var a = r.toISOString().slice(0, 10),
                  n = e.arguments[1].code;
              n && (t[a] = t[a] || {}, Number(t[a][n]) || (t[a][n] = 0), t[a][n]++);
            }

            R.setDataInLocalStorage(C, JSON.stringify(t));
          }
        }(e);
      }

      function oe(e) {
        e.renderer.push(function () {
          var t = e.adUnitCode,
              r = document.getElementById(t) ? t : (0, d.ky)(t).divId;
          r ? window.createIXPlayer(r, e) : (0, d.yN)("IX Bid Adapter: adUnitCode: ".concat(r, " not found on page."));
        });
      }

      function de(e, t) {
        var r = I.Th.install({
          id: e,
          url: t,
          loaded: !1
        });

        try {
          r.setRender(oe);
        } catch (e) {
          return (0, d.yN)("Prebid Error calling setRender on renderer", e), null;
        }

        return t ? r : ((0, d.yN)("Outstream renderer URL not found"), null);
      }

      function se(e) {
        if ("outstream" !== (0, o.Z)(e, "mediaTypes.video.context")) return !1;
        var t = (0, o.Z)(e, "mediaTypes.video.renderer");
        return t || (t = (0, o.Z)(e, "renderer")), !!("object" !== (0, n.Z)(t) || !t.url || !t.render) || t.backupOnly;
      }

      var ce = {
        code: O,
        gvlid: 10,
        aliases: [{
          code: S,
          gvlid: 10,
          skipPbsAliasing: !1
        }],
        supportedMediaTypes: E,
        isBidRequestValid: function isBidRequestValid(e) {
          X || (m.on(u.FP.AUCTION_DEBUG, ie), m.on(u.FP.AD_RENDER_FAILED, ie), X = !0);
          var t,
              r,
              a = (0, o.Z)(e, "params.video"),
              n = (0, o.Z)(e, "params.size"),
              i = (0, o.Z)(e, "mediaTypes.banner.sizes"),
              s = (0, o.Z)(e, "mediaTypes.video"),
              c = (0, o.Z)(e, "mediaTypes.video.playerSize"),
              p = e.params.hasOwnProperty("bidFloor"),
              l = e.params.hasOwnProperty("bidFloorCur");
          if (e.hasOwnProperty("mediaType") && !(0, d.r3)(E, e.mediaType)) return (0, d.yN)("IX Bid Adapter: media type is not supported."), !1;
          if ((0, o.Z)(e, "mediaTypes.banner") && !i) return !1;

          if (n) {
            var f = G(n);
            if (!f) return (0, d.H)("IX Bid Adapter: size has invalid format.", {
              bidder: O,
              code: D.BID_SIZE_INVALID_FORMAT
            }), !1;
            if (!Y(e.sizes, f) && !Y(c, f) && !Y(i, f)) return (0, d.H)("IX Bid Adapter: bid size is not included in ad unit sizes or player size.", {
              bidder: O,
              code: D.BID_SIZE_NOT_INCLUDED
            }), !1;
          }

          if ("string" != typeof e.params.siteId && "number" != typeof e.params.siteId) return (0, d.H)("IX Bid Adapter: siteId must be string or number type.", {
            bidder: O,
            code: D.SITE_ID_INVALID_VALUE
          }), !1;
          if ("string" != typeof e.params.siteId && isNaN(Number(e.params.siteId))) return (0, d.H)("IX Bid Adapter: siteId must valid value", {
            bidder: O,
            code: D.SITE_ID_INVALID_VALUE
          }), !1;
          if ((p || l) && !(p && l && (t = e.params.bidFloor, r = e.params.bidFloorCur, Boolean("number" == typeof t && "string" == typeof r && r.match(/^[A-Z]{3}$/))))) return (0, d.H)("IX Bid Adapter: bidFloor / bidFloorCur parameter has invalid format.", {
            bidder: O,
            code: D.BID_FLOOR_INVALID_FORMAT
          }), !1;

          if (s && a) {
            var g = M(e).video,
                I = $(s, a);

            if ((0, o.Z)(e, "mediaTypes.video.context") === v.gZ && se(e) && g) {
              var y = [(0, o.Z)(g, "w"), (0, o.Z)(g, "h")];
              if (!(y[0] >= Z[0] && y[1] >= Z[1])) return (0, d.H)("IX Bid Adapter: ".concat(y, " is an invalid size for IX outstream renderer")), !1;
            }

            if (I.length) return I.forEach(function (e) {
              (0, d.H)(e, {
                bidder: O,
                code: D.PROPERTY_NOT_INCLUDED
              });
            }), !1;
          }

          return function (e) {
            return void 0 === (0, o.Z)(e, "mediaTypes.native") || e.nativeOrtbRequest && Array.isArray(e.nativeOrtbRequest.assets) && e.nativeOrtbRequest.assets.length > 0;
          }(e);
        },
        buildRequests: function buildRequests(e, t) {
          var r = [],
              n = {},
              i = {},
              s = {},
              p = {};

          for (var u in j.getFeatureToggles(), e.forEach(function (e) {
            var t = Object.keys((0, o.Z)(e, "mediaTypes", {}));

            for (var r in t) {
              switch (t[r]) {
                case c.Mk:
                  ae(e, p, n);
                  break;

                case c.pX:
                  re(e, i);
                  break;

                case c.B5:
                  te(e, s);
                  break;

                default:
                  (0, d.yN)("IX Bid Adapter: ad unit mediaTypes ".concat(r, " is not supported"));
              }
            }
          }), p) {
            if (p.hasOwnProperty(u)) {
              var l = p[u].missingSizes;
              n.hasOwnProperty(u) || (n[u] = {}), n[u].hasOwnProperty("missingImps") || (n[u].missingImps = [], n[u].missingCount = 0);

              for (var m = p[u].impression, f = 0; f < l.length; f++) {
                var g = ne(e[0], m, l[f]);
                n[u].missingImps.push(g), n[u].missingCount++;
              }
            }
          }

          return Object.keys(n).length > 0 && r.push.apply(r, (0, a.Z)(K(e, t, n))), Object.keys(i).length > 0 && r.push.apply(r, (0, a.Z)(K(e, t, i))), Object.keys(s).length > 0 && r.push.apply(r, (0, a.Z)(K(e, t, s))), r;
        },
        interpretResponse: function interpretResponse(e, t) {
          var r = [],
              a = null;
          if (!e.hasOwnProperty("body") || !e.body.hasOwnProperty("seatbid")) return j.setFeatureToggles(e), r;

          for (var n = e.body, i = n.seatbid, s = 0; s < i.length; s++) {
            if (i[s].hasOwnProperty("bid")) {
              for (var p = i[s].bid, u = t.data, l = 0; l < p.length; l++) {
                var m = Q(p[l].impid, u.imp, t.validBidRequests);

                if ((a = V(p[l], n.cur, m)).mediaType === c.pX && se(m)) {
                  var f = (0, o.Z)(n, "ext.videoplayerurl");
                  if (a.renderer = de(p[l].bidId, f), !a.renderer) continue;
                }

                r.push(a);
              }

              if ((0, o.Z)(u, "ext.ixdiag.err") && R.localStorageIsEnabled()) try {
                R.removeDataFromLocalStorage(C);
              } catch (e) {
                (0, d.H)("ix can not clear ixdiag from localStorage.");
              }
            }
          }

          return j.setFeatureToggles(e), r;
        },
        transformBidParams: function transformBidParams(e, t) {
          return (0, d.uh)({
            siteID: "number"
          }, e);
        },
        getUserSyncs: function getUserSyncs(e, t) {
          var r = [],
              a = null;
          if (t.length > 0 && (a = (0, o.Z)(t[0], "body.ext.publishersyncsperbidderoverride")), void 0 !== a && 0 == a) return [];
          if (e.iframeEnabled) r.push({
            type: "iframe",
            url: "https://js-sec.indexww.com/um/ixmatch.html"
          });else {
            var n = null;
            p.vc.getConfig("userSync") && (n = p.vc.getConfig("userSync").syncsPerBidder), 0 === n && (n = a), n = a && (0 === n || n) ? a > n ? n : a : 1;

            for (var i = 0; i < n; i++) {
              r.push({
                type: "image",
                url: pe(n, i)
              });
            }
          }
          return r;
        }
      };

      function pe(e, t) {
        var r = "",
            a = "0";
        return U && U.hasOwnProperty("gdprApplies") && (a = U.gdprApplies ? "1" : "0"), U && U.hasOwnProperty("consentString") && (r = U.consentString || ""), "https://dsum.casalemedia.com/pbusermatch?origin=prebid&site_id=" + F.toString() + "&p=" + e.toString() + "&i=" + t.toString() + "&gdpr=" + a + "&gdpr_consent=" + r + "&us_privacy=" + (z || "");
      }

      (0, g.dX)(ce), window.pbjs.installedModules.push("ixBidAdapter");
    }
  }, function (e) {
    var t;
    t = 3390, e(e.s = t);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[769], {
    896: function _(e, t, n) {
      var i = n(4358),
          r = n(265),
          a = n(5339),
          o = n(3193),
          d = n(4679),
          s = n(5102),
          c = n(5706),
          u = n(59),
          p = "medianet",
          l = "https://prebid.media.net/video/bundle.js",
          m = {
        NOT_DETERMINED: 0,
        ABOVE_THE_FOLD: 1,
        BELOW_THE_FOLD: 2
      },
          f = "client_timeout",
          b = "client_bid_won",
          g = (0, s.nH)(),
          h = {};
      window.mnet = window.mnet || {}, window.mnet.queue = window.mnet.queue || [], h.urlData = {
        domain: g.domain,
        page: g.page,
        isTop: g.reachedTop
      };

      function v() {
        try {
          return window.top.document.referrer;
        } catch (e) {
          return document.referrer;
        }
      }

      function y(e, t) {
        var n = t.refererInfo,
            i = {
          domain: (e = e || {}).domain || n.domain,
          page: e.page || n.page,
          ref: e.ref || v(),
          topMostLocation: n.topmostLocation,
          isTop: e.isTop || n.reachedTop
        };
        return Object.assign(i, function () {
          if (h.pageMeta) return h.pageMeta;
          var e = w('link[rel="canonical"]', "href"),
              t = w('meta[property="og:url"]', "content"),
              n = w('meta[name="twitter:url"]', "content");
          return h.pageMeta = Object.assign({}, e && {
            canonical_url: e
          }, t && {
            og_url: t
          }, n && {
            twitter_url: n
          }), h.pageMeta;
        }());
      }

      function w(e, t) {
        var n,
            r,
            a = function (e, t) {
          try {
            var n = (0, i.Zy)().document.querySelector(e);
            if (null !== n && n[t]) return n[t];
          } catch (e) {}
        }(e, t);

        return a && (n = a, (r = (0, i.Zy)().document.createElement("a")).href = n, r.href);
      }

      function _(e, t) {
        return e.filter(function (e) {
          return e.type === t;
        });
      }

      function x(e) {
        return {
          w: parseInt(e[0], 10),
          h: parseInt(e[1], 10)
        };
      }

      function T(e, t) {
        var n = (0, r.Z)(e, "params"),
            a = (0, r.Z)(t, "gdprConsent"),
            d = (0, r.Z)(t, "uspConsent"),
            s = (0, r.Z)(e, "userId"),
            c = (0, r.Z)(e, "schain") || {},
            u = D.getWindowSize(),
            p = !(!a || !a.gdprApplies),
            l = !!d,
            m = !!o.vc.getConfig("coppa");
        return Object.assign({}, {
          customer_id: n.cid
        }, {
          prebid_version: pbjs.version
        }, {
          gdpr_applies: p
        }, p && {
          gdpr_consent_string: a.consentString || ""
        }, {
          usp_applies: l
        }, l && {
          usp_consent_string: d || ""
        }, {
          coppa_applies: m
        }, -1 !== u.w && -1 !== u.h && {
          screen: u
        }, s && {
          user_id: s
        }, pbjs.medianetGlobals.analyticsEnabled && {
          analytics: !0
        }, !(0, i.xb)(c) && {
          schain: c
        });
      }

      function O(e) {
        var t = {
          id: e.bidId,
          transactionId: e.transactionId,
          ext: {
            dfp_id: e.adUnitCode,
            display_count: e.bidRequestsCount
          },
          all: e.params
        };
        e.ortb2Imp && (t.ortb2Imp = e.ortb2Imp);
        var n,
            a = (0, r.Z)(e, "mediaTypes.banner.sizes") || [],
            o = (0, r.Z)(e, "mediaTypes.video") || {},
            s = (0, r.Z)(e, "params.video") || {},
            c = Object.assign({}, s, o);
        if ((0, i.xb)(c) || (t.video = c), a.length > 0 && (t.banner = (n = a, (0, i.kJ)(n) && 2 === n.length && !(0, i.kJ)(n[0]) ? [x(n)] : n.map(function (e) {
          return x(e);
        }))), e.nativeParams) try {
          t.native = JSON.stringify(e.nativeParams);
        } catch (e) {
          (0, i.H)("".concat(p, " : Incorrect JSON : bidRequest.nativeParams"));
        }
        e.params.crid && (t.tagid = e.params.crid.toString());
        var u = parseFloat(e.params.bidfloor || e.params.bidFloor);
        u && (t.bidfloor = u);

        var l = function (e) {
          var t = document.getElementById(e);

          if (!t && -1 !== e.indexOf("/")) {
            var n = (0, i.ky)(e).divId;
            (0, i.d8)(n) && (t = document.getElementById(n));
          }

          if (t && t.getBoundingClientRect) {
            var r = t.getBoundingClientRect(),
                a = {};
            return a.top_left = {
              y: r.top,
              x: r.left
            }, a.bottom_right = {
              y: r.bottom,
              x: r.right
            }, a;
          }

          return null;
        }(e.adUnitCode);

        if (l && t.banner && 0 !== t.banner.length) {
          var f = function (e) {
            return {
              top_left: {
                x: e.top_left.x + window.pageXOffset,
                y: e.top_left.y + window.pageYOffset
              },
              bottom_right: {
                x: e.bottom_right.x + window.pageXOffset,
                y: e.bottom_right.y + window.pageYOffset
              }
            };
          }(l);

          t.ext.coordinates = f, t.ext.viewability = I(l.top_left, j(t.banner)), I(f.top_left, j(t.banner)) > .5 ? t.ext.visibility = m.ABOVE_THE_FOLD : t.ext.visibility = m.BELOW_THE_FOLD;
        } else t.ext.visibility = m.NOT_DETERMINED;

        var b = function (e) {
          var t = [];
          "function" == typeof e.getFloor && [d.Mk, d.pX, d.B5].forEach(function (n) {
            e.mediaTypes.hasOwnProperty(n) && (n == d.Mk ? e.mediaTypes.banner.sizes.forEach(function (i) {
              E(e, n, i, t);
            }) : E(e, n, "*", t));
          });
          return t;
        }(e);

        return b && b.length > 0 && (t.bidfloors = b), t;
      }

      function E(e, t, n, i) {
        var r = e.getFloor({
          currency: "USD",
          mediaType: t,
          size: n
        });
        n.length > 1 && (r.size = n), r.mediaType = t, i.push(r);
      }

      function j(e) {
        return e.reduce(function (e, t) {
          return t.h * t.w < e.h * e.w ? t : e;
        });
      }

      function I(e, t) {
        var n = t.w * t.h,
            i = D.getWindowSize(),
            r = {
          x: e.x + t.w,
          y: e.y + t.h
        };
        return 0 === n || -1 === i.w || -1 === i.h ? 0 : function (e, t, n, i) {
          if (e.x > i.x || t.x < n.x || e.y > i.y || t.y < n.y) return 0;
          return (Math.min(t.x, i.x) - Math.max(e.x, n.x)) * (Math.min(t.y, i.y) - Math.max(e.y, n.y));
        }(e, r, {
          x: 0,
          y: 0
        }, {
          x: i.w,
          y: i.h
        }) / n;
      }

      function M(e, t) {
        t = (0, i.kJ)(t) && t || [];
        var n = {
          logid: "kfk",
          evtid: "projectevents",
          project: "prebid"
        };
        return n.acid = (0, r.Z)(t, "0.auctionId") || "", n.cid = pbjs.medianetGlobals.cid || "", n.crid = t.map(function (e) {
          return (0, r.Z)(e, "params.0.crid") || e.adUnitCode;
        }).join("|"), n.adunit_count = t.length || 0, n.dn = h.urlData.domain || "", n.requrl = h.urlData.page || "", n.istop = h.urlData.isTop || "", n.event = e.name || "", n.value = e.value || "", n.rd = e.related_data || "", n;
      }

      function k(e, t) {
        var n = {
          protocol: "https",
          hostname: "qsearch-a.akamaihd.net/log",
          search: M(e, t)
        };
        (0, i.hq)((0, i.Q2)(n));
      }

      function C(e) {
        var t,
            n = (0, r.Z)(e, "context") || "",
            a = (0, r.Z)(e, "vto");
        "outstream" == n && a && (e.renderer = ((t = c.Th.install({
          url: l
        })).setRender(function (e) {
          window.mnet.queue.push(function () {
            var t = {
              width: e.width,
              height: e.height,
              vastTimeout: e.vto,
              maxAllowedVastTagRedirects: e.mavtr,
              allowVpaid: e.avp,
              autoPlay: e.ap,
              preload: e.pl,
              mute: e.mt
            },
                n = e.dfp_id,
                r = (0, i.ky)(n).divId || n;
            window.mnet.mediaNetoutstreamPlayer(e, r, t);
          });
        }), t));
      }

      pbjs.medianetGlobals = pbjs.medianetGlobals || {};
      var D = {
        code: p,
        gvlid: 142,
        aliases: [{
          code: "aax",
          gvlid: 720
        }],
        supportedMediaTypes: [d.Mk, d.B5, d.pX],
        isBidRequestValid: function isBidRequestValid(e) {
          return e.params ? e.params.cid && (0, i.d8)(e.params.cid) && !(0, i.jH)(e.params.cid) ? (Object.assign(pbjs.medianetGlobals, !pbjs.medianetGlobals.cid && {
            cid: e.params.cid
          }), !0) : ((0, i.H)("".concat(p, " : cid should be a string")), !1) : ((0, i.H)("".concat(p, " : Missing bid parameters")), !1);
        },
        buildRequests: function buildRequests(e, t) {
          var n,
              i = function (e, t) {
            return {
              site: y(e[0].params.site, t),
              ext: T(e[0], t),
              id: e[0].auctionId,
              imp: e.map(function (e) {
                return O(e);
              }),
              ortb2: t.ortb2,
              tmax: t.timeout || o.vc.getConfig("bidderTimeout")
            };
          }(e = (0, u.lY)(e), t);

          return {
            method: "POST",
            url: (n = i.ext.customer_id, "https://prebid.media.net/rtb/prebid?cid=" + encodeURIComponent(n)),
            data: JSON.stringify(i)
          };
        },
        interpretResponse: function interpretResponse(e, t) {
          var n = [];
          if (!e || !e.body) return (0, i.PN)("".concat(p, " : response is empty")), n;
          var r = e.body.bidList;
          return (0, i.kJ)(r) && 0 !== r.length ? ((n = r.filter(function (e) {
            return function (e) {
              return !1 === e.no_bid && parseFloat(e.cpm) > 0;
            }(e);
          })).forEach(C), n) : ((0, i.PN)("".concat(p, " : no bids")), n);
        },
        getUserSyncs: function getUserSyncs(e, t) {
          var n,
              r = (n = t, !(0, i.xb)(n) && n[0].body && n[0].body.ext && (0, i.kJ)(n[0].body.ext.csUrl) ? n[0].body.ext.csUrl : []);
          return e.iframeEnabled ? _(r, "iframe") : e.pixelEnabled ? _(r, "image") : void 0;
        },
        onTimeout: function onTimeout(e) {
          try {
            k({
              name: f,
              value: e.length,
              related_data: e[0].timeout || o.vc.getConfig("bidderTimeout")
            }, e);
          } catch (e) {}
        },
        onBidWon: function onBidWon(e) {
          try {
            k({
              name: b,
              value: e.cpm
            }, [e]);
          } catch (e) {}
        },
        clearMnData: function clearMnData() {
          h = {};
        },
        getWindowSize: function getWindowSize() {
          return {
            w: window.screen.width || -1,
            h: window.screen.height || -1
          };
        }
      };
      (0, a.dX)(D), window.pbjs.installedModules.push("medianetBidAdapter");
    }
  }, function (e) {
    var t;
    t = 896, e(e.s = t);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[534], {
    7851: function _(e, t, n) {
      var a = n(1002),
          i = n(3324),
          r = n(265),
          d = n(4358),
          o = n(6475),
          s = n(3193),
          c = n(5339),
          p = n(4679),
          u = n(4614),
          m = [p.Mk, p.pX],
          l = ["startdelay", "mimes", "minduration", "maxduration", "startdelay", "skippable", "playbackmethod", "api", "protocols", "boxingallowed", "linearity", "delivery", "protocol", "placement", "minbitrate", "maxbitrate"],
          h = "hb_pb",
          v = "3.0.3",
          f = "USD",
          b = {
        britepoolid: "britepoolid",
        criteoId: "criteoid",
        fabrickId: "nuestarid",
        hadronId: "audigentid",
        id5id: "id5id",
        idl_env: "lre",
        IDP: "zeotapid",
        idxId: "idxid",
        intentIqId: "intentiqid",
        lipb: "lipbid",
        lotamePanoramaId: "lotameid",
        merkleId: "merkleid",
        netId: "netid",
        parrableId: "parrableid",
        pubcid: "pubcid",
        quantcastId: "quantcastid",
        tapadId: "tapadid",
        tdid: "ttduuid",
        uid2: "uid2",
        admixerId: "admixerid",
        deepintentId: "deepintentid",
        dmdId: "dmdid",
        nextrollId: "nextrollid",
        novatiq: "novatiqid",
        mwOpenLinkId: "mwopenlinkid",
        dapId: "dapid",
        amxId: "amxid",
        kpuid: "kpuid",
        publinkId: "publinkid",
        naveggId: "naveggid",
        imuid: "imuid",
        adtelligentId: "adtelligentid"
      },
          g = {
        code: "openx",
        gvlid: 69,
        supportedMediaTypes: m,
        isBidRequestValid: function isBidRequestValid(e) {
          var t = e.params.delDomain || e.params.platform;
          return (0, r.Z)(e, "mediaTypes.banner") && t ? !!e.params.unit || (0, r.Z)(e, "mediaTypes.banner.sizes.length") > 0 : !(!e.params.unit || !t);
        },
        buildRequests: function buildRequests(e, t) {
          if (0 === e.length) return [];

          var n = [],
              a = function (e) {
            return e.reduce(function (e, t) {
              var n;
              return n = t, (0, r.Z)(n, "mediaTypes.video") && !(0, r.Z)(n, "mediaTypes.banner") || n.mediaType === p.pX ? e[0].push(t) : e[1].push(t), e;
            }, [[], []]);
          }(e),
              o = (0, i.Z)(a, 2),
              c = o[0],
              m = o[1];

          return m.length > 0 && n.push(function (e, t) {
            var n = [],
                a = !1,
                i = y(e, t),
                o = (0, d.HA)(e, function (e) {
              return e.params.unit;
            });
            i.aus = (0, d.HA)(e, function (e) {
              return (0, d.sF)(e.mediaTypes.banner.sizes).join(",");
            }).join("|"), i.divids = (0, d.HA)(e, function (e) {
              return encodeURIComponent(e.adUnitCode);
            }).join(","), i.aucs = (0, d.HA)(e, function (e) {
              var t = (0, r.Z)(e, "ortb2Imp.ext.data.pbadslot");
              return encodeURIComponent(t || "");
            }).join(","), o.some(function (e) {
              return e;
            }) && (i.auid = o.join(","));
            e.some(function (e) {
              return e.params.doNotTrack;
            }) && (i.ns = 1);
            (!0 === s.vc.getConfig("coppa") || e.some(function (e) {
              return e.params.coppa;
            })) && (i.tfcd = 1);
            e.forEach(function (e) {
              if (e.params.customParams) {
                var t = (0, d.HA)(Object.keys(e.params.customParams), function (t) {
                  return function (e, t) {
                    var n = t[e];
                    (0, d.kJ)(n) && (n = n.join(","));
                    return (e.toLowerCase() + "=" + n.toLowerCase()).replace("+", ".").replace("/", "_");
                  }(t, e.params.customParams);
                }),
                    i = window.btoa(t.join("&"));
                a = !0, n.push(i);
              } else n.push("");
            }), a && (i.tps = n.join(","));
            return w(i, p.Mk, e), {
              method: "GET",
              url: i.ph ? "https://u.openx.net/w/1.0/arj" : "https://".concat(e[0].params.delDomain, "/w/1.0/arj"),
              data: i,
              payload: {
                bids: e,
                startTime: new Date()
              }
            };
          }(m, t)), c.length > 0 && c.forEach(function (e) {
            n.push(function (e, t) {
              var n = function (e, t) {
                var n,
                    a,
                    i = (0, r.Z)(e, "mediaTypes.video"),
                    o = y([e], t),
                    s = (0, r.Z)(e, "params.video") || {},
                    c = (0, r.Z)(e, "mediaTypes.video.context"),
                    m = (0, r.Z)(e, "mediaTypes.video.playerSize");
                (0, d.kJ)(e.sizes) && 2 === e.sizes.length && !(0, d.kJ)(e.sizes[0]) ? (n = parseInt(e.sizes[0], 10), a = parseInt(e.sizes[1], 10)) : (0, d.kJ)(e.sizes) && (0, d.kJ)(e.sizes[0]) && 2 === e.sizes[0].length ? (n = parseInt(e.sizes[0][0], 10), a = parseInt(e.sizes[0][1], 10)) : (0, d.kJ)(m) && 2 === m.length && (n = parseInt(m[0], 10), a = parseInt(m[1], 10));
                var h = {
                  w: n,
                  h: a
                },
                    v = e.params.video || e.params.openrtb || {};
                v.openrtb && (v = v.openrtb);
                (0, d.kJ)(v.imp) && (v = v.imp[0].video);
                Object.keys(v).filter(function (e) {
                  return (0, u.q9)(l, e);
                }).forEach(function (e) {
                  return h[e] = v[e];
                }), Object.keys(i).filter(function (e) {
                  return (0, u.q9)(l, e);
                }).forEach(function (e) {
                  return h[e] = i[e];
                });
                var f = {
                  imp: [{
                    video: h
                  }]
                };
                o.openrtb = JSON.stringify(f), o.auid = e.params.unit, o.vwd = n || s.vwd, o.vht = a || s.vht, "outstream" === c && (o.vos = "101");
                s.mimes && (o.vmimes = s.mimes);
                e.params.test && (o.vtest = 1);
                var b = (0, r.Z)(e, "ortb2Imp.ext.data.pbadslot");
                b && (o.aucs = encodeURIComponent(b));
                return w(o, p.pX, [e]), o;
              }(e, t);

              return {
                method: "GET",
                url: n.ph ? "https://u.openx.net/v/1.0/avjp" : "https://".concat(e.params.delDomain, "/v/1.0/avjp"),
                data: n,
                payload: {
                  bid: e,
                  startTime: new Date()
                }
              };
            }(e, t));
          }), n;
        },
        interpretResponse: function interpretResponse(e, t) {
          var n = e.body,
              a = function (e) {
            return /avjp$/.test(e.url) ? p.pX : p.Mk;
          }(t);

          return a === p.pX ? function (e, t) {
            var n = t.bid,
                a = (t.startTime, []);

            if (void 0 !== e && "" !== e.vastUrl && e.pub_rev > 0) {
              var i = (0, d.en)(e.vastUrl).search || {},
                  r = {};
              r.requestId = n.bidId, e.deal_id && (r.dealId = e.deal_id), r.ttl = 300, r.netRevenue = !0, r.currency = e.currency, r.cpm = parseInt(e.pub_rev, 10) / 1e3, r.width = parseInt(e.width, 10), r.height = parseInt(e.height, 10), r.creativeId = e.adid, r.vastUrl = e.vastUrl, r.mediaType = p.pX, e.ph = i.ph, e.colo = i.colo, e.ts = i.ts, a.push(r);
            }

            return a;
          }(n, t.payload) : function (e, t) {
            for (var n = t.bids, a = (t.startTime, e.ads.ad), i = [], r = 0; r < a.length; r++) {
              var d = a[r],
                  o = parseInt(d.idx, 10),
                  s = {};

              if (s.requestId = n[o].bidId, d.pub_rev) {
                s.cpm = Number(d.pub_rev) / 1e3;
                var c = d.creative[0];
                c && (s.width = c.width, s.height = c.height), s.creativeId = c.id, s.ad = d.html, d.deal_id && (s.dealId = d.deal_id), s.ttl = 300, s.netRevenue = !0, s.currency = d.currency, d.tbd && (s.tbd = d.tbd), s.ts = d.ts, s.meta = {}, d.brand_id && (s.meta.brandId = d.brand_id), d.adomain && length(d.adomain) > 0 ? s.meta.advertiserDomains = d.adomain : s.meta.advertiserDomains = [], d.adv_id && (s.meta.dspid = d.adv_id), i.push(s);
              }
            }

            return i;
          }(n, t.payload);
        },
        getUserSyncs: function getUserSyncs(e, t, n, a) {
          if (e.iframeEnabled || e.pixelEnabled) {
            var i = e.iframeEnabled ? "iframe" : "image",
                d = (0, r.Z)(t, "0.body.ads.pixels") || (0, r.Z)(t, "0.body.pixels") || function (e, t) {
              var n = "https://u.openx.net/w/1.0/pd",
                  a = [];
              e && (a.push("gdpr=" + (e.gdprApplies ? 1 : 0)), a.push("gdpr_consent=" + encodeURIComponent(e.consentString || "")));
              t && a.push("us_privacy=" + encodeURIComponent(t));
              return "".concat(n).concat(a.length > 0 ? "?" + a.join("&") : "");
            }(n, a);

            return [{
              type: i,
              url: d
            }];
          }
        },
        transformBidParams: function transformBidParams(e, t) {
          return (0, d.uh)({
            unit: "string",
            customFloor: "number"
          }, e);
        }
      };

      function I(e) {
        var t,
            n,
            a,
            i = window,
            r = document,
            d = r.documentElement;

        if (e) {
          try {
            i = window.top, r = window.top.document;
          } catch (e) {
            return;
          }

          a = r.body, t = i.innerWidth || d.clientWidth || a.clientWidth, n = i.innerHeight || d.clientHeight || a.clientHeight;
        } else t = i.innerWidth || d.clientWidth, n = i.innerHeight || d.clientHeight;

        return "".concat(t, "x").concat(n);
      }

      function y(e, t) {
        var n,
            a = (0, d.yL)();
        n = {
          ju: t.refererInfo.page,
          ch: document.charSet || document.characterSet,
          res: "".concat(screen.width, "x").concat(screen.height, "x").concat(screen.colorDepth),
          ifr: a,
          tz: new Date().getTimezoneOffset(),
          tws: I(a),
          be: 1,
          bc: e[0].params.bc || "".concat(h, "_").concat(v),
          dddid: (0, d.HA)(e, function (e) {
            return e.transactionId;
          }).join(","),
          nocache: new Date().getTime()
        };
        var i = k("user.data", t.ortb2);
        i.length > 0 && (n.sm = i);
        var c,
            p,
            u,
            m,
            l,
            f = k("site.content.data", t.ortb2);

        if (f.length > 0 && (n.scsm = f), e[0].params.platform && (n.ph = e[0].params.platform), t.gdprConsent) {
          var g = t.gdprConsent;
          void 0 !== g.consentString && (n.gdpr_consent = g.consentString), void 0 !== g.gdprApplies && (n.gdpr = g.gdprApplies ? 1 : 0), "iab" === s.vc.getConfig("consentManagement.cmpApi") && (n.x_gdpr_f = 1);
        }

        return t && t.uspConsent && (n.us_privacy = t.uspConsent), (0, r.Z)(e[0], "crumbs.pubcid") && (0, o.N)(e[0], "userId.pubcid", (0, r.Z)(e[0], "crumbs.pubcid")), c = n, p = e[0].userId, (0, d.yi)(p, function (e, t) {
          var n = b[t];
          if (b.hasOwnProperty(t)) switch (t) {
            case "merkleId":
            case "uid2":
              c[n] = e.id;
              break;

            case "lipb":
              if (c[n] = e.lipbid, Array.isArray(e.segments) && e.segments.length > 0) {
                var a = "liveintent:" + e.segments.join("|");
                c.sm = "".concat(c.sm ? c.sm + "," : "").concat(a);
              }

              break;

            case "parrableId":
              c[n] = e.eid;
              break;

            case "id5id":
              c[n] = e.uid;
              break;

            case "novatiq":
              c[n] = e.snowflake;
              break;

            default:
              c[n] = e;
          }
        }), n = c, e[0].schain && (n.schain = (u = e[0].schain, "".concat(u.ver, ",").concat(u.complete, "!").concat((m = u.nodes, l = ["asi", "sid", "hp", "rid", "name", "domain"], m.map(function (e) {
          return l.map(function (t) {
            return e[t] || "";
          }).join(",");
        }).join("!"))))), n;
      }

      function k(e, t) {
        var n = (0, r.Z)(t, e);
        if (!Array.isArray(n) || !n.length) return "";
        var i = n.filter(function (e) {
          return Array.isArray(e.segment) && e.segment.length > 0 && void 0 !== e.name && e.name.length > 0;
        }).reduce(function (e, t) {
          var n = "object" === (0, a.Z)(t.ext) && t.ext.segtax ? "".concat(t.name, "/").concat(t.ext.segtax) : t.name;
          return e[n] = (e[n] || []).concat(t.segment.map(function (e) {
            return e.id;
          })), e;
        }, {});
        return Object.keys(i).map(function (e, t) {
          return e + ":" + i[e].join("|");
        }).join(",");
      }

      function w(e, t, n) {
        var a = [],
            i = !1;
        n.forEach(function (e) {
          var n = function (e, t) {
            var n = {},
                a = s.vc.getConfig("currency.adServerCurrency") || f;
            "function" == typeof e.getFloor && (n = e.getFloor({
              currency: a,
              mediaType: t,
              size: "*"
            }));
            var i = n.floor || e.params.customFloor || 0;
            return Math.round(1e3 * i);
          }(e, t);

          n ? (a.push(n), i = !0) : a.push(0);
        }), i && (e.aumfs = a.join(","));
      }

      (0, c.dX)(g), window.pbjs.installedModules.push("openxBidAdapter");
    }
  }, function (e) {
    var t;
    t = 7851, e(e.s = t);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[979], {
    7211: function _(e, r, n) {
      var t = n(59),
          i = n(265),
          a = n(4358),
          s = n(5339),
          u = n(5706),
          o = {
        TITLE_LEN: 100,
        DESCR_LEN: 200,
        SPONSORED_BY_LEN: 50,
        IMG_MIN: 150,
        ICON_MIN: 50
      },
          d = "USD",
          p = ["cp", "ct", "cf", "video", "battr", "bcat", "badv", "bidfloor"],
          l = {
        code: "pulsepoint",
        gvlid: 81,
        aliases: ["pulseLite", "pulsepointLite"],
        supportedMediaTypes: ["banner", "native", "video"],
        isBidRequestValid: function isBidRequestValid(e) {
          return !!(e && e.params && e.params.cp && e.params.ct);
        },
        buildRequests: function buildRequests(e, r) {
          return {
            method: "POST",
            url: "https://bid.contextweb.com/header/ortb?src=prebid",
            data: {
              id: (e = (0, t.lY)(e))[0].bidderRequestId,
              imp: e.map(function (e) {
                return function (e) {
                  var r,
                      n = (null === (r = e.ortb2Imp) || void 0 === r ? void 0 : r.ext) || {},
                      t = Object.assign({}, n, function (e) {
                    var r = {},
                        n = {};
                    return p.forEach(function (e) {
                      return n[e] = 1;
                    }), Object.keys(e.params).forEach(function (t) {
                      n[t] || (r[t] = e.params[t]);
                    }), Object.keys(r).length > 0 ? {
                      prebid: r
                    } : null;
                  }(e));
                  return {
                    id: e.bidId,
                    banner: c(e),
                    native: f(e),
                    tagid: e.params.ct.toString(),
                    video: m(e),
                    bidfloor: w(e),
                    ext: Object.keys(t).length > 0 ? t : null
                  };
                }(e);
              }),
              site: h(e, r),
              app: y(e),
              device: {
                ua: navigator.userAgent,
                language: navigator.language || navigator.browserLanguage || navigator.userLanguage || navigator.systemLanguage
              },
              bcat: (0, i.Z)(r.ortb2Imp, "bcat") || e[0].params.bcat,
              badv: e[0].params.badv,
              user: I(e[0], r),
              regs: E(r),
              source: O(e[0].schain)
            },
            bidderRequest: r
          };
        },
        interpretResponse: function interpretResponse(e, r) {
          return function (e, r) {
            var n = {},
                t = {},
                s = {},
                o = r.body,
                p = e.data;
            p.imp.forEach(function (e) {
              n[e.id] = e;
            }), o && o.seatbid.forEach(function (e) {
              return e.bid.forEach(function (e) {
                t[e.impid] = e;
              });
            });
            e.bidderRequest && e.bidderRequest.bids && e.bidderRequest.bids.forEach(function (e) {
              s[e.bidId] = e;
            });
            var l = [];
            return Object.keys(n).forEach(function (e) {
              if (t[e]) {
                var r = {
                  requestId: e,
                  cpm: t[e].price,
                  creative_id: t[e].crid,
                  creativeId: t[e].crid,
                  adId: e,
                  ttl: t[e].exp || 20,
                  netRevenue: true,
                  currency: o.cur || d,
                  meta: {
                    advertiserDomains: t[e].adomain || []
                  }
                };
                n[e].video ? (s[e] && "outstream" === (0, i.Z)(s[e], "mediaTypes.video.context") && (r.renderer = (p = (0, i.Z)(s[e], "renderer.options"), c = (0, i.Z)(t[e], "ext.outstream"), (m = u.Th.install({
                  url: c.rendererUrl,
                  config: {
                    defaultOptions: c.config,
                    rendererOptions: p,
                    type: c.type
                  },
                  loaded: !1
                })).setRender(function (e) {
                  e.renderer.push(function () {
                    var r = e.renderer.getConfig();
                    new window.PulsePointOutstreamRenderer().render({
                      adUnitCode: e.adUnitCode,
                      vastXml: e.vastXml,
                      type: r.type,
                      defaultOptions: r.defaultOptions,
                      rendererOptions: p
                    });
                  });
                }), m)), r.vastXml = t[e].adm, r.mediaType = "video", r.width = t[e].w, r.height = t[e].h) : n[e].banner ? (r.ad = t[e].adm, r.width = t[e].w || n[e].banner.w, r.height = t[e].h || n[e].banner.h) : n[e].native && (r.native = function (e, r) {
                  if (e.native) {
                    var n = function (e) {
                      try {
                        if (e) return JSON.parse(e);
                      } catch (e) {
                        (0, a.H)("pulsepointLite.safeParse", "ERROR", e);
                      }

                      return null;
                    }(r.adm),
                        t = {};

                    if (n && n.native && n.native.assets) return n.native.assets.forEach(function (e) {
                      t.title = e.title ? e.title.text : t.title, t.body = e.data && 2 === e.data.type ? e.data.value : t.body, t.sponsoredBy = e.data && 1 === e.data.type ? e.data.value : t.sponsoredBy, t.image = e.img && 3 === e.img.type ? e.img.url : t.image, t.icon = e.img && 1 === e.img.type ? e.img.url : t.icon;
                    }), n.native.link && (t.clickUrl = encodeURIComponent(n.native.link.url)), t.impressionTrackers = n.native.imptrackers, t;
                  }

                  return null;
                }(n[e], t[e]), r.mediaType = "native"), l.push(r);
              }

              var p, c, m;
            }), l;
          }(r, e);
        },
        getUserSyncs: function getUserSyncs(e) {
          return e.iframeEnabled ? [{
            type: "iframe",
            url: "https://bh.contextweb.com/visitormatch"
          }] : e.pixelEnabled ? [{
            type: "image",
            url: "https://bh.contextweb.com/visitormatch/prebid"
          }] : void 0;
        },
        transformBidParams: function transformBidParams(e, r) {
          return (0, a.uh)({
            cf: "string",
            cp: "number",
            ct: "number"
          }, e);
        }
      };

      function c(e) {
        var r = function (e) {
          var r = (0, i.Z)(e, "mediaTypes.banner.sizes");
          if (r && (0, a.kJ)(r)) return r.filter(function (e) {
            return (0, a.kJ)(e) && 2 === e.length;
          }).map(function (e) {
            return {
              w: e[0],
              h: e[1]
            };
          });
          return null;
        }(e),
            n = function (e, r) {
          if (e.params.cf) {
            var n = e.params.cf.toUpperCase().split("X");
            return [parseInt(e.params.cw || n[0], 10), parseInt(e.params.ch || n[1], 10)];
          }

          if (r && r.length > 0) return [r[0].w, r[0].h];
          return [1, 1];
        }(e, r);

        return e.mediaTypes && e.mediaTypes.banner ? {
          w: n[0],
          h: n[1],
          battr: e.params.battr,
          format: r
        } : null;
      }

      function m(e) {
        return e.params.video ? Object.assign({}, e.params.video, e.mediaTypes && e.mediaTypes.video ? e.mediaTypes.video : {}, {
          battr: e.params.battr
        }) : null;
      }

      function f(e) {
        if (e.nativeParams) {
          var r = [];
          return v(r, function (e, r, n) {
            if (r) return {
              id: e,
              required: r.required ? 1 : 0,
              title: {
                len: r.len || n
              }
            };
            return null;
          }(r.length + 1, e.nativeParams.title, o.TITLE_LEN)), v(r, g(r.length + 1, e.nativeParams.body, 2, o.DESCR_LEN)), v(r, g(r.length + 1, e.nativeParams.sponsoredBy, 1, o.SPONSORED_BY_LEN)), v(r, b(r.length + 1, e.nativeParams.icon, 1, o.ICON_MIN, o.ICON_MIN)), v(r, b(r.length + 1, e.nativeParams.image, 3, o.IMG_MIN, o.IMG_MIN)), {
            request: JSON.stringify({
              assets: r
            }),
            ver: "1.1",
            battr: e.params.battr
          };
        }

        return null;
      }

      function v(e, r) {
        r && e.push(r);
      }

      function b(e, r, n, t, i) {
        return r ? {
          id: e,
          required: r.required ? 1 : 0,
          img: {
            type: n,
            wmin: r.wmin || t,
            hmin: r.hmin || i
          }
        } : null;
      }

      function g(e, r, n, t) {
        return r ? {
          id: e,
          required: r.required ? 1 : 0,
          data: {
            type: n,
            len: r.len || t
          }
        } : null;
      }

      function h(e, r) {
        var n = e && e.length > 0 ? e[0].params.cp : "0";

        if (!e[0].params.app) {
          var t,
              i,
              a,
              s = (null == r || null === (t = r.ortb2) || void 0 === t ? void 0 : t.site) || {};
          return Object.assign({}, s, {
            publisher: {
              id: n.toString()
            },
            ref: (null == r || null === (i = r.refererInfo) || void 0 === i ? void 0 : i.ref) || window.document.referrer,
            page: (null == r || null === (a = r.refererInfo) || void 0 === a ? void 0 : a.page) || ""
          });
        }

        return null;
      }

      function y(e) {
        var r = e && e.length > 0 ? e[0].params.cp : "0",
            n = e[0].params.app;
        return n ? {
          publisher: {
            id: r.toString()
          },
          bundle: n.bundle,
          storeurl: n.storeUrl,
          domain: n.domain
        } : null;
      }

      function I(e, r) {
        var n,
            t = (null == r || null === (n = r.ortb2) || void 0 === n ? void 0 : n.user) || {
          ext: {}
        },
            i = t.ext;

        if (r && r.gdprConsent && (i.consent = r.gdprConsent.consentString), e) {
          var a = e.userIdAsEids;
          a && (i.eids = a);
        }

        return t;
      }

      function E(e) {
        if (e.gdprConsent || e.uspConsent) {
          var r = {};
          return e.gdprConsent && (r.gdpr = e.gdprConsent.gdprApplies ? 1 : 0), e.uspConsent && (r.us_privacy = e.uspConsent), {
            ext: r
          };
        }

        return null;
      }

      function O(e) {
        return e ? {
          ext: {
            schain: e
          }
        } : null;
      }

      function w(e) {
        var r = e.params.bidfloor;

        if ((0, a.LQ)(e.getFloor)) {
          var n = e.getFloor({
            mediaType: e.mediaTypes.banner ? "banner" : e.mediaTypes.video ? "video" : "Native",
            size: "*",
            currency: d
          });
          n && n.floor && (r = n.floor);
        }

        return r;
      }

      (0, s.dX)(l), window.pbjs.installedModules.push("pulsepointBidAdapter");
    }
  }, function (e) {
    var r;
    r = 7211, e(e.s = r);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[187], {
    60: function _(e, t, r) {
      var i = r(3324),
          n = r(4942),
          a = r(1002),
          o = r(4358),
          s = r(265),
          c = r(6475),
          d = r(5339),
          p = r(3193),
          u = r(4679),
          l = r(4614),
          m = r(5706),
          v = r(8640);

      function f(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);
          t && (i = i.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, i);
        }

        return r;
      }

      function g(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? f(Object(r), !0).forEach(function (t) {
            (0, n.Z)(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }

      var b = "https://video-outstream.rubiconproject.com/apex-2.2.1.js",
          x = {};
      p.vc.getConfig("rubicon", function (e) {
        (0, o.Ee)(x, e.rubicon);
      });
      var y = {
        1: "468x60",
        2: "728x90",
        5: "120x90",
        7: "125x125",
        8: "120x600",
        9: "160x600",
        10: "300x600",
        13: "200x200",
        14: "250x250",
        15: "300x250",
        16: "336x280",
        17: "240x400",
        19: "300x100",
        31: "980x120",
        32: "250x360",
        33: "180x500",
        35: "980x150",
        37: "468x400",
        38: "930x180",
        39: "750x100",
        40: "750x200",
        41: "750x300",
        42: "2x4",
        43: "320x50",
        44: "300x50",
        48: "300x300",
        53: "1024x768",
        54: "300x1050",
        55: "970x90",
        57: "970x250",
        58: "1000x90",
        59: "320x80",
        60: "320x150",
        61: "1000x1000",
        64: "580x500",
        65: "640x480",
        66: "930x600",
        67: "320x480",
        68: "1800x1000",
        72: "320x320",
        73: "320x160",
        78: "980x240",
        79: "980x300",
        80: "980x400",
        83: "480x300",
        85: "300x120",
        90: "548x150",
        94: "970x310",
        95: "970x100",
        96: "970x210",
        101: "480x320",
        102: "768x1024",
        103: "480x280",
        105: "250x800",
        108: "320x240",
        113: "1000x300",
        117: "320x100",
        125: "800x250",
        126: "200x600",
        144: "980x600",
        145: "980x150",
        152: "1000x250",
        156: "640x320",
        159: "320x250",
        179: "250x600",
        195: "600x300",
        198: "640x360",
        199: "640x200",
        213: "1030x590",
        214: "980x360",
        221: "1x1",
        229: "320x180",
        230: "2000x1400",
        232: "580x400",
        234: "6x6",
        251: "2x2",
        256: "480x820",
        257: "400x600",
        258: "500x200",
        259: "998x200",
        264: "970x1000",
        265: "1920x1080",
        274: "1800x200",
        278: "320x500",
        282: "320x400",
        288: "640x380",
        548: "500x1000",
        550: "980x480",
        552: "300x200",
        558: "640x640",
        562: "300x431",
        564: "320x431",
        566: "320x300",
        568: "300x150",
        570: "300x125",
        572: "250x350",
        574: "620x891",
        576: "610x877",
        578: "980x552",
        580: "505x656"
      };
      (0, o.yi)(y, function (e, t) {
        return y[e] = t;
      });
      var h = {
        code: "rubicon",
        gvlid: 52,
        supportedMediaTypes: [u.Mk, u.pX],
        isBidRequestValid: function isBidRequestValid(e) {
          if ("object" !== (0, a.Z)(e.params)) return !1;

          for (var t = 0, r = ["accountId", "siteId", "zoneId"]; t < r.length; t++) {
            if (e.params[r[t]] = parseInt(e.params[r[t]]), isNaN(e.params[r[t]])) return (0, o.H)("Rubicon: wrong format of accountId or siteId or zoneId."), !1;
          }

          var i = Z(e, !0);
          return !!i && ("video" !== i || function (e) {
            var t = !0,
                r = Object.prototype.toString.call([]),
                i = Object.prototype.toString.call(0),
                n = {
              mimes: r,
              protocols: r,
              linearity: i,
              api: r
            };
            return Object.keys(n).forEach(function (r) {
              Object.prototype.toString.call((0, s.Z)(e, "mediaTypes.video." + r)) !== n[r] && (t = !1, (0, o.H)("Rubicon: mediaTypes.video." + r + " is required and must be of type: " + n[r]));
            }), t;
          }(e));
        },
        buildRequests: function buildRequests(e, t) {
          var r = [],
              i = e.filter(function (e) {
            return "video" === Z(e);
          }).map(function (e) {
            e.startTime = new Date().getTime();
            var r,
                i = {
              id: e.transactionId,
              test: p.vc.getConfig("debug") ? 1 : 0,
              cur: ["USD"],
              source: {
                tid: e.transactionId
              },
              tmax: t.timeout,
              imp: [{
                exp: p.vc.getConfig("s2sConfig.defaultTtl"),
                id: e.adUnitCode,
                secure: 1,
                ext: (0, n.Z)({}, e.bidder, e.params),
                video: (0, s.Z)(e, "mediaTypes.video") || {}
              }],
              ext: {
                prebid: {
                  channel: {
                    name: "pbjs",
                    version: pbjs.version
                  },
                  cache: {
                    vastxml: {
                      returnCreative: !0 === x.returnVast
                    }
                  },
                  targeting: {
                    includewinners: !0,
                    includebidderkeys: !1,
                    pricegranularity: (r = p.vc, {
                      ranges: {
                        low: [{
                          max: 5,
                          increment: .5
                        }],
                        medium: [{
                          max: 20,
                          increment: .1
                        }],
                        high: [{
                          max: 20,
                          increment: .01
                        }],
                        auto: [{
                          max: 5,
                          increment: .05
                        }, {
                          min: 5,
                          max: 10,
                          increment: .1
                        }, {
                          min: 10,
                          max: 20,
                          increment: .5
                        }],
                        dense: [{
                          max: 3,
                          increment: .01
                        }, {
                          min: 3,
                          max: 8,
                          increment: .05
                        }, {
                          min: 8,
                          max: 20,
                          increment: .5
                        }],
                        custom: r.getConfig("customPriceBucket") && r.getConfig("customPriceBucket").buckets
                      }[r.getConfig("priceGranularity")]
                    })
                  },
                  bidders: {
                    rubicon: {
                      integration: x.int_type || "pbjs"
                    }
                  }
                }
              }
            };
            "rubicon" !== e.bidder && (i.ext.prebid.aliases = (0, n.Z)({}, e.bidder, "rubicon"));
            var d,
                l,
                m = (0, v.R)().installedModules;
            if (!m || m.length && -1 === m.indexOf("rubiconAnalyticsAdapter") || (0, c.N)(i, "ext.prebid.analytics", {
              rubicon: {
                "client-analytics": !0
              }
            }), "function" != typeof e.getFloor || x.disableFloors) d = parseFloat((0, s.Z)(e, "params.floor"));else {
              var f;

              try {
                f = e.getFloor({
                  currency: "USD",
                  mediaType: "video",
                  size: k(e, "video")
                });
              } catch (e) {
                (0, o.H)("Rubicon: getFloor threw an error: ", e);
              }

              d = "object" !== (0, a.Z)(f) || "USD" !== f.currency || isNaN(parseInt(f.floor)) ? void 0 : parseFloat(f.floor);
            }
            (isNaN(d) || (i.imp[0].bidfloor = d), "object" === (0, a.Z)(e.floorData) && (i.ext.prebid.floors = {
              enabled: !1
            }), i.imp[0].ext[e.bidder].video.size_id = function (e) {
              var t = parseInt((0, s.Z)(e, "params.video.size_id"));
              if (!isNaN(t)) return t;
              return "outstream" === (0, s.Z)(e, "mediaTypes.".concat(u.pX, ".context")) ? 203 : 201;
            }(e), function (e, t, r) {
              if (!e) return;
              "object" === (0, a.Z)(p.vc.getConfig("app")) ? e.app = p.vc.getConfig("app") : e.site = {
                page: _(t, r)
              };
              "object" === (0, a.Z)(p.vc.getConfig("device")) && (e.device = p.vc.getConfig("device"));
              t.params.video.language && ["site", "device"].forEach(function (r) {
                e[r] && ("site" === r ? e[r].content = Object.assign({
                  language: t.params.video.language
                }, e[r].content) : e[r] = Object.assign({
                  language: t.params.video.language
                }, e[r]));
              });
            }(i, e, t), function (e, t) {
              "object" === (0, a.Z)(e.imp[0].video) && void 0 === e.imp[0].video.skip && (e.imp[0].video.skip = t.params.video.skip);
              "object" === (0, a.Z)(e.imp[0].video) && void 0 === e.imp[0].video.skipafter && (e.imp[0].video.skipafter = t.params.video.skipdelay);
              "object" === (0, a.Z)(e.imp[0].video) && void 0 === e.imp[0].video.pos && ("atf" === t.params.position ? e.imp[0].video.pos = 1 : "btf" === t.params.position && (e.imp[0].video.pos = 3));
              var r = k(t, "video");
              e.imp[0].video.w = r[0], e.imp[0].video.h = r[1];
            }(i, e), t.gdprConsent) && ("boolean" == typeof t.gdprConsent.gdprApplies && (l = t.gdprConsent.gdprApplies ? 1 : 0), (0, c.N)(i, "regs.ext.gdpr", l), (0, c.N)(i, "user.ext.consent", t.gdprConsent.consentString));
            t.uspConsent && (0, c.N)(i, "regs.ext.us_privacy", t.uspConsent);
            var g = (0, s.Z)(t, "bids.0.userIdAsEids");
            g && g.length && (0, c.N)(i, "user.ext.eids", g);
            var b = p.vc.getConfig("user.id");
            b && (0, c.N)(i, "user.id", b), !0 === p.vc.getConfig("coppa") && (0, c.N)(i, "regs.coppa", 1), e.schain && w(e.schain) && (0, c.N)(i, "source.ext.schain", e.schain);
            var y = p.vc.getConfig("multibid");
            return y && (0, c.N)(i, "ext.prebid.multibid", y.reduce(function (e, t) {
              var r = {};
              return Object.keys(t).forEach(function (e) {
                r[e.toLowerCase()] = t[e];
              }), e.push(r), e;
            }, [])), C(e, u.pX, i), (0, c.N)(i.imp[0], "ext.prebid.auctiontimestamp", t.auctionStart), i.ext.prebid.storedrequest = void 0, i.imp[0].ext.prebid.storedrequest = void 0, {
              method: "POST",
              url: "https://".concat(x.videoHost || "prebid-server", ".rubiconproject.com/openrtb2/auction"),
              data: i,
              bidRequest: e
            };
          });
          if (!0 !== p.vc.getConfig("rubicon.singleRequest")) r = i.concat(e.filter(function (e) {
            return "banner" === Z(e);
          }).map(function (e) {
            var r = h.createSlotParams(e, t);
            return {
              method: "GET",
              url: "https://".concat(x.bannerHost || "fastlane", ".rubiconproject.com/a/api/fastlane.json"),
              data: h.getOrderedParams(r).reduce(function (e, t) {
                var i = r[t];
                return (0, o.d8)(i) && "" !== i || (0, o.hj)(i) ? "".concat(e).concat(A(t, i), "&") : e;
              }, "") + "slots=1&rand=".concat(Math.random()),
              bidRequest: e
            };
          }));else {
            var d = e.filter(function (e) {
              return "banner" === Z(e);
            }).reduce(function (e, t) {
              return (e[t.params.siteId] = e[t.params.siteId] || []).push(t), e;
            }, {});
            r = i.concat(Object.keys(d).reduce(function (e, r) {
              var i, n;
              return (i = d[r], n = 10, i.map(function (e, t) {
                return t % n == 0 ? i.slice(t, t + n) : null;
              }).filter(function (e) {
                return e;
              })).forEach(function (r) {
                var i = h.combineSlotUrlParams(r.map(function (e) {
                  return h.createSlotParams(e, t);
                }));
                e.push({
                  method: "GET",
                  url: "https://".concat(x.bannerHost || "fastlane", ".rubiconproject.com/a/api/fastlane.json"),
                  data: h.getOrderedParams(i).reduce(function (e, t) {
                    var r = i[t];
                    return (0, o.d8)(r) && "" !== r || (0, o.hj)(r) ? "".concat(e).concat(A(t, r), "&") : e;
                  }, "") + "slots=".concat(r.length, "&rand=").concat(Math.random()),
                  bidRequest: r
                });
              }), e;
            }, []));
          }
          return r;
        },
        getOrderedParams: function getOrderedParams(e) {
          var t = /^tg_v/,
              r = /^tg_i/,
              i = /^eid_|^tpid_/,
              n = ["account_id", "site_id", "zone_id", "size_id", "alt_size_ids", "p_pos", "gdpr", "gdpr_consent", "us_privacy", "rp_schain"].concat(Object.keys(e).filter(function (e) {
            return i.test(e);
          })).concat(["x_liverampidl", "ppuid", "rf", "p_geo.latitude", "p_geo.longitude", "kw"]).concat(Object.keys(e).filter(function (e) {
            return t.test(e);
          })).concat(Object.keys(e).filter(function (e) {
            return r.test(e);
          })).concat(["tk_flint", "x_source.tid", "l_pb_bid_id", "x_source.pchain", "p_screen_res", "rp_floor", "rp_secure", "tk_user_key"]);
          return n.concat(Object.keys(e).filter(function (e) {
            return -1 === n.indexOf(e);
          }));
        },
        combineSlotUrlParams: function combineSlotUrlParams(e) {
          if (1 === e.length) return e[0];
          var t = e.reduce(function (t, r, i) {
            return Object.keys(r).forEach(function (n) {
              t.hasOwnProperty(n) || (t[n] = new Array(e.length)), t[n].splice(i, 1, r[n]);
            }), t;
          }, {}),
              r = new RegExp("^([^;]*)(;\\1)+$");
          return Object.keys(t).forEach(function (e) {
            var i = t[e].join(";"),
                n = i.match(r);
            t[e] = n ? n[1] : i;
          }), t;
        },
        createSlotParams: function createSlotParams(e, t) {
          e.startTime = new Date().getTime();
          var r = e.params,
              n = k(e, "banner"),
              c = r.latLong || [],
              d = (0, i.Z)(c, 2),
              m = d[0],
              v = d[1],
              f = {
            account_id: r.accountId,
            site_id: r.siteId,
            zone_id: r.zoneId,
            size_id: n[0],
            alt_size_ids: n.slice(1).join(",") || void 0,
            rp_floor: (r.floor = parseFloat(r.floor)) >= .01 ? r.floor : void 0,
            rp_secure: "1",
            tk_flint: "".concat(x.int_type || "pbjs_lite", "_v7.25.0"),
            "x_source.tid": e.transactionId,
            l_pb_bid_id: e.bidId,
            "x_source.pchain": r.pchain,
            p_screen_res: [window.screen.width, window.screen.height].join("x"),
            tk_user_key: r.userId,
            "p_geo.latitude": isNaN(parseFloat(m)) ? void 0 : parseFloat(m).toFixed(4),
            "p_geo.longitude": isNaN(parseFloat(v)) ? void 0 : parseFloat(v).toFixed(4),
            "tg_fl.eid": e.code,
            rf: _(e, t)
          };

          if ("function" == typeof e.getFloor && !x.disableFloors) {
            var g;

            try {
              g = e.getFloor({
                currency: "USD",
                mediaType: "banner",
                size: "*"
              });
            } catch (e) {
              (0, o.H)("Rubicon: getFloor threw an error: ", e);
            }

            f.rp_hard_floor = "object" !== (0, a.Z)(g) || "USD" !== g.currency || isNaN(parseInt(g.floor)) ? void 0 : g.floor;
          }

          var b = {
            1: "atf",
            3: "btf"
          }[(0, s.Z)(e, "mediaTypes.banner.pos")] || "";
          f.p_pos = "atf" === r.position || "btf" === r.position ? r.position : b;
          var y = p.vc.getConfig("user.id");
          return y && (f.ppuid = y), e.userIdAsEids && e.userIdAsEids.forEach(function (e) {
            try {
              if ("adserver.org" === e.source ? (f.tpid_tdid = e.uids[0].id, f["eid_adserver.org"] = e.uids[0].id) : "liveintent.com" === e.source ? (f["tpid_liveintent.com"] = e.uids[0].id, f["eid_liveintent.com"] = e.uids[0].id, e.ext && Array.isArray(e.ext.segments) && e.ext.segments.length && (f["tg_v.LIseg"] = e.ext.segments.join(","))) : "liveramp.com" === e.source ? f.x_liverampidl = e.uids[0].id : "id5-sync.com" === e.source ? f["eid_id5-sync.com"] = "".concat(e.uids[0].id, "^").concat(e.uids[0].atype, "^").concat(e.uids[0].ext && e.uids[0].ext.linkType || "") : f["eid_".concat(e.source)] = "".concat(e.uids[0].id, "^").concat(e.uids[0].atype || ""), !f.ppuid) {
                var t = (0, l.sE)(e.uids, function (e) {
                  return e.ext && "ppuid" === e.ext.stype;
                });
                t && t.id && (f.ppuid = t.id);
              }
            } catch (t) {
              (0, o.yN)("Rubicon: error reading eid:", e, t);
            }
          }), t.gdprConsent && ("boolean" == typeof t.gdprConsent.gdprApplies && (f.gdpr = Number(t.gdprConsent.gdprApplies)), f.gdpr_consent = t.gdprConsent.consentString), t.uspConsent && (f.us_privacy = encodeURIComponent(t.uspConsent)), f.rp_maxbids = t.bidLimit || 1, C(e, u.Mk, f), !0 === p.vc.getConfig("coppa") && (f.coppa = 1), e.schain && w(e.schain) && (f.rp_schain = h.serializeSupplyChain(e.schain)), f;
        },
        serializeSupplyChain: function serializeSupplyChain(e) {
          if (!w(e)) return "";
          var t = e.ver,
              r = e.complete,
              i = e.nodes;
          return "".concat(t, ",").concat(r, "!").concat(h.serializeSupplyChainNodes(i));
        },
        serializeSupplyChainNodes: function serializeSupplyChainNodes(e) {
          var t = ["asi", "sid", "hp", "rid", "name", "domain"];
          return e.map(function (e) {
            return t.map(function (t) {
              return encodeURIComponent(e[t] || "");
            }).join(",");
          }).join("!");
        },
        interpretResponse: function interpretResponse(e, t) {
          var r = t.bidRequest;
          if (!(e = e.body) || "object" !== (0, a.Z)(e)) return [];

          if (e.seatbid) {
            var n = (0, s.Z)(e, "ext.errors.rubicon");
            Array.isArray(n) && n.length > 0 && (0, o.yN)("Rubicon: Error in video response");
            var d = [];
            return e.seatbid.forEach(function (t) {
              (t.bid || []).forEach(function (i) {
                var n = {
                  requestId: r.bidId,
                  currency: e.cur || "USD",
                  creativeId: i.crid,
                  cpm: i.price || 0,
                  bidderCode: t.seat,
                  ttl: 300,
                  netRevenue: !1 !== x.netRevenue,
                  width: i.w || (0, s.Z)(r, "mediaTypes.video.w") || (0, s.Z)(r, "params.video.playerWidth"),
                  height: i.h || (0, s.Z)(r, "mediaTypes.video.h") || (0, s.Z)(r, "params.video.playerHeight")
                };
                i.id && (n.seatBidId = i.id), i.dealid && (n.dealId = i.dealid), i.adomain && (0, c.N)(n, "meta.advertiserDomains", Array.isArray(i.adomain) ? i.adomain : [i.adomain]), (0, s.Z)(i, "ext.bidder.rp.advid") && (0, c.N)(n, "meta.advertiserId", i.ext.bidder.rp.advid);
                var p = (0, s.Z)(e, "ext.responsetimemillis.rubicon");

                if (r && p && (r.serverResponseTimeMs = p), (0, s.Z)(i, "ext.prebid.type") === u.pX) {
                  n.mediaType = u.pX, (0, c.N)(n, "meta.mediaType", u.pX);
                  var l = (0, s.Z)(i, "ext.prebid.targeting");
                  l && "object" === (0, a.Z)(l) && (n.adserverTargeting = l), i.ext.prebid.cache && "object" === (0, a.Z)(i.ext.prebid.cache.vastXml) && i.ext.prebid.cache.vastXml.cacheId && i.ext.prebid.cache.vastXml.url ? (n.videoCacheKey = i.ext.prebid.cache.vastXml.cacheId, n.vastUrl = i.ext.prebid.cache.vastXml.url) : l && l.hb_uuid && l.hb_cache_host && l.hb_cache_path && (n.videoCacheKey = l.hb_uuid, n.vastUrl = "https://".concat(l.hb_cache_host).concat(l.hb_cache_path, "?uuid=").concat(l.hb_uuid)), i.adm && (n.vastXml = i.adm), i.nurl && (n.vastUrl = i.nurl), !n.vastUrl && i.nurl && (n.vastUrl = i.nurl), "outstream" === (0, s.Z)(r, "mediaTypes.video.context").toLowerCase() && (n.renderer = function (e) {
                    var t = m.Th.install({
                      id: e.adId,
                      url: x.rendererUrl || b,
                      config: x.rendererConfig || {},
                      loaded: !1,
                      adUnitCode: e.adUnitCode
                    });

                    try {
                      t.setRender(j);
                    } catch (e) {
                      (0, o.yN)("Prebid Error calling setRender on renderer", e);
                    }

                    return t;
                  }(n));
                } else (0, o.yN)("Rubicon: video response received non-video media type");

                d.push(n);
              });
            }), d;
          }

          var p,
              l = e.ads,
              v = 0;
          return "object" !== (0, a.Z)(r) || Array.isArray(r) || "video" !== Z(r) || "object" !== (0, a.Z)(l) || (l = l[r.adUnitCode]), !Array.isArray(l) || l.length < 1 ? [] : l.reduce(function (t, n, s) {
            if (n.impression_id && p === n.impression_id ? v++ : p = n.impression_id, "ok" !== n.status) return t;
            var c,
                d,
                l = Array.isArray(r) ? r[s - v] : r;

            if (l && "object" === (0, a.Z)(l)) {
              var m = {
                requestId: l.bidId,
                currency: "USD",
                creativeId: n.creative_id || "".concat(n.network || "", "-").concat(n.advertiser || ""),
                cpm: n.cpm || 0,
                dealId: n.deal,
                ttl: 300,
                netRevenue: !1 !== x.netRevenue,
                rubicon: {
                  advertiserId: n.advertiser,
                  networkId: n.network
                },
                meta: {
                  advertiserId: n.advertiser,
                  networkId: n.network,
                  mediaType: u.Mk
                }
              };
              if (n.creative_type && (m.mediaType = n.creative_type), n.adomain && (m.meta.advertiserDomains = Array.isArray(n.adomain) ? n.adomain : [n.adomain]), n.creative_type === u.pX) m.width = l.params.video.playerWidth, m.height = l.params.video.playerHeight, m.vastUrl = n.creative_depot_url, m.impression_id = n.impression_id, m.videoCacheKey = n.impression_id;else {
                m.ad = (c = n.script, d = n.impression_id, "<html>\n<head><script type='text/javascript'>inDapIF=true;<\/script></head>\n<body style='margin : 0; padding: 0;'>\n\x3c!-- Rubicon Project Ad Tag --\x3e\n<div data-rp-impression-id='".concat(d, "'>\n<script type='text/javascript'>").concat(c, "<\/script>\n</div>\n</body>\n</html>"));
                var f = y[n.size_id].split("x").map(function (e) {
                  return Number(e);
                }),
                    g = (0, i.Z)(f, 2);
                m.width = g[0], m.height = g[1];
              }
              m.rubiconTargeting = (Array.isArray(n.targeting) ? n.targeting : []).reduce(function (e, t) {
                return e[t.key] = t.values[0], e;
              }, {
                rpfl_elemid: l.adUnitCode
              }), t.push(m);
            } else (0, o.H)("Rubicon: bidRequest undefined at index position:".concat(s), r, e);

            return t;
          }, []).sort(function (e, t) {
            return (t.cpm || 0) - (e.cpm || 0);
          });
        },
        getUserSyncs: function getUserSyncs(e, t, r, i) {
          if (!O && e.iframeEnabled) {
            var n = {};
            return r && ("boolean" == typeof r.gdprApplies && (n.gdpr = Number(r.gdprApplies)), "string" == typeof r.consentString && (n.gdpr_consent = r.consentString)), i && (n.us_privacy = encodeURIComponent(i)), n = Object.keys(n).length ? "?".concat((0, o.Yp)(n)) : "", O = !0, {
              type: "iframe",
              url: "https://".concat(x.syncHost || "eus", ".rubiconproject.com/usync.html") + n
            };
          }
        },
        transformBidParams: function transformBidParams(e, t) {
          return (0, o.uh)({
            accountId: "number",
            siteId: "number",
            zoneId: "number"
          }, e);
        }
      };

      function _(e, t) {
        var r;
        return r = e.params.referrer ? e.params.referrer : t.refererInfo.page, e.params.secure ? r.replace(/^http:/i, "https:") : r;
      }

      function j(e) {
        var t,
            r = document.getElementById(e.adUnitCode);
        (t = r.querySelector("div[id^='google_ads']")) && t.style.setProperty("display", "none"), function (e) {
          var t = e.querySelector("script[id^='sas_script']"),
              r = t && t.nextSibling;
          r && "iframe" === r.localName && r.style.setProperty("display", "none");
        }(r);
        var i = e.renderer.getConfig();
        e.renderer.push(function () {
          window.MagniteApex.renderAd({
            width: e.width,
            height: e.height,
            vastUrl: e.vastUrl,
            placement: {
              attachTo: r,
              align: i.align || "center",
              position: i.position || "append"
            },
            closeButton: i.closeButton || !1,
            label: i.label || void 0,
            collapse: i.collapse || !0
          });
        });
      }

      function k(e, t) {
        var r = e.params;

        if ("video" === t) {
          var i = [];
          return r.video && r.video.playerWidth && r.video.playerHeight ? i = [r.video.playerWidth, r.video.playerHeight] : Array.isArray((0, s.Z)(e, "mediaTypes.video.playerSize")) && 1 === e.mediaTypes.video.playerSize.length ? i = e.mediaTypes.video.playerSize[0] : Array.isArray(e.sizes) && e.sizes.length > 0 && Array.isArray(e.sizes[0]) && e.sizes[0].length > 1 && (i = e.sizes[0]), i;
        }

        var n = [];
        return Array.isArray(r.sizes) ? n = r.sizes : void 0 !== (0, s.Z)(e, "mediaTypes.banner.sizes") ? n = I(e.mediaTypes.banner.sizes) : Array.isArray(e.sizes) && e.sizes.length > 0 ? n = I(e.sizes) : (0, o.yN)("Rubicon: no sizes are setup or found"), function (e) {
          var t = [15, 2, 9];
          return e.sort(function (e, r) {
            var i = t.indexOf(e),
                n = t.indexOf(r);
            return i > -1 || n > -1 ? -1 === i ? 1 : -1 === n ? -1 : i - n : e - r;
          });
        }(n);
      }

      function C(e, t, r) {
        var i = {
          user: {
            ext: {
              data: g({}, e.params.visitor)
            }
          },
          site: {
            ext: {
              data: g({}, e.params.inventory)
            }
          }
        };
        e.params.keywords && (i.site.keywords = (0, o.kJ)(e.params.keywords) ? e.params.keywords.join(",") : e.params.keywords);

        var n = (0, o.Ee)({}, e.ortb2 || {}, i),
            c = (0, s.Z)(e.ortb2Imp, "ext") || {},
            d = (0, s.Z)(e.ortb2Imp, "ext.data") || {},
            p = (0, s.Z)(e, "ortb2Imp.ext.gpid"),
            l = {
          user: [4],
          site: [1, 2, 5, 6]
        },
            m = {
          user: "tg_v.",
          site: "tg_i.",
          adserver: "tg_i.dfp_ad_unit_code",
          pbadslot: "tg_i.pbadslot",
          keywords: "kw"
        },
            v = function v(e, t, i) {
          var n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
              c = function (e, t, r) {
            return "data" === t && Array.isArray(e) ? e.filter(function (e) {
              return e.segment && (0, s.Z)(e, "ext.segtax") && l[r] && -1 !== l[r].indexOf((0, s.Z)(e, "ext.segtax"));
            }).map(function (e) {
              var t = e.segment.filter(function (e) {
                return e.id;
              }).reduce(function (e, t) {
                return e.push(t.id), e;
              }, []);
              if (t.length > 0) return t.toString();
            }).toString() : "object" === (0, a.Z)(e) && !Array.isArray(e) || void 0 === e ? void 0 : Array.isArray(e) ? e.filter(function (e) {
              if ("object" !== (0, a.Z)(e) && void 0 !== e) return e.toString();
              (0, o.yN)("Rubicon: Filtered value: ", e, "for key", t, ": Expected value to be string, integer, or an array of strings/ints");
            }).toString() : e.toString();
          }(e, i, t),
              d = m[i] && n ? "".concat(m[i]) : "data" === i ? "".concat(m[t], "iab") : "".concat(m[t]).concat(i);

          r[d] = r[d] ? r[d].concat(",", c) : c;
        };

        t === u.Mk ? (["site", "user"].forEach(function (e) {
          Object.keys(n[e]).forEach(function (t) {
            "site" === e && "content" === t && n[e][t].data ? v(n[e][t].data, e, "data") : "ext" !== t ? v(n[e][t], e, t) : n[e][t].data && Object.keys(n[e].ext.data).forEach(function (t) {
              v(n[e].ext.data[t], e, t, !1);
            });
          });
        }), Object.keys(d).forEach(function (e) {
          "adserver" !== e ? v(d[e], "site", e) : "gam" === d[e].name && v(d[e].adslot, name, e);
        }), p && (r.p_gpid = p), r["tg_i.pbadslot"] && delete r["tg_i.dfp_ad_unit_code"]) : (Object.keys(c).length && (0, o.Ee)(r.imp[0].ext, c), p && (r.imp[0].ext.gpid = p), (0, o.Ee)(r, n));
      }

      function I(e) {
        return (0, o.sF)(e).reduce(function (e, t) {
          var r = parseInt(y[t], 10);
          return r && e.push(r), e;
        }, []);
      }

      function Z(e) {
        var t,
            r,
            i,
            n,
            d = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return t = e, r = void 0 !== (0, s.Z)(t, "mediaTypes.".concat(u.pX)), i = void 0 !== (0, s.Z)(t, "mediaTypes.".concat(u.Mk)), n = "object" !== (0, a.Z)((0, s.Z)(t, "params.video")), i && n && (r = !1), r && n && (0, c.N)(t, "params.video", {}), r ? -1 === ["outstream", "instream"].indexOf((0, s.Z)(e, "mediaTypes.".concat(u.pX, ".context"))) ? void (d && (0, o.H)("Rubicon: mediaTypes.video.context must be outstream or instream")) : k(e, "video").length < 2 ? void (d && (0, o.H)("Rubicon: could not determine the playerSize of the video")) : (d && (0, o.ji)("Rubicon: making video request for adUnit", e.adUnitCode), "video") : 0 === k(e, "banner").length ? void (d && (0, o.H)("Rubicon: could not determine the sizes for banner request")) : (d && (0, o.ji)("Rubicon: making banner request for adUnit", e.adUnitCode), "banner");
      }

      function w(e) {
        var t = !1,
            r = ["asi", "sid", "hp"];
        return e.nodes ? ((t = e.nodes.reduce(function (e, t) {
          return e ? r.every(function (e) {
            return t.hasOwnProperty(e);
          }) : e;
        }, !0)) || (0, o.H)("Rubicon: required schain params missing"), t) : t;
      }

      function A(e, t) {
        return "rp_schain" === e ? "rp_schain=".concat(t) : "".concat(e, "=").concat(encodeURIComponent(t));
      }

      var O = !1;
      (0, d.dX)(h), window.pbjs.installedModules.push("rubiconBidAdapter");
    }
  }, function (e) {
    var t;
    t = 60, e(e.s = t);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[302], {
    1415: function _(e, i, r) {
      var n = r(3324),
          t = r(4942),
          s = r(5339),
          a = r(4358),
          o = r(265),
          d = r(4679),
          c = r(3193),
          u = r(5706),
          p = r(1974),
          l = "sonobi",
          f = (0, a.DO)(),
          v = "https://mtrx.go.sonobi.com/sbi_outstream_renderer.js",
          m = {
        code: l,
        gvlid: 104,
        supportedMediaTypes: [d.Mk, d.pX],
        isBidRequestValid: function isBidRequestValid(e) {
          if (!e.params) return !1;
          if (!e.params.ad_unit && !e.params.placement_id) return !1;
          if (!(0, o.Z)(e, "mediaTypes.banner") && !(0, o.Z)(e, "mediaTypes.video")) return !1;

          if ((0, o.Z)(e, "mediaTypes.banner")) {
            if (!(0, o.Z)(e, "mediaTypes.banner.sizes") && !e.params.sizes) return !1;
          } else if ((0, o.Z)(e, "mediaTypes.video")) {
            if ("outstream" === (0, o.Z)(e, "mediaTypes.video.context") && !e.params.sizes) return !1;
            if ("instream" === (0, o.Z)(e, "mediaTypes.video.context") && !(0, o.Z)(e, "mediaTypes.video.playerSize")) return !1;
          }

          return !0;
        },
        buildRequests: function buildRequests(e, i) {
          var r = e.map(function (e) {
            var i;
            (0, o.Z)(e, "mediaTypes.video") ? i = "video" : (0, o.Z)(e, "mediaTypes.banner") && (i = "display");

            var r = function (e) {
              if (e.params.ad_unit) return e.params.ad_unit;
              return e.params.placement_id;
            }(e);

            return /^[\/]?[\d]+[[\/].+[\/]?]?$/.test(r) ? (r = "/" === r.charAt(0) ? r : "/" + r, (0, t.Z)({}, "".concat(r, "|").concat(e.bidId), "".concat(b(e), "|").concat(y(e)).concat(g(e)).concat(h(i)))) : /^[0-9a-fA-F]{20}$/.test(r) && 20 === r.length ? (0, t.Z)({}, e.bidId, "".concat(r, "|").concat(b(e), "|").concat(y(e)).concat(g(e)).concat(h(i))) : void (0, a.H)("The ad unit code or Sonobi Placement id for slot ".concat(e.bidId, " is invalid"));
          }),
              n = {};
          r.forEach(function (e) {
            Object.assign(n, e);
          });
          var s = {
            key_maker: JSON.stringify(n),
            ref: i.refererInfo.page,
            s: (0, a.DO)(),
            pv: f,
            vp: S(),
            lib_name: "prebid",
            lib_v: "7.25.0",
            us: 0
          },
              d = i.ortb2;

          if (d && (s.fpd = JSON.stringify(d)), c.vc.getConfig("userSync") && c.vc.getConfig("userSync").syncsPerBidder && (s.us = c.vc.getConfig("userSync").syncsPerBidder), p.k_.canBidderRegisterSync("iframe", l) ? s.ius = 1 : s.ius = 0, (0, o.Z)(e[0], "params.hfa") && (s.hfa = (0, o.Z)(e[0], "params.hfa")), e[0].params.referrer && (s.ref = e[0].params.referrer), i && i.gdprConsent && (s.gdpr = i.gdprConsent.gdprApplies ? "true" : "false", i.gdprConsent.consentString && (s.consent_string = i.gdprConsent.consentString)), e[0].schain && (s.schain = JSON.stringify(e[0].schain)), (0, o.Z)(e[0], "userId") && Object.keys(e[0].userId).length > 0) {
            var u = (0, a.I8)(e[0].userId);
            u.id5id && (u.id5id = (0, o.Z)(u, "id5id.uid")), s.userid = JSON.stringify(u);
          }

          var v = (0, o.Z)(e[0], "userIdAsEids");
          Array.isArray(v) && v.length > 0 && (s.eids = JSON.stringify(v));
          var m = e[0].params.keywords;
          if (m && (s.kw = m), i && i.uspConsent && (s.us_privacy = i.uspConsent), !0 === c.vc.getConfig("coppa") ? s.coppa = 1 : s.coppa = 0, (0, a.xb)(n)) return null;
          var _ = "https://apex.go.sonobi.com/trinity.json";
          return (0, o.Z)(e[0], "params.bid_request_url") && (_ = (0, o.Z)(e[0], "params.bid_request_url")), {
            method: "GET",
            url: _,
            withCredentials: !0,
            data: s,
            bidderRequests: e
          };
        },
        interpretResponse: function interpretResponse(e, i) {
          var r = e.body,
              t = [],
              s = i.data.ref;
          return 0 === Object.keys(r.slots).length || Object.keys(r.slots).forEach(function (e) {
            var d = r.slots[e],
                c = e.split("|").slice(-1)[0],
                p = function (e, i) {
              for (var r = 0; r < e.length; r++) {
                if (e[r].bidId === i) return e[r];
              }
            }(i.bidderRequests, c),
                l = null;

            "video" === d.sbi_ct && (l = "video", "outstream" === (0, o.Z)(p, "mediaTypes.video.context") && (l = "outstream"));

            var f = _(l, s);

            if (d.sbi_aid && d.sbi_mouse && d.sbi_size) {
              var m = d.sbi_size.split("x"),
                  b = (0, n.Z)(m, 2),
                  y = b[0],
                  g = void 0 === y ? 1 : y,
                  h = b[1],
                  Z = void 0 === h ? 1 : h,
                  S = [];
              d.sbi_adomain && (S = [d.sbi_adomain]);
              var C = {
                requestId: c,
                cpm: Number(d.sbi_mouse),
                width: Number(g),
                height: Number(Z),
                ad: f(r.sbi_dc, d.sbi_aid),
                ttl: 500,
                creativeId: d.sbi_crid || d.sbi_aid,
                aid: d.sbi_aid,
                netRevenue: !0,
                currency: "USD",
                meta: {
                  advertiserDomains: S
                }
              };
              if (d.sbi_dozer && (C.dealId = d.sbi_dozer), "video" === l) C.mediaType = "video", C.vastUrl = f(r.sbi_dc, d.sbi_aid), delete C.ad, delete C.width, delete C.height;else if ("outstream" === l && p) {
                delete C.ad, C.mediaType = "video", C.vastUrl = f(r.sbi_dc, d.sbi_aid), C.renderer = function (e, i) {
                  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                      n = u.Th.install({
                    id: i.aid,
                    url: v,
                    config: r,
                    loaded: !1,
                    adUnitCode: e
                  });

                  try {
                    n.setRender(T);
                  } catch (e) {
                    (0, a.yN)("Prebid Error calling setRender on renderer", e);
                  }

                  return n.setEventHandlers({
                    impression: function impression() {
                      return (0, a.ji)("Sonobi outstream video impression event");
                    },
                    loaded: function loaded() {
                      return (0, a.ji)("Sonobi outstream video loaded event");
                    },
                    ended: function ended() {
                      (0, a.ji)("Sonobi outstream renderer video event");
                    }
                  }), n;
                }(p.adUnitCode, C, (0, o.Z)(p, "renderer.options"));
                var j = (0, o.Z)(p, "params.sizes");
                Array.isArray(j) && Array.isArray(j[0]) && (j = j[0]), j && (C.width = j[0], C.height = j[1]);
              }
              t.push(C);
            }
          }), t;
        },
        getUserSyncs: function getUserSyncs(e, i, r, n) {
          var t = [];

          try {
            e.pixelEnabled && i[0].body.sbi_px.forEach(function (e) {
              t.push({
                type: e.type,
                url: e.url
              });
            });
          } catch (e) {}

          return t;
        }
      };

      function b(e) {
        return (0, o.Z)(e, "mediaTypes.video") ? "" : e.params.sizes ? (0, a.sF)(e.params.sizes).join(",") : (0, o.Z)(e, "mediaTypes.banner.sizes") ? (0, a.sF)((0, o.Z)(e, "mediaTypes.banner.sizes")).join(",") : e.sizes ? (0, a.sF)(e.sizes).join(",") : void 0;
      }

      function y(e) {
        var i = function (e) {
          if (!(0, a.LQ)(e.getFloor)) return e.params.floor ? e.params.floor : null;
          var i = e.getFloor({
            currency: "USD",
            mediaType: "*",
            size: "*"
          });
          if ((0, a.PO)(i) && !isNaN(i.floor) && "USD" === i.currency) return i.floor;
          return "";
        }(e);

        return i ? "f=".concat(i, ",") : "";
      }

      function g(e) {
        var i = (0, o.Z)(e, "ortb2Imp.ext.data.pbadslot") || (0, o.Z)((0, a.ky)(e.adUnitCode), "gptSlot") || e.params.ad_unit;
        return i ? "gpid=".concat(i, ",") : "";
      }

      function h(e) {
        var i = "";
        return "video" === e ? i = "c=v," : "display" === e && (i = "c=d,"), i;
      }

      var _ = function _(e, i) {
        return function (r, n) {
          return "video" === e || "outstream" === e ? function (e, i, r) {
            return "https://".concat(e, "apex.go.sonobi.com/vast.xml?vid=").concat(i, "&ref=").concat(encodeURIComponent(r));
          }(r, n, i) : '<script type="text/javascript" src="' + "https://".concat(r, "apex.go.sonobi.com/sbi.js?aid=").concat(n, "&as=null&ref=").concat(encodeURIComponent(i)) + '"><\/script>';
        };
      };

      var Z = function Z() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window;
        return function () {
          var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_SAFE_INTEGER;
          return e.innerWidth >= i && e.innerWidth < r;
        };
      };

      function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window,
            i = Z(e),
            r = 992,
            n = 768;
        return i(0, 768) ? "mobile" : i(n, r) ? "tablet" : "desktop";
      }

      function T(e) {
        e.renderer.push(function () {
          var i = e.getSize().split("x"),
              r = (0, n.Z)(i, 2),
              t = r[0],
              s = r[1],
              a = new window.SbiOutstreamRenderer();
          a.init({
            vastUrl: e.vastUrl,
            height: s,
            width: t
          }), a.setRootElement(e.adUnitCode);
        });
      }

      (0, s.dX)(m), window.pbjs.installedModules.push("sonobiBidAdapter");
    }
  }, function (e) {
    var i;
    i = 1415, e(e.s = i);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[771], {
    61: function _(e, r, t) {
      var n = t(4942),
          i = t(4358),
          o = t(265),
          a = t(6475),
          u = t(5339),
          c = t(4679),
          s = {
        growthCodeId: {
          getValue: function getValue(e) {
            return e.gc_id;
          },
          source: "growthcode.io",
          atype: 1,
          getUidExt: function getUidExt(e) {
            var r = (0, i.ei)(e, ["h1", "h2", "h3"]);
            if (Object.keys(r).length) return r;
          }
        },
        trustpid: {
          source: "trustpid.com",
          atype: 1,
          getValue: function getValue(e) {
            return e;
          }
        },
        intentIqId: {
          source: "intentiq.com",
          atype: 1
        },
        naveggId: {
          source: "navegg.com",
          atype: 1
        },
        justId: {
          source: "justtag.com",
          atype: 1
        },
        pubcid: {
          source: "pubcid.org",
          atype: 1
        },
        tdid: {
          source: "adserver.org",
          atype: 1,
          getUidExt: function getUidExt() {
            return {
              rtiPartner: "TDID"
            };
          }
        },
        id5id: {
          getValue: function getValue(e) {
            return e.uid;
          },
          source: "id5-sync.com",
          atype: 1,
          getUidExt: function getUidExt(e) {
            if (e.ext) return e.ext;
          }
        },
        ftrackId: {
          source: "flashtalking.com",
          atype: 1,
          getValue: function getValue(e) {
            var r = "";
            return e && e.ext && e.ext.DeviceID && (r = e.ext.DeviceID), r;
          },
          getUidExt: function getUidExt(e) {
            return e && e.ext;
          }
        },
        parrableId: {
          source: "parrable.com",
          atype: 1,
          getValue: function getValue(e) {
            return e.eid ? e.eid : e.ccpaOptout ? "" : null;
          },
          getUidExt: function getUidExt(e) {
            var r = (0, i.ei)(e, ["ibaOptout", "ccpaOptout"]);
            if (Object.keys(r).length) return r;
          }
        },
        idl_env: {
          source: "liveramp.com",
          atype: 3
        },
        lipb: {
          getValue: function getValue(e) {
            return e.lipbid;
          },
          source: "liveintent.com",
          atype: 3,
          getEidExt: function getEidExt(e) {
            if (Array.isArray(e.segments) && e.segments.length) return {
              segments: e.segments
            };
          }
        },
        britepoolid: {
          source: "britepool.com",
          atype: 3
        },
        dmdId: {
          source: "hcn.health",
          atype: 3
        },
        lotamePanoramaId: {
          source: "crwdcntrl.net",
          atype: 1
        },
        criteoId: {
          source: "criteo.com",
          atype: 1
        },
        merkleId: {
          atype: 3,
          getSource: function getSource(e) {
            var r;
            return null != e && null !== (r = e.ext) && void 0 !== r && r.ssp ? "".concat(e.ext.ssp, ".merkleinc.com") : "merkleinc.com";
          },
          getValue: function getValue(e) {
            return e.id;
          },
          getUidExt: function getUidExt(e) {
            return e.keyID ? {
              keyID: e.keyID
            } : e.ext ? e.ext : void 0;
          }
        },
        netId: {
          source: "netid.de",
          atype: 1
        },
        IDP: {
          source: "zeotap.com",
          atype: 1
        },
        hadronId: {
          source: "audigent.com",
          atype: 1
        },
        quantcastId: {
          source: "quantcast.com",
          atype: 1
        },
        idx: {
          source: "idx.lat",
          atype: 1
        },
        connectid: {
          source: "verizonmedia.com",
          atype: 3
        },
        fabrickId: {
          source: "neustar.biz",
          atype: 1
        },
        mwOpenLinkId: {
          source: "mediawallahscript.com",
          atype: 1
        },
        tapadId: {
          source: "tapad.com",
          atype: 1
        },
        novatiq: {
          getValue: function getValue(e) {
            return e.snowflake;
          },
          source: "novatiq.com",
          atype: 1
        },
        uid2: {
          source: "uidapi.com",
          atype: 3,
          getValue: function getValue(e) {
            return e.id;
          }
        },
        deepintentId: {
          source: "deepintent.com",
          atype: 3
        },
        admixerId: {
          source: "admixer.net",
          atype: 3
        },
        adtelligentId: {
          source: "adtelligent.com",
          atype: 3
        },
        amxId: {
          source: "amxrtb.com",
          atype: 1
        },
        publinkId: {
          source: "epsilon.com",
          atype: 3
        },
        kpuid: {
          source: "kpuid.com",
          atype: 3
        },
        imppid: {
          source: "ppid.intimatemerger.com",
          atype: 1
        },
        imuid: {
          source: "intimatemerger.com",
          atype: 1
        },
        connectId: {
          source: "yahoo.com",
          atype: 3
        },
        qid: {
          source: "adquery.io",
          atype: 1
        },
        dacId: {
          source: "impact-ad.jp",
          atype: 1
        },
        "33acrossId": {
          source: "33across.com",
          atype: 1,
          getValue: function getValue(e) {
            return e.envelope;
          }
        },
        tncid: {
          source: "thenewco.it",
          atype: 3
        },
        gravitompId: {
          source: "gravito.net",
          atype: 1
        },
        cpexId: {
          source: "czechadid.cz",
          atype: 1
        },
        oneKeyData: {
          getValue: function getValue(e) {
            if (e && Array.isArray(e.identifiers) && e.identifiers[0]) return e.identifiers[0].value;
          },
          source: "paf",
          atype: 1,
          getEidExt: function getEidExt(e) {
            if (e && e.preferences) return {
              preferences: e.preferences
            };
          },
          getUidExt: function getUidExt(e) {
            if (e && Array.isArray(e.identifiers) && e.identifiers[0]) {
              var r = e.identifiers[0];
              return {
                version: r.version,
                type: r.type,
                source: r.source
              };
            }
          }
        }
      };

      function d(e, r) {
        var t = s[r];

        if (t && e) {
          var n = {};
          n.source = (0, i.LQ)(t.getSource) ? t.getSource(e) : t.source;
          var o = (0, i.LQ)(t.getValue) ? t.getValue(e) : e;

          if ((0, i.d8)(o)) {
            var a = {
              id: o,
              atype: t.atype
            };

            if ((0, i.LQ)(t.getUidExt)) {
              var u = t.getUidExt(e);
              u && (a.ext = u);
            }

            if (n.uids = [a], (0, i.LQ)(t.getEidExt)) {
              var c = t.getEidExt(e);
              c && (n.ext = c);
            }

            return n;
          }
        }

        return null;
      }

      function p(e, r) {
        var t = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          r && (n = n.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })), t.push.apply(t, n);
        }

        return t;
      }

      function f(e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = null != arguments[r] ? arguments[r] : {};
          r % 2 ? p(Object(t), !0).forEach(function (r) {
            (0, n.Z)(e, r, t[r]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : p(Object(t)).forEach(function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
          });
        }

        return e;
      }

      var y = {
        mimes: function mimes(e) {
          return Array.isArray(e) && e.length > 0 && e.every(function (e) {
            return "string" == typeof e;
          });
        },
        minduration: function minduration(e) {
          return (0, i.U)(e);
        },
        maxduration: function maxduration(e) {
          return (0, i.U)(e);
        },
        protocols: function protocols(e) {
          return Array.isArray(e) && e.every(function (e) {
            return e >= 1 && e <= 10;
          });
        },
        w: function w(e) {
          return (0, i.U)(e);
        },
        h: function h(e) {
          return (0, i.U)(e);
        },
        startdelay: function startdelay(e) {
          return (0, i.U)(e);
        },
        placement: function placement(e) {
          return (0, i.U)(e) && e >= 1 && e <= 5;
        },
        linearity: function linearity(e) {
          return -1 !== [1, 2].indexOf(e);
        },
        skip: function skip(e) {
          return -1 !== [0, 1].indexOf(e);
        },
        skipmin: function skipmin(e) {
          return (0, i.U)(e);
        },
        skipafter: function skipafter(e) {
          return (0, i.U)(e);
        },
        sequence: function sequence(e) {
          return (0, i.U)(e);
        },
        battr: function battr(e) {
          return Array.isArray(e) && e.every(function (e) {
            return e >= 1 && e <= 17;
          });
        },
        maxextended: function maxextended(e) {
          return (0, i.U)(e);
        },
        minbitrate: function minbitrate(e) {
          return (0, i.U)(e);
        },
        maxbitrate: function maxbitrate(e) {
          return (0, i.U)(e);
        },
        boxingallowed: function boxingallowed(e) {
          return -1 !== [0, 1].indexOf(e);
        },
        playbackmethod: function playbackmethod(e) {
          return Array.isArray(e) && e.every(function (e) {
            return e >= 1 && e <= 6;
          });
        },
        playbackend: function playbackend(e) {
          return -1 !== [1, 2, 3].indexOf(e);
        },
        delivery: function delivery(e) {
          return Array.isArray(e) && e.every(function (e) {
            return e >= 1 && e <= 3;
          });
        },
        pos: function pos(e) {
          return (0, i.U)(e) && e >= 1 && e <= 7;
        },
        api: function api(e) {
          return Array.isArray(e) && e.every(function (e) {
            return e >= 1 && e <= 6;
          });
        }
      },
          l = {
        context: function context(e) {
          return e !== c.Oh;
        },
        mimes: y.mimes,
        minduration: y.minduration,
        maxduration: y.maxduration,
        protocols: y.protocols
      },
          m = {
        code: "sovrn",
        supportedMediaTypes: [c.Mk, c.pX],
        gvlid: 13,
        isBidRequestValid: function isBidRequestValid(e) {
          var r,
              t = null == e || null === (r = e.mediaTypes) || void 0 === r ? void 0 : r.video;
          return !(!e.params.tagid || isNaN(parseFloat(e.params.tagid)) || !isFinite(e.params.tagid) || t && !Object.keys(l).every(function (e) {
            return l[e](t[e]);
          }));
        },
        buildRequests: function buildRequests(e, r) {
          try {
            var t,
                n,
                u,
                c,
                s = [];
            (0, i.yi)(e, function (e) {
              !u && e.userId && (u = function (e) {
                var r = [],
                    t = function t(_t2) {
                  if (e.hasOwnProperty(_t2)) if ("pubProvidedId" === _t2) r = r.concat(e.pubProvidedId);else if (Array.isArray(e[_t2])) e[_t2].forEach(function (e, n, i) {
                    var o = d(e, _t2);
                    o && r.push(o);
                  });else {
                    var n = d(e[_t2], _t2);
                    n && r.push(n);
                  }
                };

                for (var n in e) {
                  t(n);
                }

                return r;
              }(e.userId)).forEach(function (e) {
                e.uids && e.uids[0] && "criteo.com" === e.source && (c = e.uids[0].id);
              }), e.schain && (n = n || e.schain), t = t || (0, i.An)("iv", e.params);
              var r = e.getFloor && "function" == typeof e.getFloor ? e.getFloor({
                currency: "USD",
                mediaType: e.mediaTypes && e.mediaTypes.banner ? "banner" : "video",
                size: "*"
              }) : {};
              r.floor = r.floor || (0, i.An)("bidfloor", e.params);
              var a = {
                adunitcode: e.adUnitCode,
                id: e.bidId,
                tagid: String((0, i.An)("tagid", e.params)),
                bidfloor: r.floor
              };

              if ((0, o.Z)(e, "mediaTypes.banner")) {
                var p = (0, o.Z)(e, "mediaTypes.banner.sizes") || e.sizes,
                    l = (p = (p = (0, i.kJ)(p) && (0, i.kJ)(p[0]) ? p : [p]).filter(function (e) {
                  return (0, i.kJ)(e);
                })).map(function (e) {
                  return {
                    w: parseInt(e[0], 10),
                    h: parseInt(e[1], 10)
                  };
                });
                a.banner = {
                  format: l,
                  w: 1,
                  h: 1
                };
              }

              (0, o.Z)(e, "mediaTypes.video") && (a.video = function (e) {
                var r = {},
                    t = (0, o.Z)(e, "sizes"),
                    n = (0, o.Z)(e, "mediaTypes.video", {}),
                    a = (0, o.Z)(e, "params.video", {}),
                    u = {};

                if (t) {
                  var c = Array.isArray(t[0]) ? t[0] : t;
                  u.w = c[0], u.h = c[1];
                } else if (Array.isArray(n.playerSize)) {
                  var s = Array.isArray(n.playerSize[0]) ? n.playerSize[0] : n.playerSize;
                  u.w = s[0], u.h = s[1];
                }

                var d = f(f(f({}, u), n), a);
                return Object.keys(y).forEach(function (e) {
                  d.hasOwnProperty(e) && (y[e](d[e]) ? r[e] = d[e] : (0, i.yN)("The OpenRTB video param ".concat(e, " has been skipped due to misformating. Please refer to OpenRTB 2.5 spec.")));
                }), r;
              }(e)), a.ext = (0, i.An)("ext", e.ortb2Imp) || void 0;
              var m = (0, i.An)("segments", e.params);
              m && (a.ext = a.ext || {}, a.ext.deals = m.split(",").map(function (e) {
                return e.trim();
              })), s.push(a);
            });
            var p = r.ortb2 || {},
                l = p.site || {};
            l.page = r.refererInfo.page, l.domain = r.refererInfo.domain;
            var m = {
              id: (0, i._d)(),
              imp: s,
              site: l,
              user: p.user || {}
            };
            n && (m.source = {
              ext: {
                schain: n
              }
            }), r.gdprConsent && ((0, a.N)(m, "regs.ext.gdpr", +r.gdprConsent.gdprApplies), (0, a.N)(m, "user.ext.consent", r.gdprConsent.consentString)), r.uspConsent && (0, a.N)(m, "regs.ext.us_privacy", r.uspConsent), u && ((0, a.N)(m, "user.ext.eids", u), c && (0, a.N)(m, "user.ext.prebid_criteoid", c));
            var g = "https://ap.lijit.com/rtb/bid?src=prebid_prebid_7.25.0";
            return t && (g += "&iv=".concat(t)), {
              method: "POST",
              url: g,
              data: JSON.stringify(m),
              options: {
                contentType: "text/plain"
              }
            };
          } catch (e) {
            (0, i.H)("Could not build bidrequest, error deatils:", e);
          }
        },
        interpretResponse: function interpretResponse(e) {
          var r = e.body,
              t = r.id,
              n = r.seatbid;
          if (!t || !n || !Array.isArray(n)) return [];

          try {
            return n.filter(function (e) {
              return e;
            }).map(function (e) {
              return e.bid.map(function (e) {
                var r,
                    t = {
                  requestId: e.impid,
                  cpm: parseFloat(e.price),
                  width: parseInt(e.w),
                  height: parseInt(e.h),
                  creativeId: e.crid || e.id,
                  dealId: e.dealid || null,
                  currency: "USD",
                  netRevenue: !0,
                  mediaType: e.nurl ? c.Mk : c.pX,
                  ttl: (null === (r = e.ext) || void 0 === r ? void 0 : r.ttl) || 90,
                  meta: {
                    advertiserDomains: e && e.adomain ? e.adomain : []
                  }
                };
                return e.nurl ? t.ad = decodeURIComponent("".concat(e.adm, '<img src="').concat(e.nurl, '">')) : t.vastXml = decodeURIComponent(e.adm), t;
              });
            }).flat();
          } catch (e) {
            return (0, i.H)("Could not interpret bidresponse, error details:", e), e;
          }
        },
        getUserSyncs: function getUserSyncs(e, r, t, n) {
          try {
            var i = [];

            if (r && 0 !== r.length) {
              if (e.iframeEnabled) {
                var a = r.filter(function (e) {
                  return (0, o.Z)(e, "body.ext.iid");
                }).map(function (e) {
                  return e.body.ext.iid;
                }),
                    u = [];
                t && t.gdprApplies && "string" == typeof t.consentString && u.push(["gdpr_consent", t.consentString]), n && u.push(["us_privacy", n]), a[0] && (u.push(["informer", a[0]]), i.push({
                  type: "iframe",
                  url: "https://ap.lijit.com/beacon?" + u.map(function (e) {
                    return e.join("=");
                  }).join("&")
                }));
              }

              e.pixelEnabled && r.filter(function (e) {
                return (0, o.Z)(e, "body.ext.sync.pixels");
              }).reduce(function (e, r) {
                return e.concat(r.body.ext.sync.pixels);
              }, []).map(function (e) {
                return e.url;
              }).forEach(function (e) {
                return i.push({
                  type: "image",
                  url: e
                });
              });
            }

            return i;
          } catch (e) {
            return [];
          }
        }
      };
      (0, u.dX)(m), window.pbjs.installedModules.push("sovrnBidAdapter");
    }
  }, function (e) {
    var r;
    r = 61, e(e.s = r);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[599], {
    789: function _(e, t, r) {
      var n = r(1002),
          i = r(4942),
          o = r(9062),
          a = r(4358),
          u = r(4679),
          c = r(5339),
          d = r(3193),
          s = r(5164);

      function p(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function l(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? p(Object(r), !0).forEach(function (t) {
            (0, i.Z)(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : p(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }

      var f = "triplelift",
          m = !0,
          v = null,
          b = (0, s.df)({
        gvlid: 28,
        bidderCode: f
      }),
          g = {
        gvlid: 28,
        code: f,
        supportedMediaTypes: [u.Mk, u.pX],
        isBidRequestValid: function isBidRequestValid(e) {
          return void 0 !== e.params.inventoryCode;
        },
        buildRequests: function buildRequests(e, t) {
          var r = "https://tlx.3lift.com/header/auction?",
              n = function (e, t) {
            var r = {},
                n = e[0].schain,
                i = function (e) {
              var t = {},
                  r = {},
                  n = {},
                  i = e.ortb2 || {},
                  o = function () {
                var e = b.getDataFromLocalStorage("opecloud_ctx");
                if (!e) return null;

                try {
                  return JSON.parse(e);
                } catch (e) {
                  return (0, a.H)("Triplelift: error parsing JSON: ", e), null;
                }
              }(),
                  u = Object.assign({}, i.site),
                  c = Object.assign({}, i.user);

              if (o) {
                c.data = c.data || [];

                try {
                  c.data.push({
                    name: "www.1plusx.com",
                    ext: o
                  });
                } catch (e) {
                  (0, a.H)("Triplelift: error adding 1plusX segments: ", e);
                }
              }

              j(r, u), j(n, c), (0, a.xb)(r) || (t.context = r);
              (0, a.xb)(n) || (t.user = n);
              return t;
            }(t);

            r.imp = e.map(function (e, t) {
              var r = {
                id: t,
                tagid: e.params.inventoryCode,
                floor: O(e)
              };
              return y(e) && (r.video = function (e) {
                var t = l(l({}, e.params.video), e.mediaTypes.video);

                try {
                  t.w || (t.w = t.playerSize[0][0]), t.h || (t.h = t.playerSize[0][1]);
                } catch (e) {
                  (0, a.yN)("Video size not defined", e);
                }

                "instream" === t.context && (t.placement = 1);
                "outstream" === t.context && (t.placement ? -1 === [3, 4, 5].indexOf(t.placement) && ((0, a.ji)("video.placement value of ".concat(t.placement, " is invalid for outstream context. Setting placement to 3")), t.placement = 3) : t.placement = 3);
                return delete t.playerSize, t;
              }(e)), e.mediaTypes.banner && !h(e) && (r.banner = {
                format: I(e.sizes)
              }), (0, a.xb)(e.ortb2Imp) || (r.fpd = function (e) {
                var t = {},
                    r = {};
                j(r, e.ext), (0, a.xb)(r) || (t.context = r);
                return t;
              }(e.ortb2Imp)), r;
            });
            var u = [].concat((0, o.Z)((c = [e[0]], w(c, "tdid", "adserver.org", "TDID"))), (0, o.Z)(function (e) {
              return w(e, "idl_env", "liveramp.com", "idl");
            }([e[0]])), (0, o.Z)(function (e) {
              return w(e, "criteoId", "criteo.com", "criteoId");
            }([e[0]])), (0, o.Z)(function (e) {
              return w(e, "pubcid", "pubcid.org", "pubcid");
            }([e[0]])), (0, o.Z)(function (e) {
              var t = ["adserver.org", "liveramp.com", "criteo.com", "pubcid.org"],
                  r = [];
              e.userIdAsEids && e.userIdAsEids.forEach(function (e) {
                try {
                  if (-1 === t.indexOf(e.source)) {
                    var n = e.uids.map(function (t) {
                      return {
                        id: t.id,
                        ext: {
                          rtiPartner: e.source
                        }
                      };
                    });
                    r.push({
                      source: e.source,
                      uids: n
                    });
                  }
                } catch (t) {
                  (0, a.yN)("Triplelift: Error attempting to add ".concat(e, " to bid request"), t);
                }
              });
              return r;
            }(e[0])));
            var c;
            u.length > 0 && (r.user = {
              ext: {
                eids: u
              }
            });

            var d = function (e, t) {
              var r = {};
              (0, a.xb)(e) || (r.schain = l({}, e));
              (0, a.xb)(t) || (r.fpd = l({}, t));
              return r;
            }(n, i);

            (0, a.xb)(d) || (r.ext = d);
            return r;
          }(e, t);

          if (r = (0, a.t0)(r, "lib", "prebid"), r = (0, a.t0)(r, "v", "7.25.0"), t && t.refererInfo) {
            var i,
                u,
                c = (null == t || null === (i = t.refererInfo) || void 0 === i ? void 0 : i.topmostLocation) || (null == t || null === (u = t.refererInfo) || void 0 === u ? void 0 : u.page);
            r = (0, a.t0)(r, "referrer", c);
          }

          return t && t.timeout && (r = (0, a.t0)(r, "tmax", t.timeout)), t && t.gdprConsent && (void 0 !== t.gdprConsent.gdprApplies && (m = t.gdprConsent.gdprApplies, r = (0, a.t0)(r, "gdpr", m.toString())), void 0 !== t.gdprConsent.consentString && (v = t.gdprConsent.consentString, r = (0, a.t0)(r, "cmp_cs", v))), t && t.uspConsent && (r = (0, a.t0)(r, "us_privacy", t.uspConsent)), !0 === d.vc.getConfig("coppa") && (r = (0, a.t0)(r, "coppa", !0)), r.lastIndexOf("&") === r.length - 1 && (r = r.substring(0, r.length - 1)), (0, a.ji)("tlCall request built: " + r), {
            method: "POST",
            url: r,
            data: n,
            bidderRequest: t
          };
        },
        interpretResponse: function interpretResponse(e, t) {
          var r = t.bidderRequest;
          return (e.body.bids || []).map(function (e) {
            return function (e, t) {
              var r = {},
                  n = t.width || 1,
                  i = t.height || 1,
                  o = t.deal_id || "",
                  a = t.crid || "",
                  u = e.bids[t.imp_id];
              0 != t.cpm && t.ad && (r = {
                requestId: u.bidId,
                cpm: t.cpm,
                width: n,
                height: i,
                netRevenue: !0,
                ad: t.ad,
                creativeId: a,
                dealId: o,
                currency: "USD",
                ttl: 300,
                tl_source: t.tl_source,
                meta: {}
              }, y(u) && "video" === t.media_type && (r.vastXml = t.ad, r.mediaType = "video", r.ttl = 3600), t.advertiser_name && (r.meta.advertiserName = t.advertiser_name), t.adomain && t.adomain.length && (r.meta.advertiserDomains = t.adomain), t.tl_source && "hdx" == t.tl_source && (y(u) && "video" === t.media_type ? r.meta.mediaType = "video" : r.meta.mediaType = "banner"), t.tl_source && "tlx" == t.tl_source && (r.meta.mediaType = "native"));
              return r;
            }(r, e);
          });
        },
        getUserSyncs: function getUserSyncs(e, t, r, n) {
          var i = function (e) {
            if (!e) return;
            if (e.iframeEnabled) return "iframe";
            if (e.pixelEnabled) return "image";
          }(e);

          if (i) {
            var o = "https://eb2.3lift.com/sync?";
            return "image" === i && (o = (0, a.t0)(o, "px", 1), o = (0, a.t0)(o, "src", "prebid")), null !== v && (o = (0, a.t0)(o, "gdpr", m), o = (0, a.t0)(o, "cmp_cs", v)), n && (o = (0, a.t0)(o, "us_privacy", n)), [{
              type: i,
              url: o
            }];
          }
        }
      };

      function y(e) {
        return x(e) && (h(e) || function (e) {
          return x(e) && "outstream" === e.mediaTypes.video.context.toLowerCase();
        }(e));
      }

      function h(e) {
        return x(e) && "instream" === e.mediaTypes.video.context.toLowerCase();
      }

      function x(e) {
        return e.mediaTypes.video && e.mediaTypes.video.context;
      }

      function O(e) {
        var t = null;
        if ("function" == typeof e.getFloor) try {
          var r = e.getFloor({
            currency: "USD",
            mediaType: y(e) ? "video" : "banner",
            size: "*"
          });
          "object" !== (0, n.Z)(r) || "USD" !== r.currency || isNaN(parseFloat(r.floor)) || (t = parseFloat(r.floor));
        } catch (e) {
          (0, a.H)("Triplelift: getFloor threw an error: ", e);
        }
        return null !== t ? t : e.params.floor;
      }

      function j(e, t) {
        (0, a.xb)(t) || Object.keys(t).forEach(function (r) {
          null != t[r] && (e[r] = t[r]);
        });
      }

      function w(e, t, r, n) {
        return e.map(function (e) {
          return function (t) {
            return t && t.userId && t.userId[e];
          };
        }(t)).filter(T(t)).map(function (e, t) {
          return function (r) {
            return {
              source: e,
              uids: [{
                id: r.id ? r.id : r,
                ext: {
                  rtiPartner: t
                }
              }]
            };
          };
        }(r, n));
      }

      var T = function T(e) {
        return function (t, r, n) {
          var i = !!t && ((0, a.d8)(t) ? !!t : (0, a.PO)(t) && !(0, a.kJ)(t) && !(0, a.xb)(t) && t.id && (0, a.d8)(t.id) && !!t.id);
          return i || void 0 === n[0] || (0, a.yN)("Triplelift: invalid ".concat(e, " userId format")), i;
        };
      };

      function I(e) {
        return e.filter(_).map(function (e) {
          return {
            w: e[0],
            h: e[1]
          };
        });
      }

      function _(e) {
        return 2 === e.length && "number" == typeof e[0] && "number" == typeof e[1];
      }

      (0, c.dX)(g), window.pbjs.installedModules.push("tripleliftBidAdapter");
    }
  }, function (e) {
    var t;
    t = 789, e(e.s = t);
  }]);
  (self.pbjsChunk = self.pbjsChunk || []).push([[39], {
    1004: function _(e, r, n) {
      var t = n(4942);

      function i(e, r) {
        if (null == e) return {};

        var n,
            t,
            i = function (e, r) {
          if (null == e) return {};
          var n,
              t,
              i = {},
              o = Object.keys(e);

          for (t = 0; t < o.length; t++) {
            n = o[t], r.indexOf(n) >= 0 || (i[n] = e[n]);
          }

          return i;
        }(e, r);

        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);

          for (t = 0; t < o.length; t++) {
            n = o[t], r.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
          }
        }

        return i;
      }

      var o = n(265),
          a = n(4358),
          d = n(5706),
          u = n(5339),
          s = n(4679),
          p = ["bids", "bidderRequestId", "auctionId", "bidderCode"];

      function c(e, r) {
        var n = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var t = Object.getOwnPropertySymbols(e);
          r && (t = t.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })), n.push.apply(n, t);
        }

        return n;
      }

      function f(e) {
        for (var r = 1; r < arguments.length; r++) {
          var n = null != arguments[r] ? arguments[r] : {};
          r % 2 ? c(Object(n), !0).forEach(function (r) {
            (0, t.Z)(e, r, n[r]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
          });
        }

        return e;
      }

      var l = function l(e, r, n) {
        n.bids, n.bidderRequestId, n.auctionId, n.bidderCode;
        var t = i(n, p),
            a = n.bids.length - r.length,
            d = {};
        r.forEach(function (e) {
          var r = e.params.siteId;
          !function (e) {
            Object.keys(e.mediaTypes).forEach(function (r) {
              var n;
              n = "function" == typeof e.getFloor ? e.getFloor({
                currency: "USD",
                mediaType: r,
                size: "*"
              }).floor || 0 : e.params.floor || 0, e.mediaTypes[r].floor = n;
            });
          }(e), function (e) {
            var r = (0, o.Z)(e, "mediaTypes.banner");

            if (r) {
              var n = {},
                  t = [];
              r.sizes.forEach(function (e) {
                n[e.toString()] || (n[e.toString()] = !0, t.push(e));
              }), r.sizes = t;
            }
          }(e), d[r] = d[r] || [], d[r].push(e);
        });
        var u = [];
        return Object.keys(d).forEach(function (r) {
          var n = {
            bidderRequest: Object.assign({}, f({
              bids: d[r],
              invalidBidsCount: a
            }, t))
          };
          u.push(Object.assign({}, f({
            data: n
          }, e)));
        }), u;
      },
          y = function y(e) {
        if (e.ad) return e;
        (0, a.H)(new Error("UnrulyBidAdapter: Missing ad config."));
      },
          b = function b(e) {
        if (e.vastUrl || e.vastXml) return e;
        (0, a.H)(new Error("UnrulyBidAdapter: Missing vastUrl or vastXml config."));
      },
          v = function v(e) {
        var r = !!(0, o.Z)(e, "ext.renderer.config"),
            n = !!(0, o.Z)(e, "ext.renderer.config.siteId");

        if (r) {
          if (n) {
            var t = (0, o.Z)(e, "ext.renderer");
            !function (e, r) {
              if (!e.config) throw new Error("UnrulyBidAdapter: Missing renderer config.");
              if (!e.config.siteId) throw new Error("UnrulyBidAdapter: Missing renderer siteId.");
              parent.window.unruly = parent.window.unruly || {}, parent.window.unruly.native = parent.window.unruly.native || {}, parent.window.unruly.native.siteId = parent.window.unruly.native.siteId || e.config.siteId, parent.window.unruly.native.adSlotId = r, parent.window.unruly.native.supplyMode = "prebid";
            }(t, e.requestId), parent.window.unruly.native.prebid = parent.window.unruly.native.prebid || {}, parent.window.unruly.native.prebid.uq = parent.window.unruly.native.prebid.uq || [];
            var i = d.Th.install(Object.assign({}, t)),
                u = Object.assign({}, e, {
              renderer: i,
              adUnitCode: (0, o.Z)(e, "ext.adUnitCode")
            });
            return i.setRender(function () {
              var e;
              e = u, parent.window.unruly.native.prebid.uq.push(["render", e]);
            }), e.renderer = e.renderer || i, e;
          }

          (0, a.H)(new Error("UnrulyBidAdapter: Missing renderer siteId."));
        } else (0, a.H)(new Error("UnrulyBidAdapter: Missing renderer config."));
      },
          w = function w(e) {
        if (!e.context) return !1;
        return -1 !== ["outstream", "instream"].indexOf(e.context);
      },
          g = function g(e) {
        return e.sizes;
      },
          O = {
        code: "unruly",
        supportedMediaTypes: [s.pX, s.Mk],
        gvlid: 36,
        isBidRequestValid: function isBidRequestValid(e) {
          var r = (0, o.Z)(e, "params.siteId") && function (e) {
            var r = (0, o.Z)(e, "mediaTypes.video"),
                n = (0, o.Z)(e, "mediaTypes.banner"),
                t = !(!r && !n);
            return t && r && (t = w(r)), t && n && (t = g(n)), t;
          }(e);

          return !!r;
        },
        buildRequests: function buildRequests(e, r) {
          var n = "https://targeting.unrulymedia.com/unruly_prebid";
          e[0] && (n = (0, o.Z)(e[0], "params.endpoint") || n);
          return l({
            url: n,
            method: "POST",
            options: {
              contentType: "application/json"
            }
          }, e, r);
        },
        interpretResponse: function interpretResponse() {
          var e,
              r,
              n = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).body;
          return !n || !n.bids ? [] : (e = n.bids, r = [], e.forEach(function (e) {
            var n,
                t = (0, o.Z)(e, "meta.mediaType");
            if (t && "banner" === t.toLowerCase()) e.mediaType = s.Mk, n = y(e);else if (t && "video" === t.toLowerCase()) {
              var i = (0, o.Z)(e, "meta.videoContext");
              e.mediaType = s.pX, "instream" === i ? n = b(e) : "outstream" === i && (n = v(e));
            }
            n && r.push(n);
          }), r);
        }
      };

      (0, u.dX)(O), window.pbjs.installedModules.push("unrulyBidAdapter");
    }
  }, function (e) {
    var r;
    r = 1004, e(e.s = r);
  }]);
})(), pbjs.processQueue();